'use strict';

import { environment } from "src/environment/environment";
import { HospitalBaseURL, HospitalUserAffiliationURL } from "./GlobalVariable/Hospital.GlobalVariable";
import { Export, string } from "@amcharts/amcharts4/core";

export const BaseURL: string = environment.apiURL;
export const PayLaterURL: string = environment.plApiURL;
export const SocietyMasterURL: string = environment.smApiURL;
export const SchoolMasterUrl: string = environment.speApiURL;

export const MasterBaseURL: string = BaseURL + '/M';
export const SocietyBaseURL: string = SocietyMasterURL + '/SOC';
export const PayLaterBaseURL: string = PayLaterURL + '/PL';
export const SchoolBaseURL: string = SchoolMasterUrl + '/SCL';
// export const HospitalExpenseURL: string = HospitalBaseURL + '/HEM';
export const RealEstateBaseURL: string = BaseURL + '/RE';
export const NotificationBaseURL: string = BaseURL + '/NT'
export const AIBaseURL: string = BaseURL + '/AI/OA';

// //#region BBPS API
// export const BBPSBaseURL: string = BaseURL.replace("dev.","") + '/BBPS';
// export const billerURL: string = BBPSBaseURL + '/REH';
// export const BBPS_GetMobileOperator: string =billerURL + '/GetMobileOperator';
// export const BBPS_GetBillerOperators: string =billerURL + '/GetOperators';
// export const BBPS_GetPrepaidPlane: string =billerURL + '/GetPrepaidPlane';

// export const CCBaseURL: string = BaseURL.replace("dev.","") + '/CC';
// export const CC_GetOperatorList: string =billerURL + '/GetOperators';

//#region BBPS API


export const BBPSBaseURL: string = BaseURL.replace("dev.", "") + "/BBPS";
export const billerURL: string = BBPSBaseURL + "/REH";
export const BBPS_GetMobileOperator: string = billerURL + "/GetMobileOperator";
export const BBPS_GetBillerOperators: string = billerURL + "/GetOperators";
export const BBPS_GetPrepaidPlan: string = billerURL + "/GetPrepaidPlan";
export const BBPS_GetPrepaidPlanByName: string = billerURL + "/GetPrepaidPlanByName";

/**
 * Biller payment gateway routes.
 */
export const BBPSBillerURL: string = BBPSBaseURL + "/BLR";
export const BBPS_Biller_GetOperators: string = BBPSBillerURL + "/GetOperators";
export const BBPS_Biller_FetchBill: string = BBPSBillerURL + "/FetchBill";
export const BBPS_Biller_PayBill: string = BBPSBillerURL + "/PayBill";
export const BBPS_Biller_CheckStatus: string = BBPSBillerURL + "/CheckStatus";

/**
 * Credit-card payment gateway routes.
 */
export const BBPSCreditCardURL: string = BBPSBaseURL + "/CC";
export const BBPS_CreditCard_GetOperatorList: string = BBPSCreditCardURL + "/GetOperatorList";
export const BBPS_CreditCard_GetBill: string = BBPSCreditCardURL + "/GetBill";
export const BBPS_CreditCard_PayBill: string = BBPSCreditCardURL + "/PayBill";
export const BBPS_CreditCard_CheckStatus: string = BBPSCreditCardURL + "/CheckStatus";

export const BBPS_InitiateRecharge: string = BBPSBaseURL + "/REH/InitiateRecharge";

export const BBPSBillFetchRequestURL: string = BaseURL + "/BBPS/BFR";
export const BBPS_AccountHistory: string = BBPSBillFetchRequestURL + "/AccountHistory";



/**
 * BBPS support-ticket routes.
 */
export const BBPSSupportTicketURL: string = BBPSBaseURL + "/ST";
export const BBPS_SupportTicket_Create: string = BBPSSupportTicketURL + "/Create";
export const BBPS_SupportTicket_Update: string = BBPSSupportTicketURL + "/Update";
export const BBPS_SupportTicket_Delete: string = BBPSSupportTicketURL + "/Delete";
export const BBPS_SupportTicket_ReadAll: string = BBPSSupportTicketURL + "/ReadAll";
export const BBPS_SupportTicket_ReadById: string = BBPSSupportTicketURL + "/ReadById";
export const BBPS_SupportTicket_ReadByTicketNo: string = BBPSSupportTicketURL + "/ReadByTicketNo";
export const BBPS_SupportTicket_ReadByUserId: string = BBPSSupportTicketURL + "/ReadByUserId";
export const BBPS_SupportTicket_ReadByAssignedTo: string = BBPSSupportTicketURL + "/ReadByAssignedTo";
export const BBPS_SupportTicket_ReadAllPaginated: string = BBPSSupportTicketURL + "/ReadAllPaginated";

//#endregion

//#region QuestionPaperMaster API
export const QuestionPaperMasterURL: string = SchoolBaseURL + "/QPM";
export const QuestionPaperMaster_Create: string = QuestionPaperMasterURL + "/Create";
export const QuestionPaperMaster_Update: string = QuestionPaperMasterURL + "/Update";
export const QuestionPaperMaster_Delete: string = QuestionPaperMasterURL + "/Delete";
export const QuestionPaperMaster_ReadBySchoolId: string = QuestionPaperMasterURL + "/ReadBySchoolId";
export const QuestionPaperMaster_ReadByClassId: string = QuestionPaperMasterURL + "/ReadByClassId";
export const QuestionPaperMaster_ReadBySubjectId: string = QuestionPaperMasterURL + "/ReadBySubjectId";
// export const QuestionPaperMaster_ReadByPaperGroupId: string = QuestionPaperMasterURL + "/ReadByPaperGroupId";
//#endregion


//#endregion BBPS API

export const UserLoginURL: string = MasterBaseURL + '/UL';
export const UserLogin_Create: string = UserLoginURL + '/Create';
export const UserLogin_Update: string = UserLoginURL + '/Update';
export const UserLogin_ReadByUserId: string = UserLoginURL + '/ReadByUserId';
export const UserLogin_Delete: string = UserLoginURL + '/Delete';
export const UserLogin_ValidateUserName: string = UserLoginURL + '/ValidateUserName';
export const UserLogin_Auth: string = UserLoginURL + '/auth';
export const UserLogin_AzureAuth: string = UserLoginURL + '/AzureAuth';
export const UserLogin_ValidateToken: string = UserLoginURL + '/ValidateToken';
export const UserLogin_GenerateOtp: string = UserLoginURL + '/GenerateOtp';
export const UserLogin_ValidateOtp: string = UserLoginURL + '/ValidateOtp';
export const UserLogin_ValidatePassword: string = UserLoginURL + '/ValidatePassword';
export const UserLogin_GenerateMobileOtp: string = UserLoginURL + '/GenerateMobileOtp';
export const UserLogin_ValidateMobileOtp: string = UserLoginURL + '/ValidateMobileOtp';
//#endRegion

//#region ImageMaster API
export const ImageMasterURL: string = MasterBaseURL + '/IM';
export const ImageMaster_Upload: string = ImageMasterURL + '/Upload'
export const ImageMaster_ExternalUpload: string = ImageMasterURL + '/Upload_External'
//#endRegion 

//#region DocumentVerificationSession API
// export const DocumentVerificationSessionURL: string = MasterBaseURL + '/DVS';
// export const DocumentVerificationSession_Create: string = DocumentVerificationSessionURL + '/Create';
// export const DocumentVerificationSession_Update: string = DocumentVerificationSessionURL + '/Update';
// export const DocumentVerificationSession_Delete: string = DocumentVerificationSessionURL + '/Delete';
// export const DocumentVerificationSession_ExternalDelete: string = DocumentVerificationSessionURL + '/Delete_External';
// export const DocumentVerificationSession_ReadAll: string = DocumentVerificationSessionURL + '/ReadAll';
// export const DocumentVerificationSession_ReadById: string = DocumentVerificationSessionURL + '/ReadById';
// export const DocumentVerificationSession_ExternalReadById: string = DocumentVerificationSessionURL + '/ReadById_External';
// export const DocumentVerificationSession_ReadByMasterId: string = DocumentVerificationSessionURL + '/ReadByMasterId';
//#endRegion

//#region DocumentVerificationSession API
export const DocumentVerificationSessionURL: string = MasterBaseURL + '/DVS';

export const DocumentVerificationSession_Create: string =
  DocumentVerificationSessionURL + '/Create';

export const DocumentVerificationSession_Update: string =
  DocumentVerificationSessionURL + '/Update';

export const DocumentVerificationSession_Delete: string =
  DocumentVerificationSessionURL + '/Delete';

/*
 * Legacy external numeric endpoint.
 *
 * Kept temporarily so the current working document-upload flow does not break.
 * Remove only after SchoolDocVerificationComponent, backend and Ocelot are
 * completely migrated to the token-based endpoints below.
 */
export const DocumentVerificationSession_ExternalDelete: string =
  DocumentVerificationSessionURL + '/Delete_External';

export const DocumentVerificationSession_ReadAll: string =
  DocumentVerificationSessionURL + '/ReadAll';

export const DocumentVerificationSession_ReadById: string =
  DocumentVerificationSessionURL + '/ReadById';

/*
 * Legacy external numeric endpoint.
 *
 * Kept temporarily for backward compatibility during the migration.
 */
export const DocumentVerificationSession_ExternalReadById: string =
  DocumentVerificationSessionURL + '/ReadById_External';

export const DocumentVerificationSession_ReadByMasterId: string =
  DocumentVerificationSessionURL + '/ReadByMasterId';

/*
 * P0-07 token-based public endpoints.
 *
 * The public browser sends only the opaque token.
 * The backend resolves sessionId, masterId and schoolId internally.
 */
export const DocumentVerificationSession_ResolvePublic: string =
  DocumentVerificationSessionURL + '/ResolvePublic';

export const DocumentVerificationSession_UploadPublic: string =
  DocumentVerificationSessionURL + '/UploadPublic';

export const DocumentVerificationSession_CompletePublic: string =
  DocumentVerificationSessionURL + '/CompletePublic';

//#endregion


//#region ServiceAvailability API

export const ServiceAvailabilityURL: string = MasterBaseURL + '/SA';
export const ServiceAvailability_Update: string = ServiceAvailabilityURL + '/Update';
export const ServiceAvailability_ReadAllPaginated: string = ServiceAvailabilityURL + '/ReadAllPaginated';

//#endregion


//#region ERPntityMapping API
export const ERPEntityMappingURL: string = MasterBaseURL + '/EEM';
export const ERPEntityMapping_Create: string = ERPEntityMappingURL + '/Create';
export const ERPEntityMapping_Update: string = ERPEntityMappingURL + '/Update';
export const ERPEntityMapping_Delete: string = ERPEntityMappingURL + '/Delete';
export const ERPEntityMapping_ReadAll: string = ERPEntityMappingURL + '/ReadAll';
export const ERPEntityMapping_ReadById: string = ERPEntityMappingURL + '/ReadById';
export const ERPEntityMapping_ReadByMasterId: string = ERPEntityMappingURL + '/ReadByMasterId';
export const ERPEntityMapping_ExternalReadByMasterId: string = ERPEntityMappingURL + '/ReadByMasterId_External';
export const ERPEntityMapping_CreateBulk: string = ERPEntityMappingURL + '/CreateBulk';
export const ERPEntityMapping_Onboarding: string = ERPEntityMappingURL + '/Onboarding';
export const ERPEntityMapping_UserMasterOnboarding: string = ERPEntityMappingURL + '/UserMasterOnbording';
export const ERPEntityMapping_UserMasterDelete: string = ERPEntityMappingURL + '/UserMasterDelete';
export const ERPEntityMapping_CreateSupportTickets: string = ERPEntityMappingURL + '/CreateSupportTickets';
export const ERPEntityMapping_CreateValueListItem: string = ERPEntityMappingURL + '/CreateValueListItem';
export const ERPEntityMapping_CreateLeadMaster: string = ERPEntityMappingURL + '/CreateLeadMaster';
export const ERPEntityMapping_CreateTicketActivity: string = ERPEntityMappingURL + '/CreateTicketActivity';
//#endRegion

//#region Biller Category API
export const BillerCategoryURL: string = BBPSBaseURL + '/BC';
export const BillerCategory_Create: string = BillerCategoryURL + '/Create';
export const BillerCategory_Update: string = BillerCategoryURL + '/Update';
export const BillerCategory_ReadById: string = BillerCategoryURL + '/ReadById';
export const BillerCategory_Delete: string = BillerCategoryURL + '/Delete';
export const BillerCategory_ReadAll = BillerCategoryURL + '/ReadAll';
//#endregion

//region UserPermission API
const UserPermissionURL: string = MasterBaseURL + '/UP';
export const UserPermission_create = UserPermissionURL + '/Create';
export const UserPermission_update = UserPermissionURL + '/Update';
export const UserPermission_readAll = UserPermissionURL + '/ReadAll';
export const UserPermission_readByFeatureId = UserPermissionURL + '/ReadByFeatureId';
export const UserPermission_readById = UserPermissionURL + '/ReadById';
export const UserPermission_readByUserId = UserPermissionURL + '/ReadByUserId';
export const UserPermission_readBySubRoleId = UserPermissionURL + '/ReadBySubRoleId';
export const UserPermission_delete = UserPermissionURL + '/Delete';
export const UserPermission_generateSignature = UserPermissionURL + '/generate';
//endregion

//#region SubRoles API
export const SubRolesURL: string = MasterBaseURL + '/SR';
export const SubRoles_create = SubRolesURL + '/Create';
export const SubRoles_update = SubRolesURL + '/Update';
export const SubRoles_readByUserId = SubRolesURL + '/ReadByUserId';
export const SubRoles_readByProjectId = SubRolesURL + '/ReadByProjectId';
export const SubRoles_readById = SubRolesURL + '/ReadById';
export const SubRoles_updateIsDefault = SubRolesURL + '/UpdateIsDefault';
export const SubRoles_delete = SubRolesURL + '/Delete';
export const SubRoles_readByRoleId = SubRolesURL + '/ReadByRoleId';
//#endregion

//#region Product API
export const ProductURL: string = PayLaterBaseURL + '/P';
export const Product_Create: string = ProductURL + '/Create';
export const Product_Update: string = ProductURL + '/Update';
export const Product_ReadById: string = ProductURL + '/ReadById';
export const Product_Delete: string = ProductURL + '/Delete';
export const Product_ReadAll = ProductURL + '/ReadAll';
export const Product_FetchDetail = ProductURL + '/FetchProductDetails';
export const Product_ReadByProductType: string = ProductURL + '/ReadByProductType';
export const Product_ReadByProductCode: string = ProductURL + '/ReadByProductCode';
export const Product_GetLoanSlabs: string = ProductURL + '/GetLoanSlabs';
//#endregion


//#region Credit Applications API
export const CreditApplicationURL: string = PayLaterBaseURL + '/CCA';
export const CreditApplication_Create: string = CreditApplicationURL + '/Create';
export const CreditApplication_Update: string = CreditApplicationURL + '/Update';
export const CreditApplication_Delete: string = CreditApplicationURL + '/Delete';
export const CreditApplication_ReadAll = CreditApplicationURL + '/ReadAll';
export const CreditApplication_ReadById: string = CreditApplicationURL + '/ReadById';
export const CreditApplication_ReadByProductId: string = CreditApplicationURL + '/ReadByProductId';
export const CreditApplication_ReadByUserId: string = CreditApplicationURL + '/ReadByUserId';

//#endregion

//#region SchoolMaster API
export const SchoolMasterURL: string = SchoolBaseURL + '/SCLM';
export const SchoolMaster_Create: string = SchoolMasterURL + '/Create';
export const SchoolMaster_Update: string = SchoolMasterURL + '/Update';
export const SchoolMaster_ReadById: string = SchoolMasterURL + '/ReadById';
export const SchoolMaster_ExternalReadById: string = SchoolMasterURL + '/ReadById_External';
export const SchoolMaster_Delete: string = SchoolMasterURL + '/Delete';
export const SchoolMaster_ReadAll: string = SchoolMasterURL + '/ReadAll';
export const SchoolMaster_ReadAllPaginated: string = SchoolMasterURL + '/ReadAllPaginated';
export const SchoolMaster_OnboardingReadAllPaginated: string = SchoolMasterURL + '/OnboardingReadAllPaginated';
export const SchoolMaster_OnboardingComplete: string = SchoolMasterURL + '/OnboardingComplete';
export const SchoolMaster_ReadByParentId = SchoolMasterURL + '/SchoolMasterReadByParentId';
export const SchoolMaster_GetSummary = SchoolMasterURL + '/GetSummary'
export const SchoolMaster_OpsDashboardKPI = SchoolMasterURL + '/OpsDashboardKPI'

//#endregion

// //#region WhatsAppConfig API
// export const WhatsAppConfigURL: string = NotificationBaseURL + '/WAC';
// export const WhatsAppConfig_Create: string = WhatsAppConfigURL + '/Create';
// export const WhatsAppConfig_Update: string = WhatsAppConfigURL + '/Update';
// export const WhatsAppConfig_Delete: string = WhatsAppConfigURL + '/Delete';
// export const WhatsAppConfig_ReadById: string = WhatsAppConfigURL + '/ReadById';
// export const WhatsAppConfig_ReadAll: string = WhatsAppConfigURL + '/ReadAll';
// export const WhatsAppConfig_ReadAllPaginated: string = WhatsAppConfigURL + '/ReadAllPaginated';
// export const WhatsAppConfig_QRCode: string = WhatsAppConfigURL + '/QRCode';
// export const WhatsAppConfig_SendText: string = WhatsAppConfigURL + '/SendText';
// export const WhatsAppConfig_ReadByModule: string = WhatsAppConfigURL + '/ReadByModule';
// //#endregion


 //#region WhatsAppConfig API

export const WhatsAppConfigURL: string = NotificationBaseURL + '/WAC';
export const WhatsAppConfig_Create: string = WhatsAppConfigURL + '/Create';
export const WhatsAppConfig_Update: string = WhatsAppConfigURL + '/Update';
export const WhatsAppConfig_Delete: string = WhatsAppConfigURL + '/Delete';
export const WhatsAppConfig_ReadById: string = WhatsAppConfigURL + '/ReadById';
export const WhatsAppConfig_ReadAll: string = WhatsAppConfigURL + '/ReadAll';
export const WhatsAppConfig_ReadAllPaginated: string = WhatsAppConfigURL + '/ReadAllPaginated';
export const WhatsAppConfig_QRCode: string = WhatsAppConfigURL + '/QRCode';
export const WhatsAppConfig_SendText: string = WhatsAppConfigURL + '/SendText';
export const WhatsAppConfig_ReadByModule: string = WhatsAppConfigURL + '/ReadByModule';

// ============================================================
// WHATSAPP CHAT API - OCELOT /NT/WAM/Chats
// ============================================================

// Deploy the matching Notification controller and Ocelot mapping for these two DB APIs.
export const WhatsAppConversation_ReadAllPaginated: string = NotificationBaseURL + '/WACV/ReadAllPaginated';
export const WhatsAppContact_ReadAllPaginated: string = NotificationBaseURL + '/WACT/ReadAllPaginated';

export const WhatsAppChatsURL: string = NotificationBaseURL + '/WAM/Chats';

export const WhatsAppChats_ReadAll: string = WhatsAppChatsURL + '/ReadAll';
export const WhatsAppChats_ReadOverview: string = WhatsAppChatsURL + '/ReadOverview';
export const WhatsAppChats_ReadOverviewByIds: string = WhatsAppChatsURL + '/ReadOverviewByIds';

export const WhatsAppChats_DeleteChat: string = WhatsAppChatsURL + '/DeleteChat';
export const WhatsAppChats_ReadPicture: string = WhatsAppChatsURL + '/ReadPicture';

export const WhatsAppChats_ReadMessages: string = WhatsAppChatsURL + '/ReadMessages';
export const WhatsAppChats_ClearMessages: string = WhatsAppChatsURL + '/ClearMessages';
export const WhatsAppChats_MarkMessagesRead: string = WhatsAppChatsURL + '/MarkMessagesRead';

export const WhatsAppChats_ReadMessageById: string = WhatsAppChatsURL + '/ReadMessageById';
export const WhatsAppChats_DeleteMessage: string = WhatsAppChatsURL + '/DeleteMessage';
export const WhatsAppChats_EditMessage: string = WhatsAppChatsURL + '/EditMessage';

export const WhatsAppChats_PinMessage: string = WhatsAppChatsURL + '/PinMessage';
export const WhatsAppChats_UnpinMessage: string = WhatsAppChatsURL + '/UnpinMessage';

export const WhatsAppChats_Archive: string = WhatsAppChatsURL + '/Archive';
export const WhatsAppChats_Unarchive: string = WhatsAppChatsURL + '/Unarchive';
export const WhatsAppChats_MarkUnread: string = WhatsAppChatsURL + '/MarkUnread';

// NEW API - Backend action and Ocelot route must be deployed
export const WhatsAppChats_SendFile: string = WhatsAppChatsURL + '/SendFile';

//#endregion


// ============================================================
// WHATSAPP SCHEDULER APIs
// ============================================================

export const WhatsAppSchedulerApiURL: string = NotificationBaseURL + '/WAS';

export const WhatsAppScheduler_Create: string = WhatsAppSchedulerApiURL + '/Create';
export const WhatsAppScheduler_Update: string = WhatsAppSchedulerApiURL + '/Update';
export const WhatsAppScheduler_Delete: string = WhatsAppSchedulerApiURL + '/Delete';
export const WhatsAppScheduler_ReadById: string = WhatsAppSchedulerApiURL + '/ReadById';
export const WhatsAppScheduler_ReadAll: string = WhatsAppSchedulerApiURL + '/ReadAll';
export const WhatsAppScheduler_ReadAllPaginated: string = WhatsAppSchedulerApiURL + '/ReadAllPaginated';


// ============================================================
// WHATSAPP MESSAGE APIs
// ============================================================

// CRM Lead SendText reuses existing WhatsAppConfig endpoint.
// Backend MUST authorize lead ownership and recipient number.
export const WhatsAppLeadApiURL: string = WhatsAppConfigURL;
export const WhatsAppLead_SendText: string = WhatsAppConfig_SendText;
// Requires downstream atomic ScheduleText API and Ocelot route (not part of existing WAS CRUD).
export const WhatsAppLead_ScheduleText: string = WhatsAppSchedulerApiURL + '/ScheduleText';


//#region HRMS Attendance API

export const HRMSAttendanceApiURL: string = BaseURL + '/H/ATT';
export const Attendance_CheckInCheckOut: string = HRMSAttendanceApiURL + '/CheckInCheckOut';
export const Attendance_Status: string = HRMSAttendanceApiURL + '/Status';
export const Attendance_SchoolStaffAttendanceKPI: string = HRMSAttendanceApiURL + '/SchoolStaffAttendanceKPI';
export const Attendance_SchoolReadAllPaginated: string = HRMSAttendanceApiURL + '/SchoolReadAllPaginated';

export const Attendance_SocietyStaffAttendanceKPI: string =
  HRMSAttendanceApiURL + '/SocietyStaffAttendanceKPI';

export const Attendance_SocietyReadAllPaginated: string =
  HRMSAttendanceApiURL + '/SocietyReadAllPaginated';

export const Attendance_HospitalStaffAttendanceKPI: string =
  HRMSAttendanceApiURL + '/HospitalStaffAttendanceKPI';

export const Attendance_HospitalReadAllPaginated: string =
  HRMSAttendanceApiURL + '/HospitalReadAllPaginated';

//#endregion

//#region RealEstate - Property API 
export const PropertyURL: string = RealEstateBaseURL + '/PTY';
export const Property_Create: string = PropertyURL + '/Create';
export const Property_Update: string = PropertyURL + '/Update';
export const Property_Delete: string = PropertyURL + '/Delete';
export const Property_ReadAll: string = PropertyURL + '/ReadAll';
export const Property_ReadById: string = PropertyURL + '/ReadById';
export const Property_ReadByOwnerUserId: string = PropertyURL + '/ReadByOwnerUserId';
export const Property_ReadByBusinessIdPaginated: string = PropertyURL + '/ReadByBusinessIdPaginated';
export const Property_GetDictionary: string = PropertyURL + '/GetDictionary';
//#endRegion

//#region RealEstate - Property Details API
export const PropertyDetailsURL: string = RealEstateBaseURL + '/PTYDTL';
export const PropertyDetails_Create: string = PropertyDetailsURL + '/Create';
export const PropertyDetails_Update: string = PropertyDetailsURL + '/Update';
export const PropertyDetails_Delete: string = PropertyDetailsURL + '/Delete';
export const PropertyDetails_ReadAll: string = PropertyDetailsURL + '/ReadAll';
export const PropertyDetails_ReadById: string = PropertyDetailsURL + '/ReadById';
export const PropertyDetails_ReadByPropertyId: string = PropertyDetailsURL + '/ReadByPropertyId';
//#endRegion

//#region RealEstate - Property Listing API
export const PropertyListingURL: string = RealEstateBaseURL + '/PTYL';
export const PropertyListing_Create: string = PropertyListingURL + '/Create';
export const PropertyListing_Update: string = PropertyListingURL + '/Update';
export const PropertyListing_Delete: string = PropertyListingURL + '/Delete';
export const PropertyListing_ReadAll: string = PropertyListingURL + '/ReadAll';
export const PropertyListing_ReadById: string = PropertyListingURL + '/ReadById';
export const PropertyListing_ReadByPropertyId: string = PropertyListingURL + '/ReadByPropertyId';
export const PropertyListing_ReadAllPaginated: string = PropertyListingURL + '/ReadAllPaginated';
export const PropertyListing_ReadAllPaginatedForAdmin: string = PropertyListingURL + '/ReadAllPaginatedForAdmin';
export const PropertyListing_GetPropertyDetails: string = PropertyListingURL + '/GetPropertyDetails';
export const PropertyListing_CompareListings: string = PropertyListingURL + '/CompareListings';
//#endRegion

//#region RealEstate - Property Amenities API
export const PropertyAmenitiesURL: string = RealEstateBaseURL + '/PTYA';
export const PropertyAmenities_Create: string = PropertyAmenitiesURL + '/Create';
export const PropertyAmenities_Update: string = PropertyAmenitiesURL + '/Update';
export const PropertyAmenities_Delete: string = PropertyAmenitiesURL + '/Delete';
export const PropertyAmenities_ReadAll: string = PropertyAmenitiesURL + '/ReadAll';
export const PropertyAmenities_ReadById: string = PropertyAmenitiesURL + '/ReadById';
export const PropertyAmenities_ReadByMasterId: string = PropertyAmenitiesURL + '/ReadByMasterId';
//#endRegion

//#region RealEstate - Property Document API
export const PropertyDocumentURL: string = RealEstateBaseURL + '/PTYDCT';
export const PropertyDocument_Create: string = PropertyDocumentURL + '/Create';
export const PropertyDocument_Update: string = PropertyDocumentURL + '/Update';
export const PropertyDocument_Delete: string = PropertyDocumentURL + '/Delete';
export const PropertyDocument_ReadAll: string = PropertyDocumentURL + '/ReadAll';
export const PropertyDocument_ReadById: string = PropertyDocumentURL + '/ReadById';
//#endRegion

//#region RealEstate - Property Media API

//#endRegion



//#region RealEstate - User Role In Property API
export const UserRoleInPropertyURL: string = RealEstateBaseURL + '/PTYURL';
export const UserRoleInProperty_Create: string = UserRoleInPropertyURL + '/Create';
export const UserRoleInProperty_Update: string = UserRoleInPropertyURL + '/Update';
export const UserRoleInProperty_Delete: string = UserRoleInPropertyURL + '/Delete';
export const UserRoleInProperty_ReadALL: string = UserRoleInPropertyURL + '/ReadAll';
export const UserRoleInProperty_ReadById: string = UserRoleInPropertyURL + '/ReadById';
export const UserRoleInProperty_ReadByPropertyId: string = UserRoleInPropertyURL + '/ReadByPropertyId';
export const UserRoleInProperty_ReadByUserId: string = UserRoleInPropertyURL + '/ReadByUserId';
//#endRegion

//#region housing_society API
export const SocietyURL: string = SocietyBaseURL + '/SOC';
export const Society_Create: string = SocietyURL + '/Create';
export const Society_Update: string = SocietyURL + '/Update';
export const Society_Delete: string = SocietyURL + '/Delete';
export const Society_ReadById: string = SocietyURL + '/ReadById';
export const Society_ExternalReadById: string = SocietyURL + '/ReadById_External';
export const Society_ReadAll: string = SocietyURL + '/ReadAll';
export const Society_ReadAllPaginated: string = SocietyURL + '/ReadAllPaginated';
export const Society_ReadByUserId: string = SocietyURL + '/ReadByUserId';
export const Society_OnboardingComplete: string = SocietyURL + '/OnboardingComplete';
export const Society_OnboardingReadAllPaginated: string = SocietyURL + '/OnboardingReadAllPaginated';
//#end region

//#region building API
export const BuildingURL: string = SocietyBaseURL + '/BUL';
export const Building_Create: string = BuildingURL + '/Create';
export const Building_Update: string = BuildingURL + '/Update';
export const Building_Delete: string = BuildingURL + '/Delete';
export const Building_ReadByUserId: string = BuildingURL + '/ReadByUserId';
export const Building_ReadAll: string = BuildingURL + '/ReadAll';
export const Building_ReadById: string = BuildingURL + '/ReadById';
export const Building_ReadBySocietyId: string = BuildingURL + '/ReadBySocietyId';
export const Building_ReadBySocietyId_External: string = BuildingURL + '/ReadBySocietyId_External';
export const Building_CreateBulk: string = BuildingURL + '/CreateBulk';


//#end region


//#region StudentMaster API
export const StudentMasterURL: string = SchoolBaseURL + '/STDM';
export const StudentMaster_Create: string = StudentMasterURL + '/Create';
export const StudentMaster_Update: string = StudentMasterURL + '/Update';
export const StudentMaster_ReadById: string = StudentMasterURL + '/ReadById';
export const StudentMaster_ReadBySchoolId: string = StudentMasterURL + '/ReadBySchoolId';
export const StudentMaster_ReadByClassId: string = StudentMasterURL + '/ReadByClassId';
export const StudentMaster_Delete: string = StudentMasterURL + '/Delete';
export const StudentMaster_ReadAll = StudentMasterURL + '/ReadAll';
export const StudentMaster_ReadAllPaginated = StudentMasterURL + '/ReadAllPaginated';
export const StudentMaster_ReadByParentId = StudentMasterURL + '/ReadByParentId';
//#endregion

//#region flat API
export const FlatURL: string = SocietyBaseURL + '/FL';
export const Flat_Create: string = FlatURL + '/Create';
export const Flat_Update: string = FlatURL + '/Update';
export const Flat_Delete: string = FlatURL + '/Delete';
export const Flat_ReadByUserId: string = FlatURL + '/ReadByUserId';
export const Flat_ReadAll: string = FlatURL + '/ReadAll';
export const Flat_ReadByBuildingId: string = FlatURL + '/ReadByBuildingId';
export const Flat_ReadByBuildingId_External: string = FlatURL + '/ReadByBuildingId_External';
export const Flat_ReadById: string = FlatURL + '/ReadById';
export const Flat_CreateBulk: string = FlatURL + '/CreateBulk';
export const Flat_GetFlatsCountBySocietyId: string = FlatURL + '/GetFlatsCountBySocietyId';
export const Flat_ReadByOwnerId = FlatURL + '/ReadByOwnerId';
//#end region

//#region flat-member API
export const FlatMemberURL: string = SocietyBaseURL + '/FLM';
export const FlatMember_Create: string = FlatMemberURL + '/Create';
export const FlatMember_Update: string = FlatMemberURL + '/Update';
export const FlatMember_Delete: string = FlatMemberURL + '/Delete';
export const FlatMember_ReadAll: string = FlatMemberURL + '/ReadAll';
export const FlatMember_ReadByFlatId: string = FlatMemberURL + '/ReadByFlatId';
export const FlatMember_ReadByUserId: string = FlatMemberURL + '/ReadByUserId';
export const FlatMember_ReadById: string = FlatMemberURL + '/ReadById';
export const FlatMember_FetchFlatMemberDetails: string = FlatMemberURL + '/FetchFlatMemberDetails';
export const FlatMember_BulkMemberDetails: string = FlatMemberURL + '/CreateBulk';
//#end region

//#region flat-member API
export const VaultDoumentURL: string = SocietyBaseURL + '/VLD';
export const VaultDocument_Create: string = VaultDoumentURL + '/Create';
export const VaultDocument_Update: string = VaultDoumentURL + '/Update';
export const VaultDocument_Delete: string = VaultDoumentURL + '/Delete';
export const VaultDocument_ReadAll: string = VaultDoumentURL + '/ReadAll';
export const VaultDocument_ReadByUserId: string = VaultDoumentURL + '/ReadByUserId';


//#end region

//#region ClassMaster API
export const ClassMasterURL: string = SchoolBaseURL + '/CLM';
export const ClassMaster_Create: string = ClassMasterURL + '/Create';
export const ClassMaster_Update: string = ClassMasterURL + '/Update';
export const ClassMaster_ReadById: string = ClassMasterURL + '/ReadById';
export const ClassMaster_ReadBySchoolId: string = ClassMasterURL + '/ReadBySchoolId';
export const ClassMaster_ReadBySchoolId_External: string = ClassMasterURL + '/ReadBySchoolId_External';
export const ClassMaster_Delete: string = ClassMasterURL + '/Delete';
export const ClassMaster_ReadAll = ClassMasterURL + '/ReadAll';
export const ClassMaster_ReadAllPaginated = ClassMasterURL + '/ReadAllPaginated';
export const ClassMaster_CreateBulk: string = ClassMasterURL + '/CreateBulk';
export const ClassMaster_MarkAttendance: string = ClassMasterURL + '/MarkAttendance';
export const ClassMaster_CheckAttendance: string = ClassMasterURL + '/CheckAttendance';
export const ClassMaster_MarkStudentAttendance: string = ClassMasterURL + '/MarkStudentAttendance'
export const ClassMaster_GetPendingFeeBySchoolId: string = ClassMasterURL + '/GetPendingFeeBySchoolId'
//#endregion

//#region ParentStudentMapping API
export const ParentStudentMappingURL: string = SchoolBaseURL + '/PSM';
export const ParentStudentMapping_Create: string = ParentStudentMappingURL + '/Create';
export const ParentStudentMapping_Update: string = ParentStudentMappingURL + '/Update';
export const ParentStudentMapping_ReadById: string = ParentStudentMappingURL + '/ReadById';
export const ParentStudentMapping_Delete: string = ParentStudentMappingURL + '/Delete';
export const ParentStudentMapping_ReadByParentId = ParentStudentMappingURL + '/ReadByParentId';
export const ParentStudentMapping_ReadByStudentId = ParentStudentMappingURL + '/ReadByStudentId';
export const ParentStudentMapping_ReadAll = ParentStudentMappingURL + '/ReadAll';
export const ParentStudentMapping_ReadByClassId: string = ParentStudentMappingURL + '/ReadByClassId';
//#endregion

//#region SchoolBankMaster API
export const SchoolBankMasterURL: string = SchoolBaseURL + '/SBM';
export const SchoolBankMaster_Create: string = SchoolBankMasterURL + '/Create';
export const SchoolBankMaster_Update: string = SchoolBankMasterURL + '/Update';
export const SchoolBankMaster_ReadById: string = SchoolBankMasterURL + '/ReadById';
export const SchoolBankMaster_ReadByMasterId: string = SchoolBankMasterURL + '/ReadByMasterId';
export const SchoolBankMaster_ReadByMasterType: string = SchoolBankMasterURL + '/ReadByMasterType';
export const SchoolBankMaster_Delete: string = SchoolBankMasterURL + '/Delete';
export const SchoolBankMaster_ReadAll = SchoolBankMasterURL + '/ReadAll';
//#endregion

//#region SchoolImgMaster API
export const SchoolImgMasterURL: string = SchoolBaseURL + '/SIM';
export const SchoolImgMaster_Create: string = SchoolImgMasterURL + '/Create';
export const SchoolImgMaster_Update: string = SchoolImgMasterURL + '/Update';
export const SchoolImgMaster_ReadById: string = SchoolImgMasterURL + '/ReadById';
export const SchoolImgMaster_ReadByMasterId: string = SchoolImgMasterURL + '/ReadByMasterId';
export const SchoolImgMaster_ReadByMasterType: string = SchoolImgMasterURL + '/ReadByMasterType';
export const SchoolImgMaster_Delete: string = SchoolImgMasterURL + '/Delete';
export const SchoolImgMaster_ReadAll = SchoolImgMasterURL + '/ReadAll';
//#endregion

//#region SchoolDocMaster API
export const SchoolDocMasterURL: string = SchoolBaseURL + '/SDM';
export const SchoolDocMaster_Create: string = SchoolDocMasterURL + '/Create';
export const SchoolDocMaster_Update: string = SchoolDocMasterURL + '/Update';
export const SchoolDocMaster_ReadById: string = SchoolDocMasterURL + '/ReadById';
export const SchoolDocMaster_ReadByMasterId: string = SchoolDocMasterURL + '/ReadByMasterId';
export const SchoolDocMaster_ExternalReadByMasterId: string = SchoolDocMasterURL + '/ReadByMasterId_External';
export const SchoolDocMaster_ReadByMasterType: string = SchoolDocMasterURL + '/ReadByMasterType';
export const SchoolDocMaster_Delete: string = SchoolDocMasterURL + '/Delete';
export const SchoolDocMaster_ReadAll = SchoolDocMasterURL + '/ReadAll';
export const SchoolDocMaster_CreateBulk = SchoolDocMasterURL + '/CreateBulk';
export const SchoolDocMaster_ExternalCreateBulk = SchoolDocMasterURL + '/CreateBulk_External';
//#endregion

//#region FeeStructureMaster API
export const FeeStructureMasterURL: string = SchoolBaseURL + '/FSM';
export const FeeStructureMaster_Create: string = FeeStructureMasterURL + '/Create';
export const FeeStructureMaster_Update: string = FeeStructureMasterURL + '/Update';
export const FeeStructureMaster_ReadById: string = FeeStructureMasterURL + '/ReadById';
export const FeeStructureMaster_ReadByClassId: string = FeeStructureMasterURL + '/ReadByClassId';
export const FeeStructureMaster_ReadFeesDetailsByClassId: string = FeeStructureMasterURL + '/ReadFeesDetailsByClassId'
export const FeeStructureMaster_Delete: string = FeeStructureMasterURL + '/Delete';
export const FeeStructureMaster_ReadAll = FeeStructureMasterURL + '/ReadAll';
export const FeeStructureMaster_FeeClassListing = FeeStructureMasterURL + '/FeeClassListing';
export const FeeStructureMaster_ClonerByClassId = FeeStructureMasterURL + '/ClonerByClassId'
//#endregion

//#region FeeInstallmentMaster API
export const FeeInstallmentMasterURL: string = SchoolBaseURL + '/FIM';
export const FeeInstallmentMaster_Create: string = FeeInstallmentMasterURL + '/Create';
export const FeeInstallmentMaster_Update: string = FeeInstallmentMasterURL + '/Update';
export const FeeInstallmentMaster_ReadById: string = FeeInstallmentMasterURL + '/ReadById';
export const FeeInstallmentMaster_ReadByFeeStructureId: string = FeeInstallmentMasterURL + '/ReadByFeeStructureId';
export const FeeInstallmentMaster_Delete: string = FeeInstallmentMasterURL + '/Delete';
export const FeeInstallmentMaster_ReadAll = FeeInstallmentMasterURL + '/ReadAll';
//#endregion




//#region RealEstate - BusinessMaster API
export const BusinessMasterURL: string = RealEstateBaseURL + '/BM';
export const BusinessMaster_Create: string = BusinessMasterURL + '/Create';
export const BusinessMaster_Update: string = BusinessMasterURL + '/Update';
export const BusinessMaster_Delete: string = BusinessMasterURL + '/Delete';
export const BusinessMaster_ReadAll: string = BusinessMasterURL + '/ReadAll';
export const BusinessMaster_ReadAllPaginated: string = BusinessMasterURL + '/ReadAllPaginated';
export const BusinessMaster_OnboardingReadAllPaginated: string = BusinessMasterURL + '/OnboardingReadAllPaginated';
export const BusinessMaster_ReadById: string = BusinessMasterURL + '/ReadById';
export const BusinessMaster_ReadByBusinessType: string = BusinessMasterURL + '/ReadByBusinessType';
export const BusinessMaster_OnboardingComplete: string = BusinessMasterURL + '/OnboardingComplete';
export const BusinessMaster_SearchByName: string = BusinessMasterURL + '/SearchByName';
//endregion


//region ValueList API
export const ValueListURL: string = MasterBaseURL + '/VL';
export const ValueList_create = ValueListURL + '/Create';
export const ValueList_update = ValueListURL + '/Update';
export const ValueList_readById = ValueListURL + '/ReadById';
export const ValueList_readAll = ValueListURL + '/ReadAll';
export const ValueList_delete = ValueListURL + '/Delete';
export const ValueList_ReadKeyValueDictionaryByCode = ValueListURL + '/ReadKeyValueDictionaryByCode';
export const ValueList_GetFilteredKeyValueDictionaryByCode = ValueListURL + '/ReadFilteredKeyValueDictionaryByCode';
//endregion

//region ValueListItem API
export const ValueListItemURL: string = MasterBaseURL + '/VLI';
export const ValueListItem_create = ValueListItemURL + '/Create';
export const ValueListItem_update = ValueListItemURL + '/Update';
export const ValueListItem_delete = ValueListItemURL + '/Delete';
export const ValueListItem_readById = ValueListItemURL + '/ReadById';
export const ValueListItem_readByValueListId = ValueListItemURL + '/ReadByValueListId';
export const ValueListItem_readByVlCode = ValueListItemURL + '/ReadByVlCode';
export const ValueListItem_readByVlName = ValueListItemURL + '/ReadByVlName';
export const ValueListItem_readByVlCodeList = ValueListItemURL + '/ReadByVlCodeList';
export const ValueListItem_readByCompanyId = ValueListItemURL + '/ReadByCompanyId';
//endregion

//#region FeeComponentMaster API
export const FeeComponentMasterURL: string = SchoolBaseURL + '/FC';
export const FeeComponentMaster_Create: string = FeeComponentMasterURL + '/Create';
export const FeeComponentMaster_Update: string = FeeComponentMasterURL + '/Update';
export const FeeComponentMaster_ReadById: string = FeeComponentMasterURL + '/ReadById';
export const FeeComponentMaster_ReadByInstallmentId: string = FeeComponentMasterURL + '/ReadByInstallmentId';
export const FeeComponentMaster_ReadByComponentName: string = FeeComponentMasterURL + '/ReadByComponentName';
export const FeeComponentMaster_Delete: string = FeeComponentMasterURL + '/Delete';
export const FeeComponentMaster_ReadAll = FeeComponentMasterURL + '/ReadAll';
//#endregion//#endregion

//#region RealEstate - UserAffiliationMapping API
export const UserAffiliationMappingURL: string = RealEstateBaseURL + '/UAM';
export const UserAffiliationMapping_Create: string = UserAffiliationMappingURL + '/Create';
export const UserAffiliationMapping_Update: string = UserAffiliationMappingURL + '/Update';
export const UserAffiliationMapping_Delete: string = UserAffiliationMappingURL + '/Delete';
export const UserAffiliationMapping_ReadAll: string = UserAffiliationMappingURL + '/ReadAll';
export const UserAffiliationMapping_ReadById: string = UserAffiliationMappingURL + '/ReadById';
export const UserAffiliationMapping_ReadByBusinessId: string = UserAffiliationMappingURL + '/ReadByBusinessId';
export const UserAffiliationMapping_ReadByUserId: string = UserAffiliationMappingURL + '/ReadByUserId';
//#endregion

//#region Master - UserMaster API
export const UserMasterURL: string = MasterBaseURL + '/UM';
export const UserMaster_Create: string = UserMasterURL + '/Create';
export const UserMaster_Create_External: string = UserMasterURL + '/Create_External';
export const UserMaster_Update: string = UserMasterURL + '/Update';
export const UserMaster_Delete: string = UserMasterURL + '/Delete';
export const UserMaster_UpdateStatus: string = UserMasterURL + '/UpdateStatus';
export const UserMaster_ReadById: string = UserMasterURL + '/ReadById';
export const UserMaster_ReadAll: string = UserMasterURL + '/ReadAll';
export const UserMaster_ReadAllPaginated: string = UserMasterURL + '/ReadAllPaginated';
export const UserMaster_GetDictionary: string = UserMasterURL + '/GetDictionary';
export const UserMaster_SearchByName: string = UserMasterURL + '/SearchByName';
export const UserMaster_ReadByBusinessId: string = UserMasterURL + '/ReadByBusinessId';
export const UserMaster_ReadByHospitalId: string = UserMasterURL + '/ReadByHospitalId';
export const UserMaster_GetUserDetailsByDocNo: string = UserMasterURL + '/GetUserDetailsByDocNo';
export const UserMaster_ReadBySocietyId: string = UserMasterURL + '/ReadBySocietyId';
export const UserMaster_SuggestUserName: string = UserMasterURL + '/SuggestUserName';
export const UserMaster_ValidateUniqueIdentities: string = UserMasterURL + '/ValidateUniqueIdentities';
//#endregion

//#region Master - UserRole API
export const UserRoleURL: string = MasterBaseURL + '/UR';
export const UserRole_Create: string = UserRoleURL + '/Create';
export const UserRole_Update: string = UserRoleURL + '/Update';
export const UserRole_Delete: string = UserRoleURL + '/Delete';
export const UserRole_ReadByUserId: string = UserRoleURL + '/ReadByUserId';
export const UserRole_ReadAll: string = UserRoleURL + '/ReadAll';
//#endregion

//#region FlatType API
export const FlatTypeURL: string = SocietyBaseURL + '/FLT';
export const FlatType_Create: string = FlatTypeURL + '/Create'; //'https://dev.apig.nishwik.com/SOC/FLT/Create'
export const FlatType_Update: string = FlatTypeURL + '/Update';
export const FlatType_ReadById: string = FlatTypeURL + '/ReadById';
export const FlatType_ReadAll: string = FlatTypeURL + '/ReadAll';
export const FlatType_Delete: string = FlatTypeURL + '/Delete';
export const FlatType_ReadBySocietyId: string = FlatTypeURL + '/ReadBySocietyId';
//#endregion

//#region FlatMaintenancePDFConvertJSON API
export const FlatMaintenancePDFConvertJSONURL: string = SocietyBaseURL + "/FMPD";
export const FlatMaintenancePDFConvertJSON_Create: string = FlatMaintenancePDFConvertJSONURL + "/Create";
export const FlatMaintenancePDFConvertJSON_Update: string = FlatMaintenancePDFConvertJSONURL + "/Update";
export const FlatMaintenancePDFConvertJSON_ReadById: string = FlatMaintenancePDFConvertJSONURL + "/ReadById";
export const FlatMaintenancePDFConvertJSON_ReadAll: string = FlatMaintenancePDFConvertJSONURL + "/ReadAll";
export const FlatMaintenancePDFConvertJSON_Delete: string = FlatMaintenancePDFConvertJSONURL + "/Delete";
export const FlatMaintenancePDFConvertJSON_ReadBySocietyId: string = FlatMaintenancePDFConvertJSONURL + "/ReadBySocietyId";
export const FlatMaintenancePDFConvertJSON_ReadByWingFlat: string = FlatMaintenancePDFConvertJSONURL + "/ReadByWingFlat";
export const FlatMaintenancePDFConvertJSON_ReadByDuplicateKey: string = FlatMaintenancePDFConvertJSONURL + "/ReadByDuplicateKey";


export const FlatMaintenancePDFUploadfileURL: string = SocietyBaseURL + "/FMPD";
export const FlatMaintenancePDFConvertJSON_SendMaintenance: string = FlatMaintenancePDFUploadfileURL + "/SendMaintenance";

//#endregion

//#region FlatMaintenancePDFUploadfile API
export const FlatMaintenancePDFUploadfile_Create: string = FlatMaintenancePDFUploadfileURL + "/Create";
export const FlatMaintenancePDFUploadfile_Update: string = FlatMaintenancePDFUploadfileURL + "/Update";
export const FlatMaintenancePDFUploadfile_ReadById: string = FlatMaintenancePDFUploadfileURL + "/ReadById";
export const FlatMaintenancePDFUploadfile_ReadAll: string = FlatMaintenancePDFUploadfileURL + "/ReadAll";
export const FlatMaintenancePDFUploadfile_Delete: string = FlatMaintenancePDFUploadfileURL + "/Delete";
export const FlatMaintenancePDFUploadfile_ReadBySocietyId: string = FlatMaintenancePDFUploadfileURL + "/ReadBySocietyId";
export const FlatMaintenancePDFUploadfile_ReadByWingFlat: string = FlatMaintenancePDFUploadfileURL + "/ReadByWingFlat";
export const FlatMaintenancePDFUploadfile_ReadByDuplicateKey: string = FlatMaintenancePDFUploadfileURL + "/ReadByDuplicateKey";

//#region FlatMaintenance API
export const FlatMaintenanceURL: string = SocietyBaseURL + "/FM";

export const FlatMaintenance_Create = FlatMaintenanceURL + "/Create";
export const FlatMaintenance_CreateBulk = FlatMaintenanceURL + "/CreateBulk";
export const FlatMaintenance_Update = FlatMaintenanceURL + "/Update";
export const FlatMaintenance_Delete = FlatMaintenanceURL + "/Delete";
export const FlatMaintenance_ReadAll = FlatMaintenanceURL + "/ReadAll";
export const FlatMaintenance_ReadById = FlatMaintenanceURL + "/ReadById";
export const FlatMaintenance_ReadBySocietyId = FlatMaintenanceURL + "/ReadBySocietyId";
export const FlatMaintenance_ReadByFlatId = FlatMaintenanceURL + "/ReadByFlatId";
export const FlatMaintenance_ReadByFlatTypeId = FlatMaintenanceURL + "/ReadByFlatTypeId";
export const FlatMaintenance_DeleteByBuildingId = FlatMaintenanceURL + "/DeleteByBuildingId";
//#endregion


//#region FlatMaintenanceDetail API
export const FlatMaintenanceDetailURL: string = SocietyBaseURL + "/FMD";

export const FlatMaintenanceDetail_Create = FlatMaintenanceDetailURL + "/Create";
export const FlatMaintenanceDetail_Update = FlatMaintenanceDetailURL + "/Update";
export const FlatMaintenanceDetail_Delete = FlatMaintenanceDetailURL + "/Delete";
export const FlatMaintenanceDetail_ReadAll = FlatMaintenanceDetailURL + "/ReadAll";
export const FlatMaintenanceDetail_ReadById = FlatMaintenanceDetailURL + "/ReadById";
export const FlatMaintenanceDetail_ReadByChargeId = FlatMaintenanceDetailURL + "/ReadByChargeId";
export const FlatMaintenanceDetail_ReadByFMId = FlatMaintenanceDetailURL + "/ReadByFMId";
//#endregion


//#endregion

//#region BillUpload API
export const BillUploadURL: string = SocietyBaseURL + '/BillUpload';
export const BillUpload_UploadBulk: string = BillUploadURL + '/upload-bulk';
export const BillUpload_ReadByWingFlat: string = BillUploadURL + '/ReadByWingFlat';
export const BillUpload_SendMaintenance: string = BillUploadURL + '/SendMaintenance';
export const BillUpload_ReadBySocietyId: string = BillUploadURL + '/ReadBySocietyId'; 
// export const FileProcessing_ReadBySocietyId: string = FileProcessingURL + '/ReadBySocietyId';
// export const FileProcessing_Upload: string = FileProcessingURL + '/Upload';
//#endregion


//#region Society Maintenance Upload APIs
export const FileProcessingURL: string = SocietyBaseURL + '/FP';
export const FileProcessing_HealthCheck: string = FileProcessingURL + '/healthCheck';
export const FileProcessing_Create: string = FileProcessingURL + '/Create';
export const FileProcessing_Update: string = FileProcessingURL + '/Update';
export const FileProcessing_Delete: string = FileProcessingURL + '/Delete';
export const FileProcessing_ReadAll: string = FileProcessingURL + '/ReadAll';
export const FileProcessing_ReadByDuplicateKey: string = FileProcessingURL + '/ReadByDuplicateKey';
export const FileProcessing_ReadBySocietyId: string = FileProcessingURL + '/ReadBySocietyId';
export const FileProcessing_Upload: string = FileProcessingURL + '/Upload';

// export const BillUploadURL: string = SocietyBaseURL + '/BUP';
// export const BillUpload_HealthCheck: string = BillUploadURL + '/healthCheck';
// export const BillUpload_Create: string = BillUploadURL + '/Create';
// export const BillUpload_Update: string = BillUploadURL + '/Update';
// export const BillUpload_Delete: string = BillUploadURL + '/Delete';
// export const BillUpload_ReadAll: string = BillUploadURL + '/ReadAll';
// export const BillUpload_ReadByDuplicateKey: string = BillUploadURL + '/ReadByDuplicateKey';
// export const BillUpload_ReadBySocietyId: string = BillUploadURL + '/ReadBySocietyId';
// export const BillUpload_ReadByWingFlat: string = BillUploadURL + '/ReadByWingFlat';
// export const BillUpload_SendMaintenance: string = BillUploadURL + '/SendMaintenance';
//#endregion



//#region MaintenanceCharge API
export const MaintenanceChargeURL: string = SocietyBaseURL + '/MC';
export const MaintenanceCharge_Create: string = MaintenanceChargeURL + '/Create';
export const MaintenanceCharge_Update: string = MaintenanceChargeURL + '/Update';
export const MaintenanceCharge_ReadById: string = MaintenanceChargeURL + '/ReadById';
export const MaintenanceCharge_ReadAll: string = MaintenanceChargeURL + '/ReadAll';
export const MaintenanceCharge_Delete: string = MaintenanceChargeURL + '/Delete';
export const MaintenanceCharge_ReadByFlatId: string = MaintenanceChargeURL + '/ReadByFlatId';
//#endregion


//#region MaintenanceChargeMaster API
export const MaintenanceChargeMasterURL: string = SocietyBaseURL + '/MCM';
export const MaintenanceChargeMaster_Create: string = MaintenanceChargeMasterURL + '/Create';
export const MaintenanceChargeMaster_ReadById: string = MaintenanceChargeMasterURL + '/ReadById';
export const MaintenanceChargeMaster_ReadAll: string = MaintenanceChargeMasterURL + '/ReadAll';
export const MaintenanceChargeMaster_Update: string = MaintenanceChargeMasterURL + '/Update';
export const MaintenanceChargeMaster_Delete: string = MaintenanceChargeMasterURL + '/Delete';
export const MaintenanceChargeMaster_ReadBySocietyId: string = MaintenanceChargeMasterURL + '/ReadBySocietyId';
export const MaintenanceChargeMaster_ReadByFlatTypeId: string = MaintenanceChargeMasterURL + '/ReadByFlatTypeId';
export const MaintenanceChargeMaster_CloneMaintenanceCharge: string = MaintenanceChargeMasterURL + '/CloneMaintenanceCharge'
export const MaintenanceChargeMaster_CreateBulk: string = MaintenanceChargeMasterURL + '/CreateBulk'
//#endregion

//#region LoanRequest API
export const LoanRequestURL: string = SchoolBaseURL + '/LR';
export const LoanRequest_Create: string = LoanRequestURL + '/Create';
export const LoanRequest_Update: string = LoanRequestURL + '/Update';
export const LoanRequest_Delete: string = LoanRequestURL + '/Delete';
export const LoanRequest_ReadAll: string = LoanRequestURL + '/ReadAll';
export const LoanRequest_ReadById: string = LoanRequestURL + '/ReadById';
export const LoanRequest_ReadByBusinessId: string = LoanRequestURL + '/ReadByBusinessId';
export const LoanRequest_ReadByUserId: string = LoanRequestURL + '/ReadByUserId';
export const LoanRequest_ReadByServiceProviderRRN: string = LoanRequestURL + '/ReadByServiceProviderRRN';
//#endregion

//#region MaintenanceChargeDetail API
export const MaintenanceChargeDetailURL: string = SocietyBaseURL + '/MCD';
export const MaintenanceChargeDetail_Create: string = MaintenanceChargeDetailURL + '/Create';
export const MaintenanceChargeDetail_ReadById: string = MaintenanceChargeDetailURL + '/ReadById';
export const MaintenanceChargeDetail_ReadAll: string = MaintenanceChargeDetailURL + '/ReadAll';
export const MaintenanceChargeDetail_Update: string = MaintenanceChargeDetailURL + '/Update';
export const MaintenanceChargeDetail_Delete: string = MaintenanceChargeDetailURL + '/Delete';
export const MaintenanceChargeDetail_ReadByChargeId: string = MaintenanceChargeDetailURL + '/ReadByChargeId';
export const MaintenanceChargeDetail_ReadByFlatTypeId: string = MaintenanceChargeDetailURL + '/ReadByFlatTypeId';
//#endregion


//#region LegalDocument API
export const LegalDocumentURL: string = SocietyBaseURL + '/LD';
export const LegalDocument_Create: string = LegalDocumentURL + '/Create';
export const LegalDocument_ReadById: string = LegalDocumentURL + '/ReadById';
export const LegalDocument_ReadAll: string = LegalDocumentURL + '/ReadAll';
export const LegalDocument_Update: string = LegalDocumentURL + '/Update';
export const LegalDocument_Delete: string = LegalDocumentURL + '/Delete';
export const LegalDocument_ReadBySocietyId: string = LegalDocumentURL + '/ReadBySocietyId';
//#endregion


//#region RealEstate - BankMaster
export const BankMasterURL: string = RealEstateBaseURL + '/Bank';
export const BankMaster_Create: string = BankMasterURL + '/Create';
export const BankMaster_Update: string = BankMasterURL + '/Update';
export const BankMaster_Delete: string = BankMasterURL + '/Delete';
export const BankMaster_ReadAll = BankMasterURL + '/ReadAll';
export const BankMaster_ReadById: string = BankMasterURL + '/ReadById';
export const BankMaster_ReadByMasterId: string = BankMasterURL + '/ReadByMasterId';
//#endRegion

//#region School User Affiliation Mapping 
export const SUserAffiliationMappingURL: string = SchoolBaseURL + '/UAM';
export const SUserAffiliationMapping_Create: string = SUserAffiliationMappingURL + '/Create';
export const SUserAffiliationMapping_Create_External: string = SUserAffiliationMappingURL + '/Create_External';
export const SUserAffiliationMapping_Update: string = SUserAffiliationMappingURL + '/Update';
export const SUserAffiliationMapping_Delete: string = SUserAffiliationMappingURL + '/Delete';
export const SUserAffiliationMapping_ReadAll = SUserAffiliationMappingURL + '/ReadAll';
export const SUserAffiliationMapping_ReadById: string = SUserAffiliationMappingURL + '/ReadById';
export const SUserAffiliationMapping_ReadBySchoolId: string = SUserAffiliationMappingURL + '/ReadBySchoolId';
export const SUserAffiliationMapping_ReadByUserId: string = SUserAffiliationMappingURL + '/ReadByUserId';
export const SUserAffiliationMapping_ReadUserBySchoolId: string = SUserAffiliationMappingURL + '/ReadUserBySchoolId'
export const SUserAffiliationMapping_ValidateCreateBulk: string = SUserAffiliationMappingURL + '/ValidateCreateBulk'
export const SUserAffiliationMapping_CreateBulk: string = SUserAffiliationMappingURL + '/CreateBulk'
export const SUserAffiliationMapping_ValidateStudentBulk: string = SUserAffiliationMappingURL + '/ValidateStudentBulk'
export const SUserAffiliationMapping_CreateStudentBulk: string = SUserAffiliationMappingURL + '/CreateStudentBulk'
export const ClassDashboard_KPI: string = SUserAffiliationMappingURL + '/KPI';
export const ClassDashboard_AttendanceClassAvgChart: string = SUserAffiliationMappingURL + '/AttendanceClassAvgChart'
export const ClassDashboard_StudentAttendanceSummary: string = SUserAffiliationMappingURL + '/StudentAttendanceSummary'
export const UserAffiliationMapping_AttendanceStaffOverview: string = SUserAffiliationMappingURL + '/AttendanceStaffOverview'

//#endRegion

// ============ school-expense GlobalVariable.ts ========
//#region SchoolExpenseMaster API
export const SchoolExpenseURL: string = SchoolBaseURL + '/EXM';

export const SchoolExpense_Create: string = SchoolExpenseURL + '/Create';
export const SchoolExpense_Update: string = SchoolExpenseURL + '/Update';
export const SchoolExpense_Delete: string = SchoolExpenseURL + '/Delete';
export const SchoolExpense_ReadById: string = SchoolExpenseURL + '/ReadById';
export const SchoolExpense_ReadBySchoolId: string = SchoolExpenseURL + '/ReadBySchoolId';
//#endregion

//#region HospitalExpenseMaster API
export const HospitalExpenseURL: string = HospitalBaseURL + '/HEM';

export const HospitalExpense_Create: string = HospitalExpenseURL + '/Create';
export const HospitalExpense_Update: string = HospitalExpenseURL + '/Update';
export const HospitalExpense_Delete: string = HospitalExpenseURL + '/Delete';
export const HospitalExpense_ReadById: string = HospitalExpenseURL + '/ReadById';
export const HospitalExpense_ReadByHospitalId: string = HospitalExpenseURL + '/ReadByHospitalId';
//#endregion

//#region Hospital User Affiliation Mapping API
export const HUserAffiliationMappingURL: string = HospitalBaseURL + '/UAM';

export const HUserAffiliationMapping_Create: string = HUserAffiliationMappingURL + '/Create';
export const HUserAffiliationMapping_Update: string = HUserAffiliationMappingURL + '/Update';
export const HUserAffiliationMapping_Delete: string = HUserAffiliationMappingURL + '/Delete';
export const HUserAffiliationMapping_ReadAll: string = HUserAffiliationMappingURL + '/ReadAll';
export const HUserAffiliationMapping_ReadById: string = HUserAffiliationMappingURL + '/ReadById';
export const HUserAffiliationMapping_ReadByHospitalId: string = HUserAffiliationMappingURL + '/ReadByHospitalId';
export const HUserAffiliationMapping_ReadByUserId: string = HUserAffiliationMappingURL + '/ReadByUserId';
export const HUserAffiliationMapping_ReadUserByHospitalId: string = HUserAffiliationMappingURL + '/ReadUserByHospitalId';
export const HUserAffiliationMapping_ReadAllPaginated: string = HUserAffiliationMappingURL + '/ReadAllPaginated';
export const HUserAffiliationMapping_ReadAllUserPaginated: string = HUserAffiliationMappingURL + '/ReadAllUserPaginated';
export const HUserAffiliationMapping_AttendanceStaffOverview: string = HUserAffiliationMappingURL + '/AttendanceStaffOverview';
export const HospitalUserAffiliation_CreateBulk: string = HospitalUserAffiliationURL + '/CreateBulk';

//#endRegion

//#region society - SmUserAffiliationMapping API
export const SmUserAffiliationMappingURL: string = SocietyBaseURL + '/UAM';
export const SmUserAffiliationMapping_Create: string = SmUserAffiliationMappingURL + '/Create';
export const SmUserAffiliationMapping_Create_External: string = SmUserAffiliationMappingURL + '/Create_External';
export const SmUserAffiliationMapping_Update: string = SmUserAffiliationMappingURL + '/Update';
export const SmUserAffiliationMapping_Delete: string = SmUserAffiliationMappingURL + '/Delete';
export const SmUserAffiliationMapping_ReadAll: string = SmUserAffiliationMappingURL + '/ReadAll';
export const SmUserAffiliationMapping_ReadById: string = SmUserAffiliationMappingURL + '/ReadById';
export const SmUserAffiliationMapping_ReadBySocietyId: string = SmUserAffiliationMappingURL + '/ReadBySocietyId';
export const SmUserAffiliationMapping_ReadByUserId: string = SmUserAffiliationMappingURL + '/ReadByUserId';
export const SmUserAffiliationMapping_ReadByBuildingId: string = SmUserAffiliationMappingURL + '/ReadByBuildingId';
export const SmUserAffiliationMapping_ReadByFlatId: string = SmUserAffiliationMappingURL + '/ReadByFlatId';
export const SmUserAffiliationMapping_GetResidentDetailBySocietyId: string = SmUserAffiliationMappingURL + '/GetResidentDetailBySocietyId';
export const SmUserAffiliationMapping_GetTenantsByBuildingId: string = SmUserAffiliationMappingURL + '/GetTenantsByBuildingId';
export const SmUserAffiliationMapping_ReadUserBySocietyId: string = SmUserAffiliationMappingURL + '/ReadUserBySocietyId';
export const SmUserAffiliationMapping_ReadGeneralStaffBySocietyId: string = SmUserAffiliationMappingURL + '/ReadGeneralStaffBySocietyId';
export const SmUserAffiliationMapping_OnDutySecurityStaff: string = SmUserAffiliationMappingURL + '/OnDutySecurityStaff';

export const SmUserAffiliationMapping_ValidateCreateBulk: string = SmUserAffiliationMappingURL + '/ValidateCreateBulk';
export const SmUserAffiliationMapping_CreateBulk: string =SmUserAffiliationMappingURL + '/CreateBulk';
//#endregion

//#region KYC Gateway API
export const KycGatewayURL: string = PayLaterBaseURL + '/KYCG';
export const KycGateway_Authenticate: string = KycGatewayURL + '/Authenticate';
export const KycGateway_GenerateOtp: string = KycGatewayURL + '/GenerateOtp';
export const KycGateway_VerifyOtp: string = KycGatewayURL + '/VerifyOtp';


export const KycGateway_VerifyPanDetails: string = KycGatewayURL + '/VerifyPanDetails';
export const KycGateway_VerifyGstNo: string = KycGatewayURL + '/VerifyGSTIn';

export const KycGateway_GenerateOtpEntity: string = 'in.co.sandbox.kyc.aadhaar.okyc.otp.request';
export const KycGateway_VerifyOtpEntity: string = 'in.co.sandbox.kyc.aadhaar.okyc.request';
export const KycGateway_VerifyPanDetailsEntity: string = 'in.co.sandbox.kyc.pan_verification.request';
//#endregion

//#region User KYC API
export const UserKYCURL: string = PayLaterBaseURL + '/UK';
export const UserKYC_Create: string = UserKYCURL + '/Create';
export const UserKYC_Delete: string = UserKYCURL + '/Delete';
export const UserKYC_ReadAll: string = UserKYCURL + '/ReadAll';
export const UserKYC_ReadById: string = UserKYCURL + '/ReadById';
export const UserKYC_ReadByUserId: string = UserKYCURL + '/ReadByUserId';
export const UserKYC_Update: string = UserKYCURL + '/Update';
//#endregion

//#region PDF Extracter API
export const PDFExtracterURL: string = PayLaterURL + '/PL/PDFExtracter/extract';
//#endregion



//#region Roles API
export const RolesURL: string = MasterBaseURL + '/R';
export const Roles_Create: string = RolesURL + '/Create';
export const Roles_Update: string = RolesURL + '/Update';
export const Roles_Delete: string = RolesURL + '/Delete';
export const Roles_ReadAllPaginated = RolesURL + '/ReadAllPaginated';
export const Roles_ReadByActionUser: string = RolesURL + '/ReadbyActionUser';
export const Roles_ReadByGroupName: string = RolesURL + '/ReadByGroupName';
//#endRegion



//#region PayLaterImageMaster API
export const PLImageMasterURL: string = PayLaterBaseURL + '/IM';
export const PLImageMaster_Create: string = PLImageMasterURL + '/Create';
export const PLImageMaster_Update: string = PLImageMasterURL + '/Update';
export const PLImageMaster_Delete: string = PLImageMasterURL + '/Delete';
export const PLImageMaster_ReadAll = PLImageMasterURL + '/ReadAll';
export const PLImageMaster_ReadById: string = PLImageMasterURL + '/ReadById';
export const PLImageMaster_ReadByMasterId: string = PLImageMasterURL + '/ReadByMasterId';
//#endregion

//#region RoundOff Savings API
export const RoundOffSavingsURL: string = PayLaterBaseURL + '/ROS';
export const RoundOffSavings_Create: string = RoundOffSavingsURL + '/Create';
export const RoundOffSavings_Update: string = RoundOffSavingsURL + '/Update';
export const RoundOffSavings_Delete: string = RoundOffSavingsURL + '/Delete';
export const RoundOffSavings_ReadAll = RoundOffSavingsURL + '/ReadAll';
export const RoundOffSavings_ReadById: string = RoundOffSavingsURL + '/ReadById';
export const RoundOffSavings_ReadByUserId: string = RoundOffSavingsURL + '/ReadByUserId';
export const RoundOffSavings_RoundOffAmountFetch = RoundOffSavingsURL + '/AmountFetch'
//#endregion

//#region RoundOff Transaction API
export const RoundOffTransactionsURL: string = PayLaterBaseURL + '/ROT';
export const RoundOffTransactions_Create: string = RoundOffTransactionsURL + '/Create';
export const RoundOffTransactions_Update: string = RoundOffTransactionsURL + '/Update';
export const RoundOffTransactions_Delete: string = RoundOffTransactionsURL + '/Delete';
export const RoundOffTransactions_ReadAll = RoundOffTransactionsURL + '/ReadAll';
export const RoundOffTransactions_ReadById: string = RoundOffTransactionsURL + '/ReadById';
export const RoundOffTransactions_ReadByUserId: string = RoundOffTransactionsURL + '/ReadByUserId';
export const RoundOffTransactions_ReadByRoundOffSavingId = RoundOffTransactionsURL + '/ReadByRoundOffSavingId';
export const RoundOffTransactions_ReadByMasterId = RoundOffTransactionsURL + '/ReadByMasterId'
//#endregion

//#region SocietyDocMaster API
export const SocietyDocMasterURL: string = SocietyBaseURL + '/SDM';
export const SocietyDocMaster_Create: string = SocietyDocMasterURL + '/Create';
export const SocietyDocMaster_ReadById: string = SocietyDocMasterURL + '/ReadById';
export const SocietyDocMaster_ReadAll: string = SocietyDocMasterURL + '/ReadAll';
export const SocietyDocMaster_Update: string = SocietyDocMasterURL + '/Update';
export const SocietyDocMaster_Delete: string = SocietyDocMasterURL + '/Delete';
export const SocietyDocMaster_ReadByMasterId: string = SocietyDocMasterURL + '/ReadByMasterId';
export const SocietyDocMaster_ExternalReadByMasterId: string = SocietyDocMasterURL + '/ReadByMasterId_External';
export const SocietyDocMaster_CreateBulk: string = SocietyDocMasterURL + '/CreateBulk';
export const SocietyDocMaster_ExternalCreateBulk: string = SocietyDocMasterURL + '/CreateBulk_External';
//#endregion

//#region FlatFacility API
export const FlatFacilityURL: string = SocietyBaseURL + '/FF';
export const FlatFacility_Create: string = FlatFacilityURL + '/Create';
export const FlatFacility_ReadById: string = FlatFacilityURL + '/ReadById';
export const FlatFacility_ReadAll: string = FlatFacilityURL + '/ReadAll';
export const FlatFacility_Update: string = FlatFacilityURL + '/Update';
export const FlatFacility_Delete: string = FlatFacilityURL + '/Delete';
export const FlatFacility_ReadByFlatId: string = FlatFacilityURL + '/ReadByFlatId';
export const FlatFacility_ReadByDetailId: string = FlatFacilityURL + '/ReadByDetailId'
//#endregion

//#region RealEstate - PropertyVisit API 
export const PropertyVisitURL: string = RealEstateBaseURL + '/PTYV'
export const PropertyVisit_Create: string = PropertyVisitURL + '/Create'
export const PropertyVisit_Update: string = PropertyVisitURL + '/Update';
export const PropertyVisit_Delete: string = PropertyVisitURL + '/Delete';
export const PropertyVisit_ReadAll: string = PropertyVisitURL + '/ReadAll';
export const PropertyVisit_ReadById: string = PropertyVisitURL + '/ReadById';
export const PropertyVisit_ReadByMasterId: string = PropertyVisitURL + '/ReadByMasterId';
export const PropertyVisit_ReadByVisitorUserId: string = PropertyVisitURL + '/ReadByVisitorUserId';
export const PropertyVisit_ReadByBusinessId: string = PropertyVisitURL + '/ReadByBusinessId';
//#endregion

//#region RealEstate - RealEstateDocMaster API
export const RealEstateDocMasterURL: string = RealEstateBaseURL + '/RDM';
export const RealEstateDocMaster_Create: string = RealEstateDocMasterURL + '/Create';
export const RealEstateDocMaster_Update: string = RealEstateDocMasterURL + '/Update';
export const RealEstateDocMaster_ReadById: string = RealEstateDocMasterURL + '/ReadById';
export const RealEstateDocMaster_ReadByMasterId: string = RealEstateDocMasterURL + '/ReadByMasterId';
export const RealEstateDocMaster_ReadByMasterType: string = RealEstateDocMasterURL + '/ReadByMasterType';
export const RealEstateDocMaster_Delete: string = RealEstateDocMasterURL + '/Delete';
export const RealEstateDocMaster_ReadAll = RealEstateDocMasterURL + '/ReadAll';
//#endRegion

//#region OPCalendar
export const OPCalendar: string = MasterBaseURL + '/OPC'
export const OPCalendar_create = OPCalendar + '/Create';
export const OPCalendar_update = OPCalendar + '/Update';
export const OPCalendar_readAll = OPCalendar + '/ReadAll';
export const OPCalendar_delete = OPCalendar + '/Delete';
export const OPCalendar_readByCompanyID = OPCalendar + '/ReadByCompanyId';
export const OPCalendar_getMonthlyCalendarByCompany = OPCalendar + '/GetMonthlyCalendarByCompany';
//#endregion



//#region StudentRegistration
export const StudentRegistrationURL: string = SchoolBaseURL + '/STRE';
export const StudentRegistration_Create: string = StudentRegistrationURL + '/Create';
export const StudentRegistration_Update: string = StudentRegistrationURL + '/Update';
export const StudentRegistration_ReadById: string = StudentRegistrationURL + '/ReadById';
export const StudentRegistration_ReadBySchoolId: string = StudentRegistrationURL + '/ReadBySchoolId';
export const StudentRegistration_Delete: string = StudentRegistrationURL + '/Delete';
export const StudentRegistration_ReadAll = StudentRegistrationURL + '/ReadAll';
export const StudentRegistration_ReadByUserId: string = StudentRegistrationURL + '/ReadByUserId';
export const StudentRegistration_ReadByMappingId: string = StudentRegistrationURL + '/ReadByMappingId'
//#endregion

//#region RealEstate - RealEstateImgMaster API
export const RealEstateImgMasterURL: string = RealEstateBaseURL + '/RIM';
export const RealEstateImgMaster_Create: string = RealEstateImgMasterURL + '/Create';
export const RealEstateImgMaster_Update: string = RealEstateImgMasterURL + '/Update';
export const RealEstateImgMaster_Delete: string = RealEstateImgMasterURL + '/Delete';
export const RealEstateImgMaster_ReadAll: string = RealEstateImgMasterURL + '/ReadAll';
export const RealEstateImgMaster_ReadById: string = RealEstateImgMasterURL + '/ReadById';
export const RealEstateImgMaster_ReadByMasterId: string = RealEstateImgMasterURL + '/ReadByMasterId';
export const RealEstateImgMaster_ReadByMasterType: string = RealEstateImgMasterURL + '/ReadByMasterType';
//#endregion


//#region SocietyStaff
export const SocietyStaffURL: string = SocietyBaseURL + '/SS';
export const SocietyStaff_Create = SocietyStaffURL + '/Create';
export const SocietyStaff_Update = SocietyStaffURL + '/Update';
export const SocietyStaff_Delete = SocietyStaffURL + '/Delete';
export const SocietyStaff_ReadAll = SocietyStaffURL + '/ReadAll';
export const SocietyStaff_ReadById = SocietyStaffURL + '/ReadById';
export const SocietyStaff_ReadBySocietyId = SocietyStaffURL + '/ReadBySocietyId';
export const SocietyStaff_ReadByFlatId = SocietyStaffURL + '/ReadByFlatId';
//#endregion


//#region MaintenancePayment
export const MaintenancePaymentURL: string = SocietyBaseURL + '/MP';
export const MaintenancePayment_Create = MaintenancePaymentURL + '/Create';
export const MaintenancePayment_Update = MaintenancePaymentURL + '/Update';
export const MaintenancePayment_Delete = MaintenancePaymentURL + '/Delete';
export const MaintenancePayment_ReadAll = MaintenancePaymentURL + '/ReadAll';
export const MaintenancePayment_ReadByChargeId = MaintenancePaymentURL + '/ReadByChargeId';
export const MaintenancePayment_ReadById = MaintenancePaymentURL + '/ReadById';
export const MaintenancePayment_ResolveLedgerContext = MaintenancePaymentURL + '/ResolveLedgerContext';

// HS-P0-002 FIX
export const MaintenancePayment_ReconcilePayment = MaintenancePaymentURL + '/ReconcilePayment';

//#endregion

//#endregion


//#region MaintenancePayment
export const ParkingURL: string = SocietyBaseURL + '/PKG';
export const Parking_Create = ParkingURL + '/Create';
export const Parking_Update = ParkingURL + '/Update';
export const Parking_Delete = ParkingURL + '/Delete';
export const Parking_ReadAll = ParkingURL + '/ReadAll';
export const Parking_ReadById = ParkingURL + '/ReadById';
export const Parking_ReadBySocietyId = ParkingURL + '/ReadBySocietyId';
export const Parking_ReadByBuildingId = ParkingURL + '/ReadByBuildingId';
export const Parking_ReadByFlatId = ParkingURL + '/ReadByFlatId';
export const Parking_CreateBulk = ParkingURL + '/CreateBulk'


//#endregion


//#region RealEstate - UserPropertyShortlist API
export const UserPropertyShortlistURL: string = RealEstateBaseURL + '/UPS';
export const UserPropertyShortlist_Create: string = UserPropertyShortlistURL + '/Create';
export const UserPropertyShortlist_Update: string = UserPropertyShortlistURL + '/Update';
export const UserPropertyShortlist_Delete: string = UserPropertyShortlistURL + '/Delete';
export const UserPropertyShortlist_ReadAll: string = UserPropertyShortlistURL + '/ReadAll';
export const UserPropertyShortlist_ReadById: string = UserPropertyShortlistURL + '/ReadById';
export const UserPropertyShortlist_ReadByMasterId: string = UserPropertyShortlistURL + '/ReadByMasterId';
export const UserPropertyShortlist_ReadByUserId: string = UserPropertyShortlistURL + '/ReadByUserId';
export const UserPropertyShortlist_CheckShortlist: string = UserPropertyShortlistURL + '/CheckShortlist';
export const UserPropertyShortlist_GetUserShortlistProperties: string = UserPropertyShortlistURL + '/GetUserShortlistProperties';
export const UserPropertyShortlist_GetUserShortlistProject: string = UserPropertyShortlistURL + '/GetUserShortlistProject';
//#endRegion

//#region RealEstate - ReportedListing API
export const ReportedListingURL: string = RealEstateBaseURL + '/RL';
export const ReportedListing_Create: string = ReportedListingURL + '/Create';
export const ReportedListing_Update: string = ReportedListingURL + '/Update';
export const ReportedListing_Delete: string = ReportedListingURL + '/Delete';
export const ReportedListing_ReadAll: string = ReportedListingURL + '/ReadAll';
export const ReportedListing_ReadById: string = ReportedListingURL + '/ReadById';
export const ReportedListing_ReadByMasterId: string = ReportedListingURL + '/ReadByMasterId';
export const ReportedListing_ReadByBusinessId: string = ReportedListingURL + '/ReadByBusinessId';
export const ReportedListing_ReadByUserId: string = ReportedListingURL + '/ReadByUserId';
//#endRegion




//#region Facility
export const FacilityURL: string = SocietyBaseURL + '/FCL';
export const Facility_Create = FacilityURL + '/Create';
export const Facility_Update = FacilityURL + '/Update';
export const Facility_Delete = FacilityURL + '/Delete';
export const Facility_ReadAll = FacilityURL + '/ReadAll';
export const Facility_ReadBySocietyId = FacilityURL + '/ReadBySocietyId';
export const Facility_ReadById = FacilityURL + '/ReadById'
export const Facility_CreateBulk = FacilityURL + '/CreateBulk'
export const Facility_GetBookingDetailsBySocietyId = FacilityURL + '/GetBookingDetailsBySocietyId'
//#endregion

//#region MaintenanceLoan
export const MaintenanceLoanURL: string = SocietyBaseURL + '/ML';
export const MaintenanceLoan_Create = MaintenanceLoanURL + '/Create';
export const MaintenanceLoan_Update = MaintenanceLoanURL + '/Update';
export const MaintenanceLoan_Delete = MaintenanceLoanURL + '/Delete';
export const MaintenanceLoan_ReadAll = MaintenanceLoanURL + '/ReadAll';
export const MaintenanceLoan_ReadBySocietyId = MaintenanceLoanURL + '/ReadBySocietyId';
export const MaintenanceLoan_ReadById = MaintenanceLoanURL + '/ReadById'
export const MaintenanceLoan_ReadByFlatId = MaintenanceLoanURL + '/ReadByFlatId'
//#endregion

//#region FacilityBooking
export const FacilityBookingURL: string = SocietyBaseURL + '/FCLBK';
export const FacilityBooking_Create = FacilityBookingURL + '/Create';
export const FacilityBooking_Update = FacilityBookingURL + '/Update';
export const FacilityBooking_Delete = FacilityBookingURL + '/Delete';
export const FacilityBooking_ReadAll = FacilityBookingURL + '/ReadAll';
export const FacilityBooking_ReadById = FacilityBookingURL + '/ReadById'
export const FacilityBooking_ReadByFlatId = FacilityBookingURL + '/ReadByFlatId'
export const FacilityBooking_ReadByFacilityId = FacilityBookingURL + '/ReadByFacilityId'
export const FacilityBooking_ReadBySocietyId = FacilityBookingURL + '/ReadBySocietyId'
// 
//#endregion





//#region VehicleMaster API
export const VehicleMasterURL: string = SchoolBaseURL + '/VM';
export const VehicleMaster_Create: string = VehicleMasterURL + '/Create';
export const VehicleMaster_Update: string = VehicleMasterURL + '/Update';
export const VehicleMaster_ReadById: string = VehicleMasterURL + '/ReadById';
export const VehicleMaster_ReadBySchoolId: string = VehicleMasterURL + '/ReadBySchoolId';
export const VehicleMaster_Delete: string = VehicleMasterURL + '/Delete';
export const VehicleMaster_ReadAll = VehicleMasterURL + '/ReadAll';
export const VehicleMaster_ReadByVehicleNo = VehicleMasterURL + '/ReadByVehicleNo'
export const VehicleMaster_ReadAllPaginated = VehicleMasterURL + '/ReadAllPaginated';
export const VehicleMaster_CreateBulk = VehicleMasterURL + '/CreateBulk';
export const VehicleMaster_AssignmentProgress = VehicleMasterURL + '/VehicleAssignmentProgress'
//#endregion




//#region DriverMaster API
export const DriverMasterURL: string = SchoolBaseURL + '/DRM';
export const DriverMaster_Create: string = DriverMasterURL + '/Create';
export const DriverMaster_Update: string = DriverMasterURL + '/Update';
export const DriverMaster_ReadById: string = DriverMasterURL + '/ReadById';
export const DriverMaster_ReadBySchoolId: string = DriverMasterURL + '/ReadBySchoolId';
export const DriverMaster_Delete: string = DriverMasterURL + '/Delete';
export const DriverMaster_ReadAll = DriverMasterURL + '/ReadAll';
export const DriverMaster_ReadByUserId = DriverMasterURL + '/ReadByUserId'
export const DriverMaster_ReadAllPaginated = DriverMasterURL + '/ReadAllPaginated';
//#endregion




//#region VehicleDriverAssignment API
export const VehicleDriverAssignmentURL: string = SchoolBaseURL + '/VDM';
export const VehicleDriverAssignment_Create: string = VehicleDriverAssignmentURL + '/Create';
export const VehicleDriverAssignment_Update: string = VehicleDriverAssignmentURL + '/Update';
export const VehicleDriverAssignment_ReadById: string = VehicleDriverAssignmentURL + '/ReadById';
export const VehicleDriverAssignment_ReadByDriverId: string = VehicleDriverAssignmentURL + '/ReadByDriverId';
export const VehicleDriverAssignment_Delete: string = VehicleDriverAssignmentURL + '/Delete';
export const VehicleDriverAssignment_ReadAll = VehicleDriverAssignmentURL + '/ReadAll';
export const VehicleDriverAssignment_ReadByRouteId = VehicleDriverAssignmentURL + '/ReadByRouteId'
export const VehicleDriverAssignment_ReadByVehicleId = VehicleDriverAssignmentURL + '/ReadByVehicleId';
//#endregion

//#region SectionMaster API
export const SectionMasterURL: string = SchoolBaseURL + '/SM';
export const SectionMaster_Create: string = SectionMasterURL + '/Create';
export const SectionMaster_Update: string = SectionMasterURL + '/Update';
export const SectionMaster_ReadById: string = SectionMasterURL + '/ReadById';
export const SectionMaster_ReadByClassId: string = SectionMasterURL + '/ReadByClassId';
export const SectionMaster_Delete: string = SectionMasterURL + '/Delete';
export const SectionMaster_ReadAll = SectionMasterURL + '/ReadAll';
export const SectionMaster_CreateBulk = SectionMasterURL + '/CreateBulk'
export const SectionMaster_GetPendingFeeByClassId = SectionMasterURL + '/GetPendingFeeByClassId'
//#endregion

//#region VehicleRouteMaster API
export const VehicleRouteMasterURL: string = SchoolBaseURL + '/VRM';
export const VehicleRouteMaster_Create: string = VehicleRouteMasterURL + '/Create';
export const VehicleRouteMaster_Update: string = VehicleRouteMasterURL + '/Update';
export const VehicleRouteMaster_ReadById: string = VehicleRouteMasterURL + '/ReadById';
export const VehicleRouteMaster_ReadBySchoolId: string = VehicleRouteMasterURL + '/ReadBySchoolId';
export const VehicleRouteMaster_Delete: string = VehicleRouteMasterURL + '/Delete';
export const VehicleRouteMaster_ReadAll = VehicleRouteMasterURL + '/ReadAll';
//#endregion


//#region VehicleRouteDetail API
export const VehicleRouteDetailURL: string = SchoolBaseURL + '/VRD';
export const VehicleRouteDetail_Create: string = VehicleRouteDetailURL + '/Create';
export const VehicleRouteDetail_Update: string = VehicleRouteDetailURL + '/Update';
export const VehicleRouteDetail_ReadById: string = VehicleRouteDetailURL + '/ReadById';
export const VehicleRouteDetail_ReadByRouteId: string = VehicleRouteDetailURL + '/ReadByRouteId';
export const VehicleRouteDetail_Delete: string = VehicleRouteDetailURL + '/Delete';
export const VehicleRouteDetail_ReadAll = VehicleRouteDetailURL + '/ReadAll';
//#endregion

//#region VehicleRouteMapping API
export const VehicleRouteMappingURL: string = SchoolBaseURL + '/VERM';
export const VehicleRouteMapping_Create: string = VehicleRouteMappingURL + '/Create';
export const VehicleRouteMapping_Update: string = VehicleRouteMappingURL + '/Update';
export const VehicleRouteMapping_ReadById: string = VehicleRouteMappingURL + '/ReadById';
export const VehicleRouteMapping_ReadByRouteId: string = VehicleRouteMappingURL + '/ReadByRouteId';
export const VehicleRouteMapping_Delete: string = VehicleRouteMappingURL + '/Delete';
export const VehicleRouteMapping_ReadAll = VehicleRouteMappingURL + '/ReadAll';
export const VehicleRouteMapping_ReadByVehicleId: string = VehicleRouteMappingURL + '/ReadByVehicleId';
//#endregion

//#region StudentClassMapping API
export const StudentClassMappingURL: string = SchoolBaseURL + '/SCM';
export const StudentClassMapping_Create: string = StudentClassMappingURL + '/Create';
export const StudentClassMapping_Update: string = StudentClassMappingURL + '/Update';
export const StudentClassMapping_ReadById: string = StudentClassMappingURL + '/ReadById';
export const StudentClassMapping_Delete: string = StudentClassMappingURL + '/Delete';
export const StudentClassMapping_ReadAll = StudentClassMappingURL + '/ReadAll';
export const StudentClassMapping_ReadByClassId: string = StudentClassMappingURL + '/ReadByClassId';
export const StudentClassMapping_ReadBySectionId: string = StudentClassMappingURL + '/ReadBySectionId';
export const StudentClassMapping_ReadByUserId: string = StudentClassMappingURL + '/ReadByUserId';
export const StudentClassMapping_AutoAssignSection: string = StudentClassMappingURL + '/AutoAssignSection'
//#endregion


//#region StudentRouteMapping API
export const StudentRouteMappingURL: string = SchoolBaseURL + '/SRM';
export const StudentRouteMapping_Create: string = StudentRouteMappingURL + '/Create';
export const StudentRouteMapping_Update: string = StudentRouteMappingURL + '/Update';
export const StudentRouteMapping_ReadById: string = StudentRouteMappingURL + '/ReadById';
export const StudentRouteMapping_Delete: string = StudentRouteMappingURL + '/Delete';
export const StudentRouteMapping_ReadAll = StudentRouteMappingURL + '/ReadAll';
export const StudentRouteMapping_ReadByDropDetailId: string = StudentRouteMappingURL + '/ReadByDropDetailId';
export const StudentRouteMapping_ReadByPickupDetailId: string = StudentRouteMappingURL + '/ReadByPickupDetailId';
export const StudentRouteMapping_ReadByUserId: string = StudentRouteMappingURL + '/ReadByUserId';
//#endregion




//#region SubjectMaster API
export const SubjectMasterURL: string = SchoolBaseURL + '/SUM';
export const SubjectMaster_Create: string = SubjectMasterURL + '/Create';
export const SubjectMaster_Update: string = SubjectMasterURL + '/Update';
export const SubjectMaster_ReadById: string = SubjectMasterURL + '/ReadById';
export const SubjectMaster_Delete: string = SubjectMasterURL + '/Delete';
export const SubjectMaster_ReadAll = SubjectMasterURL + '/ReadAll';
export const SubjectMaster_ReadBySchoolId: string = SubjectMasterURL + '/ReadBySchoolId';
export const SubjectMaster_ReadByClassId: string = SubjectMasterURL + '/ReadByClassId';
export const SubjectMaster_CreateBulk: string = SubjectMasterURL + '/CreateBulk'
//#endregion

//#region CurriculumMaster API
export const CurriculumMasterURL: string = SchoolBaseURL + '/CUM';
export const CurriculumMaster_Create: string = CurriculumMasterURL + '/Create';
export const CurriculumMaster_Update: string = CurriculumMasterURL + '/Update';
export const CurriculumMaster_ReadById: string = CurriculumMasterURL + '/ReadById';
export const CurriculumMaster_Delete: string = CurriculumMasterURL + '/Delete';
export const CurriculumMaster_ReadAll = CurriculumMasterURL + '/ReadAll';
export const CurriculumMaster_ReadBySchoolId: string = CurriculumMasterURL + '/ReadBySchoolId';
export const CurriculumMaster_ReadByClassId: string = CurriculumMasterURL + '/ReadByClassId';
export const CurriculumMaster_CreateBulk: string = CurriculumMasterURL + '/CreateBulk'
//#endregion



//#region Announcement API
export const AnnouncementURL: string = SocietyBaseURL + '/AN';
export const Announcement_Create = AnnouncementURL + '/Create';
export const Announcement_Update = AnnouncementURL + '/Update';
export const Announcement_Delete = AnnouncementURL + '/Delete';
export const Announcement_ReadAll = AnnouncementURL + '/ReadAll';
export const Announcement_ReadById = AnnouncementURL + '/ReadById'
export const Announcement_ReadBySocietyId = AnnouncementURL + '/ReadBySocietyId'
//#endregion


//#region VotingMaster API
export const VotingMasterURL: string = SocietyBaseURL + '/VM';
export const VotingMaster_Create = VotingMasterURL + '/Create';
export const VotingMaster_Update = VotingMasterURL + '/Update';
export const VotingMaster_Delete = VotingMasterURL + '/Delete';
export const VotingMaster_ReadAll = VotingMasterURL + '/ReadAll';
export const VotingMaster_ReadById = VotingMasterURL + '/ReadById';
export const VotingMaster_ReadBySocietyId = VotingMasterURL + '/ReadBySocietyId';
//#endregion


//#region VotingDetail API
export const VotingDetailURL: string = SocietyBaseURL + '/VD';
export const VotingDetail_Create = VotingDetailURL + '/Create';
export const VotingDetail_Update = VotingDetailURL + '/Update';
export const VotingDetail_Delete = VotingDetailURL + '/Delete';
export const VotingDetail_ReadAll = VotingDetailURL + '/ReadAll';
export const VotingDetail_ReadById = VotingDetailURL + '/ReadById';
export const VotingDetail_ReadByUserId = VotingDetailURL + '/ReadByUserId';
export const VotingDetail_ReadByVotingId = VotingDetailURL + '/ReadByVotingId';
export const Votingdetail_ReadByFlatId = VotingDetailURL + '/ReadByFlatId'
//#endregion

//#region RealEstate - Onboarding
export const OnboardingPreCheckURL: string = RealEstateBaseURL + '/OBP';
export const OnboardingPreCheck_Create: string = OnboardingPreCheckURL + '/Create';
export const OnboardingPreCheck_Update: string = OnboardingPreCheckURL + '/Update';
export const OnboardingPreCheck_Delete: string = OnboardingPreCheckURL + '/Delete';
export const OnboardingPreCheck_ReadAll = OnboardingPreCheckURL + '/ReadAll';
export const OnboardingPreCheck_ReadById: string = OnboardingPreCheckURL + '/ReadById';
export const OnboardingPreCheck_ReadByBusinessId: string = OnboardingPreCheckURL + '/ReadByBusinessId';
//#endregion

//#region SM - Onboarding
export const SM_OnboardingPreCheckURL: string = SocietyBaseURL + '/OPC';
export const SM_OnboardingPreCheck_Create: string = SM_OnboardingPreCheckURL + '/Create';
export const SM_OnboardingPreCheck_Update: string = SM_OnboardingPreCheckURL + '/Update';
export const SM_OnboardingPreCheck_Delete: string = SM_OnboardingPreCheckURL + '/Delete';
export const SM_OnboardingPreCheck_ReadAll = SM_OnboardingPreCheckURL + '/ReadAll';
export const SM_OnboardingPreCheck_ReadById: string = SM_OnboardingPreCheckURL + '/ReadById';
export const SM_OnboardingPreCheck_ReadBySocietyId: string = SM_OnboardingPreCheckURL + '/ReadBySocietyId';
//#endregion

//#region School - Onboarding
export const SchoolOnboardingPreCheckURL: string = SchoolBaseURL + '/OBPC';
export const SchoolOnboardingPreCheck_Create: string = SchoolOnboardingPreCheckURL + '/Create';
export const SchoolOnboardingPreCheck_Update: string = SchoolOnboardingPreCheckURL + '/Update';
export const SchoolOnboardingPreCheck_Delete: string = SchoolOnboardingPreCheckURL + '/Delete';
export const SchoolOnboardingPreCheck_ReadAll: string = SchoolOnboardingPreCheckURL + '/ReadAll';
export const SchoolOnboardingPreCheck_ReadById: string = SchoolOnboardingPreCheckURL + '/ReadById';
export const SchoolOnboardingPreCheck_ReadBySchoolId: string = SchoolOnboardingPreCheckURL + '/ReadBySchoolId';
//#endregion
//#region StudentAdmission API
export const StudentAdmissionURL: string = SchoolBaseURL + '/SA';
export const StudentAdmission_AdmissionApprove: string = StudentAdmissionURL + '/AdmissionApprove';
export const StudentAdmission_Create: string = StudentAdmissionURL + '/Create';
export const StudentAdmission_ExternalCreate: string = StudentAdmissionURL + '/Create_External';
export const StudentAdmission_Update: string = StudentAdmissionURL + '/Update';
export const StudentAdmission_ReadById: string = StudentAdmissionURL + '/ReadById';
export const StudentAdmission_Delete: string = StudentAdmissionURL + '/Delete';
export const StudentAdmission_ReadAll = StudentAdmissionURL + '/ReadAll';
export const StudentAdmission_ReadBySchoolId: string = StudentAdmissionURL + '/ReadBySchoolId';
export const StudentAdmission_ReadByClassId: string = StudentAdmissionURL + '/ReadByClassId';
export const StudentAdmission_ReadBySUserId: string = StudentAdmissionURL + '/ReadBySUserId';
export const StudentAdmission_AdmissionList: string = StudentAdmissionURL + '/AdmissionList'
export const SStudentAdmission_ValidateBulk = StudentAdmissionURL + '/ValidateBulk';
export const SStudentAdmission_CreateBulk = StudentAdmissionURL + '/CreateBulk';
//#endregion

//#region StudentFeeStructureMapping API
export const StudentFeeStructureMappingURL: string = SchoolBaseURL + '/SFSM';
export const StudentFeeStructureMapping_Create: string = StudentFeeStructureMappingURL + '/Create';
export const StudentFeeStructureMapping_Update: string = StudentFeeStructureMappingURL + '/Update';
export const StudentFeeStructureMapping_ReadById: string = StudentFeeStructureMappingURL + '/ReadById';
export const StudentFeeStructureMapping_Delete: string = StudentFeeStructureMappingURL + '/Delete';
export const StudentFeeStructureMapping_ReadAll = StudentFeeStructureMappingURL + '/ReadAll';
export const StudentFeeStructureMapping_ReadByStudentId: string = StudentFeeStructureMappingURL + '/ReadByStudentId';
export const StudentFeeStructureMapping_ReadByClassId: string = StudentFeeStructureMappingURL + '/ReadByClassId';
export const StudentFeeStructureMapping_ReadByFeeStructureId: string = StudentFeeStructureMappingURL + '/ReadByFeeStructureId';
export const StudentFeeStructureMapping_AutoAssignFees: string = StudentFeeStructureMappingURL + '/AutoAssignFees';
//#endregion

//#region CurriculumSubjectMapping API
export const CurriculumSubjectMappingURL: string = SchoolBaseURL + '/CSM';
export const CurriculumSubjectMapping_Create: string = CurriculumSubjectMappingURL + '/Create';
export const CurriculumSubjectMapping_Update: string = CurriculumSubjectMappingURL + '/Update';
export const CurriculumSubjectMapping_ReadById: string = CurriculumSubjectMappingURL + '/ReadById';
export const CurriculumSubjectMapping_Delete: string = CurriculumSubjectMappingURL + '/Delete';
export const CurriculumSubjectMapping_ReadAll = CurriculumSubjectMappingURL + '/ReadAll';
export const CurriculumSubjectMapping_ReadBySubjectId: string = CurriculumSubjectMappingURL + '/ReadBySubjectId';
export const CurriculumSubjectMapping_ReadByClassId: string = CurriculumSubjectMappingURL + '/ReadByClassId';
export const CurriculumSubjectMapping_ReadByCurriculumId: string = CurriculumSubjectMappingURL + '/ReadByCurriculumId';
//#endregion

//#region RealEstate - Amenities Master
export const AmenitiesMasterURL: string = RealEstateBaseURL + '/ATM';
export const AmenitiesMaster_Create: string = AmenitiesMasterURL + '/Create';
export const AmenitiesMaster_Update: string = AmenitiesMasterURL + '/Update';
export const AmenitiesMaster_Delete: string = AmenitiesMasterURL + '/Delete';
export const AmenitiesMaster_ReadAll = AmenitiesMasterURL + '/ReadAll';
export const AmenitiesMaster_ReadById: string = AmenitiesMasterURL + '/ReadById';
export const AmenitiesMaster_ReadBySocietyId: string = AmenitiesMasterURL + '/ReadBySocietyId';
//#endregion

//#region Society - Security
export const SecurityURL: string = SocietyBaseURL + '/SCY';
export const Security_Create = SecurityURL + '/Create';
export const Security_Update = SecurityURL + '/Update';
export const Security_Delete = SecurityURL + '/Delete';
export const Security_ReadAll = SecurityURL + '/ReadAll';
export const Security_ReadById = SecurityURL + '/ReadById'
export const Security_ReadBySocietyId = SecurityURL + '/ReadBySocietyId'
export const Security_ReadByBuildingId = SecurityURL + '/ReadByBuildingId'
export const Security_ReadByFlatId = SecurityURL + '/ReadByFlatId'
export const Security_ReadByUserId = SecurityURL + '/ReadByUserId'
export const Security_GetVisitorDetail = SecurityURL + '/GetVisitorDetail'
export const Security_GetLatestVisitorByMobileNo = SecurityURL + '/GetLatestVisitorByMobileNo'
export const Security_GetVisitorCount = SecurityURL + '/GetVisitorCount'
//#endregion

//#region Society - Add Society Expense
export const SocietyExpenceURL: string = SocietyBaseURL + '/SE';

export const SocietyExpence_Create = SocietyExpenceURL + '/Create';
export const SocietyExpence_Update = SocietyExpenceURL + '/Update';
export const SocietyExpence_Delete = SocietyExpenceURL + '/Delete';
export const SocietyExpence_ReadAll = SocietyExpenceURL + '/ReadAll';
export const SocietyExpence_ReadById = SocietyExpenceURL + '/ReadById'
export const SocietyExpence_ReadBySocietyId: string = SocietyExpenceURL + "/ReadBySocietyId";

//#endregion



//#region TeacherClassSubjectMapping API
export const TeacherClassSubjectMappingURL: string = SchoolBaseURL + '/TCSM';
export const TeacherClassSubjectMapping_Create: string = TeacherClassSubjectMappingURL + '/Create';
export const TeacherClassSubjectMapping_Update: string = TeacherClassSubjectMappingURL + '/Update';
export const TeacherClassSubjectMapping_ReadById: string = TeacherClassSubjectMappingURL + '/ReadById';
export const TeacherClassSubjectMapping_Delete: string = TeacherClassSubjectMappingURL + '/Delete';
export const TeacherClassSubjectMapping_ReadAll = TeacherClassSubjectMappingURL + '/ReadAll';
export const TeacherClassSubjectMapping_ReadByTeacherId: string = TeacherClassSubjectMappingURL + '/ReadByTeacherId';
export const TeacherClassSubjectMapping_ReadBySchoolId: string = TeacherClassSubjectMappingURL + '/ReadBySchoolId';
export const TeacherClassSubjectMapping_ReadByClassId: string = TeacherClassSubjectMappingURL + '/ReadByClassId';
export const TeacherClassSubjectMapping_ReadBySubjectId: string = TeacherClassSubjectMappingURL + '/ReadBySubjectId';
//#endregion


//#region TeacherScheduleMaster API
export const TeacherScheduleMasterURL: string = SchoolBaseURL + '/TSM';
export const TeacherScheduleMaster_Create: string = TeacherScheduleMasterURL + '/Create';
export const TeacherScheduleMaster_Update: string = TeacherScheduleMasterURL + '/Update';
export const TeacherScheduleMaster_ReadById: string = TeacherScheduleMasterURL + '/ReadById';
export const TeacherScheduleMaster_Delete: string = TeacherScheduleMasterURL + '/Delete';
export const TeacherScheduleMaster_ReadAll = TeacherScheduleMasterURL + '/ReadAll';
export const TeacherScheduleMaster_ReadByTeacherId: string = TeacherScheduleMasterURL + '/ReadByTeacherId';
export const TeacherScheduleMaster_ReadBySchoolId: string = TeacherScheduleMasterURL + '/ReadBySchoolId';
export const TeacherScheduleMaster_ReadByClassId: string = TeacherScheduleMasterURL + '/ReadByClassId';
export const TeacherScheduleMaster_ReadBySubjectId: string = TeacherScheduleMasterURL + '/ReadBySubjectId';
export const TeacherScheduleMaster_ReadBySectionId: string = TeacherScheduleMasterURL + '/ReadBySectionId';
export const TeacherScheduleMaster_ScheduleCloner: string = TeacherScheduleMasterURL + '/ScheduleCloner';
export const TeacherScheduleMaster_ValidateBulk: string = TeacherScheduleMasterURL + '/ValidateBulk';
export const TeacherScheduleMaster_CreateBulk: string = TeacherScheduleMasterURL + '/CreateBulk';
//#endregion


//#region Class Attendance Master API
export const ClassAttendanceMasterURL: string = SchoolBaseURL + '/CLA';
export const ClassAttendanceMaster_Create: string = ClassAttendanceMasterURL + '/Create';
export const ClassAttendanceMaster_Update: string = ClassAttendanceMasterURL + '/Update';
export const ClassAttendanceMaster_ReadById: string = ClassAttendanceMasterURL + '/ReadById';
export const ClassAttendanceMaster_ReadBySchoolId: string = ClassAttendanceMasterURL + '/ReadBySchoolId';
export const ClassAttendanceMaster_ReadByDate: string = ClassAttendanceMasterURL + '/ReadByDate';
export const ClassAttendanceMaster_Delete: string = ClassAttendanceMasterURL + '/Delete';
//#endregion

//#region Class Attendance Detail API
export const ClassAttendanceDetailURL: string = SchoolBaseURL + '/CLAD';
export const ClassAttendanceDetail_Create: string = ClassAttendanceDetailURL + '/Create';
export const ClassAttendanceDetail_Update: string = ClassAttendanceDetailURL + '/Update';
export const ClassAttendanceDetail_ReadById: string = ClassAttendanceDetailURL + '/ReadById';
export const ClassAttendanceDetail_ReadByAttendanceId: string = ClassAttendanceDetailURL + '/ReadByAttendanceId';
export const ClassAttendanceDetail_Delete: string = ClassAttendanceDetailURL + '/Delete';
//#endregion

//#endregion

//#region RealEstate - Rental 
// ment API
export const RentalAgreementURL: string = RealEstateBaseURL + '/RA';
export const RentalAgreement_Create: string = RentalAgreementURL + '/Create';
export const RentalAgreement_Update: string = RentalAgreementURL + '/Update';
export const RentalAgreement_Delete: string = RentalAgreementURL + '/Delete';
export const RentalAgreement_ReadAll: string = RentalAgreementURL + '/ReadAll';
export const RentalAgreement_ReadById: string = RentalAgreementURL + '/ReadById';
export const RentalAgreement_ReadByPropertyId: string = RentalAgreementURL + '/ReadByPropertyId';
export const RentalAgreement_ReadByOwnerUserId: string = RentalAgreementURL + '/ReadByOwnerUserId';
export const RentalAgreement_ReadByTenantUserId: string = RentalAgreementURL + '/ReadByTenantUserId';
//#endRegion

//#region Document Template API 
export const DocumentTemplateURL: string = MasterBaseURL + '/DT';
export const DocumentTemplate_Create: string = DocumentTemplateURL + '/Create';
export const DocumentTemplate_Update: string = DocumentTemplateURL + '/Update';
export const DocumentTemplate_Delete: string = DocumentTemplateURL + '/Delete';
export const DocumentTemplate_ReadAll: string = DocumentTemplateURL + '/ReadAll';
export const DocumentTemplate_ReadById: string = DocumentTemplateURL + '/ReadById';
//#endRegion

//#region Document Template API 
export const DocumentTemplateVariablesURL: string = MasterBaseURL + '/DTV';
export const DocumentTemplateVariables_Create: string = DocumentTemplateVariablesURL + '/Create';
export const DocumentTemplateVariables_Update: string = DocumentTemplateVariablesURL + '/Update';
export const DocumentTemplateVariables_Delete: string = DocumentTemplateVariablesURL + '/Delete';
export const DocumentTemplateVariables_ReadAll: string = DocumentTemplateVariablesURL + '/ReadAll';
export const DocumentTemplateVariables_ReadById: string = DocumentTemplateVariablesURL + '/ReadById';
export const DocumentTemplateVariables_ReadByTemplateId: string = DocumentTemplateVariablesURL + '/ReadByTemplateId';
//#endRegion

//#region RealEstate - Property Inquiries API
export const PropertyInquiriesURL: string = RealEstateBaseURL + '/PI';
export const PropertyInquiries_Create: string = PropertyInquiriesURL + '/Create';
export const PropertyInquiries_Update: string = PropertyInquiriesURL + '/Update';
export const PropertyInquiries_Delete: string = PropertyInquiriesURL + '/Delete';
export const PropertyInquiries_ReadAll: string = PropertyInquiriesURL + '/ReadAll';
export const PropertyInquiries_ReadById: string = PropertyInquiriesURL + '/ReadById';
export const PropertyInquiries_ReadByMasterId: string = PropertyInquiriesURL + '/ReadByMasterId';
export const PropertyInquiries_ReadByOwnerUserId: string = PropertyInquiriesURL + '/ReadByOwnerUserId';
export const PropertyInquiries_ReadByUserId: string = PropertyInquiriesURL + '/ReadByUserId';
export const PropertyInquiries_CheckIfUserEnquired: string = PropertyInquiriesURL + '/CheckIfUserEnquired';
export const PropertyInquiries_GetEnquiredUserDetails: string = PropertyInquiriesURL + '/GetEnquiredUserDetails';
//#endRegion

//#region NotificationMaster API
export const NotificationMasterURL: string = NotificationBaseURL + '/NM';
export const NotificationMaster_Create: string = NotificationMasterURL + '/Create';
export const NotificationMaster_ExternalCreate: string = NotificationMasterURL + '/Create_External';
export const NotificationMaster_ReadAll: string = NotificationMasterURL + '/ReadAll';
export const NotificationMaster_ReadAllPaginated: string = NotificationMasterURL + '/NotificationMasterReadAllPaginated';
//#endRegion






//#region AssignmentMaster API
export const AssignmentMasterURL: string = SchoolBaseURL + '/AM';
export const AssignmentMaster_Create: string = AssignmentMasterURL + '/Create';
export const AssignmentMaster_Update: string = AssignmentMasterURL + '/Update';
export const AssignmentMaster_ReadById: string = AssignmentMasterURL + '/ReadById';
export const AssignmentMaster_ReadBySchoolId: string = AssignmentMasterURL + '/ReadBySchoolId';
export const AssignmentMaster_Delete: string = AssignmentMasterURL + '/Delete';
export const AssignmentMaster_ReadAll = AssignmentMasterURL + '/ReadAll';
export const AssignmentMaster_ReadByTeacherId: string = AssignmentMasterURL + '/ReadByTeacherId';
export const AssignmentMaster_ReadByClassId: string = AssignmentMasterURL + '/ReadByClassId';
export const AssignmentMaster_ReadBySubjectId: string = AssignmentMasterURL + '/ReadBySubjectId';
export const AssignmentMaster_ReadByClassSubject: string = AssignmentMasterURL + '/ReadByClassSubject';
export const AssignmentMaster_GetAssignmentInfo: string = AssignmentMasterURL + '/GetAssignmentInfo'
//#endregion


//#region StudentAssignmentSubmission API
export const StudentAssignmentSubmissionURL: string = SchoolBaseURL + '/SAS';
export const StudentAssignmentSubmission_Create: string = StudentAssignmentSubmissionURL + '/Create';
export const StudentAssignmentSubmission_Update: string = StudentAssignmentSubmissionURL + '/Update';
export const StudentAssignmentSubmission_ReadById: string = StudentAssignmentSubmissionURL + '/ReadById';
export const StudentAssignmentSubmission_ReadByAssignmentId: string = StudentAssignmentSubmissionURL + '/ReadByAssignmentId';
export const StudentAssignmentSubmission_Delete: string = StudentAssignmentSubmissionURL + '/Delete';
export const StudentAssignmentSubmission_ReadAll = StudentAssignmentSubmissionURL + '/ReadAll';
export const StudentAssignmentSubmission_ReadByStudentId: string = StudentAssignmentSubmissionURL + '/ReadByStudentId';
export const StudentAssignmentSubmission_ReadByAssignmentAndStudent: string = StudentAssignmentSubmissionURL + '/ReadByAssignmentAndStudent'
//#endregion

//#region ExamMaster API
export const ExamMasterURL: string = SchoolBaseURL + '/EM';
export const ExamMaster_Create: string = ExamMasterURL + '/Create';
export const ExamMaster_Update: string = ExamMasterURL + '/Update';
export const ExamMaster_ReadById: string = ExamMasterURL + '/ReadById';
export const ExamMaster_ReadBySchoolId: string = ExamMasterURL + '/ReadBySchoolId';
export const ExamMaster_Delete: string = ExamMasterURL + '/Delete';
export const ExamMaster_ReadAll = ExamMasterURL + '/ReadAll';
export const ExamMaster_ReadAllPaginated = ExamMasterURL + '/ReadAllPaginated'
export const ExamMaster_CreateBulk: string = ExamMasterURL + '/CreateBulk';
//#endregion



//#region ExamSchedule API
export const ExamScheduleURL: string = SchoolBaseURL + '/ES';
export const ExamSchedule_Create: string = ExamScheduleURL + '/Create';
export const ExamSchedule_Update: string = ExamScheduleURL + '/Update';
export const ExamSchedule_ReadById: string = ExamScheduleURL + '/ReadById';
export const ExamSchedule_Delete: string = ExamScheduleURL + '/Delete';
export const ExamSchedule_ReadAll = ExamScheduleURL + '/ReadAll';
export const ExamSchedule_ReadByExamId: string = ExamScheduleURL + '/ReadByExamId';
export const ExamSchedule_ReadByClassId: string = ExamScheduleURL + '/ReadByClassId';
export const ExamSchedule_ReadBySubjectId: string = ExamScheduleURL + '/ReadBySubjectId';
export const ExamSchedule_ReadAllPaginated: string = ExamScheduleURL + '/ReadAllPaginated';
export const ExamSchedule_PublishResult: string = ExamScheduleURL + '/PublishResult'
//#endregion


//#region StudentExamMarks API
export const StudentExamMarksURL: string = SchoolBaseURL + '/SEM';
export const StudentExamMarks_Create: string = StudentExamMarksURL + '/Create';
export const StudentExamMarks_Update: string = StudentExamMarksURL + '/Update';
export const StudentExamMarks_ReadById: string = StudentExamMarksURL + '/ReadById';
export const StudentExamMarks_Delete: string = StudentExamMarksURL + '/Delete';
export const StudentExamMarks_ReadAll = StudentExamMarksURL + '/ReadAll';
export const StudentExamMarks_ReadByScheduleId: string = StudentExamMarksURL + '/ReadByScheduleId';
export const StudentExamMarks_ReadByStudentId: string = StudentExamMarksURL + '/ReadByStudentId';
export const StudentExamMarks_BulkCreate: string = StudentExamMarksURL + '/BulkCreate';
export const StudentExamMarks_ReadByStudent: string = StudentExamMarksURL + '/ReadByStudent';
export const StudentExamMarks_ReadBySubject: string = StudentExamMarksURL + '/ReadBySubject';
export const StudentExamMarks_ReadBySchoolClassSection: string = StudentExamMarksURL + '/ReadBySchoolClassSection';
export const StudentExamMarks_DownloadBulkTemplate: string = StudentExamMarksURL + '/DownloadBulkTemplate';
export const StudentExamMarks_UploadBulkMarks: string = StudentExamMarksURL + '/UploadBulkMarks';
export const StudentExamMarks_ExcelBulkCreate: string = StudentExamMarksURL + '/ExcelBulkCreate';

//#region SocietyImgMaster API
export const SocietyImgMasterURL: string = SocietyBaseURL + '/SIM';
export const SocietyImgMaster_Create: string = SocietyImgMasterURL + '/Create';
export const SocietyImgMaster_Update: string = SocietyImgMasterURL + '/Update';
export const SocietyImgMaster_ReadById: string = SocietyImgMasterURL + '/ReadById';
export const SocietyImgMaster_ReadByMasterId: string = SocietyImgMasterURL + '/ReadByMasterId';
export const SocietyImgMaster_ReadByMasterType: string = SocietyImgMasterURL + '/ReadByMasterType';
export const SocietyImgMaster_Delete: string = SocietyImgMasterURL + '/Delete';
export const SocietyImgMaster_ReadAll = SocietyImgMasterURL + '/ReadAll';
//#endregion


//#region RealEstate - Project API
export const ProjectURL: string = RealEstateBaseURL + '/PJT';
export const Project_Create: string = ProjectURL + '/Create';
export const Project_Update: string = ProjectURL + '/Update';
export const Project_Delete: string = ProjectURL + '/Delete';
export const Project_ReadAll: string = ProjectURL + '/ReadAll';
export const Project_ReadById: string = ProjectURL + '/ReadById';
export const Project_ReadByBusinessId: string = ProjectURL + '/ReadByBusinessId';
export const Project_ReadAllPaginated: string = ProjectURL + '/ReadAllPaginated';
export const Project_GetDetail: string = ProjectURL + '/GetDetail';
export const Project_CreateFlatBulk: string = ProjectURL + '/CreateFlatBulk';
export const Project_GetFlatListForProjectForm: string = ProjectURL + '/GetFlatListForProjectForm';
export const Project_GetProjectEntitiesForEdit: string = ProjectURL + '/GetProjectEntitiesForEdit';
export const Project_GetDictionary: string = ProjectURL + '/GetDictionary';
export const Project_CreateParkingBulk: string = ProjectURL + '/ParkingBulkCreate';
export const Project_GetParkingListForProjectForm: string = ProjectURL + '/GetParkingListForProject';
//#endRegion

//#region RealEstate - ProjectBuilding API
export const ProjectBuildingURL: string = RealEstateBaseURL + '/PB';
export const ProjectBuilding_Create: string = ProjectBuildingURL + '/Create';
export const ProjectBuilding_Update: string = ProjectBuildingURL + '/Update';
export const ProjectBuilding_Delete: string = ProjectBuildingURL + '/Delete';
export const ProjectBuilding_ReadAll: string = ProjectBuildingURL + '/ReadAll';
export const ProjectBuilding_ReadById: string = ProjectBuildingURL + '/ReadById';
export const ProjectBuilding_ReadByProjectId: string = ProjectBuildingURL + '/ReadByProjectId';
export const ProjectBuilding_GetDictionary: string = ProjectBuildingURL + '/GetDictionary';
//#endRegion

//#region RealEstate - ProjectUnitType API
export const ProjectUnitTypeURL: string = RealEstateBaseURL + '/PUT';
export const ProjectUnitType_Create: string = ProjectUnitTypeURL + '/Create';
export const ProjectUnitType_Update: string = ProjectUnitTypeURL + '/Update';
export const ProjectUnitType_Delete: string = ProjectUnitTypeURL + '/Delete';
export const ProjectUnitType_ReadAll: string = ProjectUnitTypeURL + '/ReadAll';
export const ProjectUnitType_ReadById: string = ProjectUnitTypeURL + '/ReadById';
export const ProjectUnitType_ReadByProjectId: string = ProjectUnitTypeURL + '/ReadByProjectId';
export const ProjectUnitType_ReadByBuildingId: string = ProjectUnitTypeURL + '/ReadByBuildingId';
export const ProjectUnitType_GetDictionary: string = ProjectUnitTypeURL + '/GetDictionary';
//#endRegion

//#region School - SchoolAnnouncement API
export const SchoolAnnouncementURL: string = SchoolBaseURL + '/ANN';
export const SchoolAnnouncement_Create: string = SchoolAnnouncementURL + '/Create';
export const SchoolAnnouncement_Update: string = SchoolAnnouncementURL + '/Update';
export const SchoolAnnouncement_ReadById: string = SchoolAnnouncementURL + '/ReadById';
export const SchoolAnnouncement_Delete: string = SchoolAnnouncementURL + '/Delete';
export const SchoolAnnouncement_ReadAll: string = SchoolAnnouncementURL + '/ReadAll';
export const SchoolAnnouncement_ReadBySchoolId: string = SchoolAnnouncementURL + '/ReadBySchoolId';
//#endregion


//#region School - SchoolFeedback API
export const SchoolFeedbackURL: string = SchoolBaseURL + '/FB';
export const SchoolFeedback_Create: string = SchoolFeedbackURL + '/Create';
export const SchoolFeedback_Update: string = SchoolFeedbackURL + '/Update';
export const SchoolFeedback_ReadById: string = SchoolFeedbackURL + '/ReadById';
export const SchoolFeedback_Delete: string = SchoolFeedbackURL + '/Delete';
export const SchoolFeedback_ReadAll: string = SchoolFeedbackURL + '/ReadAll';
export const SchoolFeedback_ReadByMasterId: string = SchoolFeedbackURL + '/ReadByMasterId';
export const SchoolFeedback_ReadByTeacherId: string = SchoolFeedbackURL + '/ReadByTeacherId';
export const SchoolFeedback_ReadBySchoolId: string = SchoolFeedbackURL + '/ReadBySchoolId';
//#endregion

//#region Paylater - CreditEngineConfiguration API
export const CreditEngineConfigurationURL: string = PayLaterBaseURL + '/CEC';
export const CreditEngineConfiguration_Create: string = CreditEngineConfigurationURL + '/Create';
export const CreditEngineConfiguration_Update: string = CreditEngineConfigurationURL + '/Update';
export const CreditEngineConfiguration_Delete: string = CreditEngineConfigurationURL + '/Delete';
export const CreditEngineConfiguration_ReadAll: string = CreditEngineConfigurationURL + '/ReadAll';
export const CreditEngineConfiguration_ReadById: string = CreditEngineConfigurationURL + '/ReadById';
export const CreditEngineConfiguration_ReadByMasterId: string = CreditEngineConfigurationURL + '/ReadByMasterId';
export const CreditEngineConfiguration_GetByLoanEligibilityCriteria: string = CreditEngineConfigurationURL + '/GetByLoanEligibilityCriteria';
export const CreditEngineConfiguration_ReadAllPaginated: string = CreditEngineConfigurationURL + '/ReadAllPaginated';
export const CreditEngineConfiguration_CreateBulk: string = CreditEngineConfigurationURL + '/CreateBulk';
//#endregion

//#region  Paylater - LoanApplication API
export const LoanApplicationURL: string = PayLaterBaseURL + '/APP';
export const LoanApplication_Create: string = LoanApplicationURL + '/Create';
export const LoanApplication_Delete: string = LoanApplicationURL + '/Delete';
export const LoanApplication_Update: string = LoanApplicationURL + '/Update';
export const LoanApplication_ReadAll: string = LoanApplicationURL + '/ReadAll';
export const LoanApplication_ReadById: string = LoanApplicationURL + '/ReadById';
export const LoanApplication_ReadByUserId: string = LoanApplicationURL + '/ReadByUserId';
export const LoanApplication_ReadByProductId: string = LoanApplicationURL + '/ReadByProductId';
export const LoanApplication_ReadByBusinessId: string = LoanApplicationURL + '/ReadByBusinessId';
export const LoanApplication_ReadBySubUserId: string = LoanApplicationURL + '/ReadBySubUserId';
export const LoanApplication_ReadAllPaginated: string = LoanApplicationURL + '/ReadAllPaginated';
export const LoanApplication_CreditEngineData: string = LoanApplicationURL + '/CreditEngineData';
export const LoanApplication_ExecuteFraudDetection: string = LoanApplicationURL + '/ExecuteFraudDetection';
//#endregion

//#region Common - Discussion Master
export const DiscussionMasterURL: string = SchoolBaseURL + '/DM';
export const DiscussionMaster_Create: string = DiscussionMasterURL + '/Create';
export const DiscussionMaster_Update: string = DiscussionMasterURL + '/Update';
export const DiscussionMaster_ReadById: string = DiscussionMasterURL + '/ReadById';
export const DiscussionMaster_ReadByMasterId: string = DiscussionMasterURL + '/ReadByMasterId';
export const DiscussionMaster_Delete: string = DiscussionMasterURL + '/Delete';
export const DiscussionMaster_ReadAll = DiscussionMasterURL + '/ReadAll';
export const DiscussionMaster_ReadByUserId = DiscussionMasterURL + '/ReadByUserId';
export const DiscussionMaster_GetDiscussionList = DiscussionMasterURL + '/GetDiscussionList';
export const DiscussionMaster_GetOrCreateOneToOne = DiscussionMasterURL + '/GetOrCreateOneToOne';
export const DiscussionMaster_CreateGroup = DiscussionMasterURL + '/CreateGroup';
export const DiscussionMaster_GetDiscussionUserList = DiscussionMasterURL + '/GetDiscussionUserList';
//endregion

//#region
export const DiscussionDetailURL: string = SchoolBaseURL + '/DD';
export const DiscussionDetail_Create: string = DiscussionDetailURL + '/Create';
export const DiscussionDetail_Update: string = DiscussionDetailURL + '/Update';
export const DiscussionDetail_ReadById: string = DiscussionDetailURL + '/ReadById';
export const DiscussionDetail_ReadByDiscussionId: string = DiscussionDetailURL + '/ReadByDiscussionId';
export const DiscussionDetail_Delete: string = DiscussionDetailURL + '/Delete';
export const DiscussionDetail_ReadAll = DiscussionDetailURL + '/ReadAll';
export const DiscussionDetail_WS_Connect = DiscussionDetailURL + '/ws/DiscussionDetail/connect';
export const DiscussionMaster_WS_Connect = DiscussionDetailURL + '/ws/DiscussionMaster/connect';
export const DiscussionDetail_MarkAsRead = DiscussionDetailURL + '/MarkAsRead';
//endregion



//#region
export const DiscussionParticipantsURL: string = SchoolBaseURL + '/DPS';
export const DiscussionParticipants_Create: string = DiscussionParticipantsURL + '/Create';
export const DiscussionParticipants_Update: string = DiscussionParticipantsURL + '/Update';
export const DiscussionParticipants_ReadById: string = DiscussionParticipantsURL + '/ReadById';
export const DiscussionParticipants_ReadByDiscussionId: string = DiscussionParticipantsURL + '/ReadByDiscussionId';
export const DiscussionParticipants_ReadByUserId: string = DiscussionParticipantsURL + '/ReadByUserId';
export const DiscussionParticipants_Delete: string = DiscussionParticipantsURL + '/Delete';
export const DiscussionParticipants_ReadAll = DiscussionParticipantsURL + '/ReadAll';
//endregion



//#region HousingSociety - SocietyInvoiceMaster API
export const SocietyInvoiceMasterURL: string = SocietyBaseURL + '/IM';
export const SocietyInvoiceMaster_Create: string = SocietyInvoiceMasterURL + '/Create';
export const SocietyInvoiceMaster_Update: string = SocietyInvoiceMasterURL + '/Update';
export const SocietyInvoiceMaster_ReadAll: string = SocietyInvoiceMasterURL + '/ReadAll';
export const SocietyInvoiceMaster_ReadById: string = SocietyInvoiceMasterURL + '/ReadById';
export const SocietyInvoiceMaster_Delete: string = SocietyInvoiceMasterURL + '/Delete';
export const SocietyInvoiceMaster_ReadByMasterId: string = SocietyInvoiceMasterURL + '/ReadByMasterId';
//#endregion

//#region HousingSociety - SocietyInvoiceDetail API
export const SocietyInvoiceDetailURL: string = SocietyBaseURL + '/ID';
export const SocietyInvoiceDetail_Create: string = SocietyInvoiceDetailURL + '/Create';
export const SocietyInvoiceDetail_Update: string = SocietyInvoiceDetailURL + '/Update';
export const SocietyInvoiceDetail_ReadAll: string = SocietyInvoiceDetailURL + '/ReadAll';
export const SocietyInvoiceDetail_ReadById: string = SocietyInvoiceDetailURL + '/ReadById';
export const SocietyInvoiceDetail_Delete: string = SocietyInvoiceDetailURL + '/Delete';
export const SocietyInvoiceDetail_ReadByMasterId: string = SocietyInvoiceDetailURL + '/ReadByMasterId';
//#endregion

//#region School - ReceiptMaster API
export const SchoolInvoiceMasterURL: string = SchoolBaseURL + '/IM';
export const SchoolInvoiceMaster_Create: string = SchoolInvoiceMasterURL + '/Create';
export const SchoolInvoiceMaster_Update: string = SchoolInvoiceMasterURL + '/Update';
export const SchoolInvoiceMaster_ReadAll: string = SchoolInvoiceMasterURL + '/ReadAll';
export const SchoolInvoiceMaster_ReadById: string = SchoolInvoiceMasterURL + '/ReadById';
export const SchoolInvoiceMaster_Delete: string = SchoolInvoiceMasterURL + '/Delete';
// export const SchoolInvoiceMaster_ReadByMasterId: string = SchoolInvoiceMasterURL + '/ReadByMasterId';
export const SchoolInvoiceMaster_ReadAllPaginated: string = SchoolInvoiceMasterURL + '/ReadAllPaginated'
//#endregion

//#region School - ReceiptDetail API
export const SchoolInvoiceDetailURL: string = SchoolBaseURL + '/ID';
export const SchoolInvoiceDetail_Create: string = SchoolInvoiceDetailURL + '/Create';
export const SchoolInvoiceDetail_Update: string = SchoolInvoiceDetailURL + '/Update';
export const SchoolInvoiceDetail_ReadAll: string = SchoolInvoiceDetailURL + '/ReadAll';
export const SchoolInvoiceDetail_ReadById: string = SchoolInvoiceDetailURL + '/ReadById';
export const SchoolInvoiceDetail_Delete: string = SchoolInvoiceDetailURL + '/Delete';
export const SchoolInvoiceDetail_ReadByMasterId: string = SchoolInvoiceDetailURL + '/ReadByMasterId';
export const SchoolInvoiceDetail_ReadByInvoiceId: string = SchoolInvoiceDetailURL + '/ReadByInvoiceId';
//#endregion

//#region Housing society - DicussionMaster
export const SMDiscussionMasterURL: string = SocietyBaseURL + '/DM';
export const SM_DiscussionMaster_Create: string = SMDiscussionMasterURL + '/Create';
export const SM_DiscussionMaster_Update: string = SMDiscussionMasterURL + '/Update';
export const SM_DiscussionMaster_Delete: string = SMDiscussionMasterURL + '/Delete';
export const SM_DiscussionMaster_ReadBySocietyId: string = SMDiscussionMasterURL + '/ReadBySocietyId';
export const SM_DiscussionMaster_ReadByBuildingId: string = SMDiscussionMasterURL + '/ReadByBuildingId';
export const SM_DiscussionMaster_ReadAll = SMDiscussionMasterURL + '/ReadAll';
export const SM_DiscussionMaster_ReadById = SMDiscussionMasterURL + '/ReadById';
export const SM_DiscussionMaster_GetOrCreateOneToOne = SMDiscussionMasterURL + '/GetOrCreateOneToOne';
export const SM_DiscussionMaster_CreateGroupByBuildingOrWing = SMDiscussionMasterURL + '/CreateGroupByBuildingOrWing';
export const SM_DiscussionMaster_GetDiscussionList = SMDiscussionMasterURL + '/GetDiscussionList'
//#endregion

//#region Housing society - DicussionDetail
export const SMDiscussionDetailURL: string = SocietyBaseURL + '/DD';
export const SM_DiscussionDetail_Create: string = SMDiscussionDetailURL + '/Create';
export const SM_DiscussionDetail_Update: string = SMDiscussionDetailURL + '/Update';
export const SM_DiscussionDetail_Delete: string = SMDiscussionDetailURL + '/Delete';
export const SM_DiscussionDetail_ReadByDiscussionId: string = SMDiscussionDetailURL + '/ReadByDiscussionId';
export const SM_DiscussionDetail_ReadAll = SMDiscussionDetailURL + '/ReadAll';
export const SM_DiscussionDetail_ReadById = SMDiscussionDetailURL + '/ReadById';
export const SM_DiscussionDetail_MarkAsRead = SMDiscussionDetailURL + '/MarkAsRead'
export const SM_DiscussionDetail_Ws_Connect: string = SMDiscussionDetailURL + '/ws/DiscussionDetail/connect'
export const SM_DiscussionMaster_WS_Connect: string = SMDiscussionDetailURL + '/ws/DiscussionMaster/connect'
//#endregion

//#region Housing society - DiscussionParticipants

export const SMDiscussionParticipantsURL: string =
  SocietyBaseURL + '/DPS';

export const SM_DiscussionParticipants_Create: string =
  SMDiscussionParticipantsURL + '/Create';

export const SM_DiscussionParticipants_Delete: string =
  SMDiscussionParticipantsURL + '/Delete';

export const SM_DiscussionParticipants_ReadByDiscussionId: string =
  SMDiscussionParticipantsURL + '/ReadByDiscussionId';

//#endregion

//#region RazorPay
export const RazorPayURL: string = PayLaterBaseURL + '/RP';
export const RazorPay_CreateOrder: string = RazorPayURL + '/ORD/Create';
//#endregion

// #region Receipt Master
export const PayLater_ReceiptMasterURL: string = PayLaterBaseURL + '/RM';
export const PayLater_ReceiptMaster_Create: string = PayLater_ReceiptMasterURL + '/Create'
export const PayLater_ReceiptMaster_Delete: string = PayLater_ReceiptMasterURL + '/Delete'
export const PayLater_ReceiptMaster_Update: string = PayLater_ReceiptMasterURL + '/Update'
export const PayLater_ReceiptMaster_ReadById: string = PayLater_ReceiptMasterURL + '/ReadById'
export const PayLater_ReceiptMaster_ReadAll: string = PayLater_ReceiptMasterURL + '/ReadAll'
export const PayLater_ReceiptMaster_GetAmountByPRRN: string = PayLater_ReceiptMasterURL + '/GetAmountByPRRN'
// #endregion

//#region Razorpay Payments
export const Razorpay_PaymentsURL: string = RazorPayURL + '/PAY';
export const RazorPay_Pay_Id: string = Razorpay_PaymentsURL + '/Create';
//#endregion

//#region RealEstate - FeedbackMaster API
export const RE_FeedbackMasterURL: string = RealEstateBaseURL + '/FM';
export const RE_FeedbackMaster_Create: string = RE_FeedbackMasterURL + '/Create';
export const RE_FeedbackMaster_Update: string = RE_FeedbackMasterURL + '/Update';
export const RE_FeedbackMaster_Delete: string = RE_FeedbackMasterURL + '/Delete';
export const RE_FeedbackMaster_ReadAll: string = RE_FeedbackMasterURL + '/ReadAll';
export const RE_FeedbackMaster_ReadById: string = RE_FeedbackMasterURL + '/ReadById';
export const RE_FeedbackMaster_ReadByBusinessId: string = RE_FeedbackMasterURL + '/ReadByBusinessId';
export const RE_FeedbackMaster_ReadByMasterId: string = RE_FeedbackMasterURL + '/ReadByMasterId';
//#endRegion

//#region PrintMaster API
export const PrintMasterURL: string = MasterBaseURL + '/PRT';
export const PrintMaster_PrintDynamicSQL: string = PrintMasterURL + '/PrintDynamicSQL';
export const PrintMaster_DynamicSqlTemplateGeneration: string = PrintMasterURL + '/dynamicSqlTemplateGeneration';
export const PrintMaster_UpdateSqlTemplate: string = PrintMasterURL + '/updateSqlTemplate';
//#endRegion


//#region School - ReceiptDetail API
export const SchoolEventMasterURL: string = SchoolBaseURL + '/EVM';
export const SchoolEventMaster_Create: string = SchoolEventMasterURL + '/Create';
export const SchoolEventMaster_Update: string = SchoolEventMasterURL + '/Update';
export const SchoolEventMaster_ReadAll: string = SchoolEventMasterURL + '/ReadAll';
export const SchoolEventMaster_ReadById: string = SchoolEventMasterURL + '/ReadById';
export const SchoolEventMaster_Delete: string = SchoolEventMasterURL + '/Delete';
export const SchoolEventMaster_ReadBySchoolId: string = SchoolEventMasterURL + '/ReadBySchoolId';
export const SchoolEventMaster_ReadByClassId: string = SchoolEventMasterURL + '/ReadByClassId';
export const SchoolEventMaster_ReadBySectionId: string = SchoolEventMasterURL + '/ReadBySectionId';
//#endregion

//region AI_OperAI ChatGpt API
export const ChatGPTMasterURL: string = AIBaseURL + '/GPT';
export const AskGPTWithFilesMasterURL: string = ChatGPTMasterURL + '/AskChatGPTWithFiles';
export const AskGPTWithImagesMasterURL: string = ChatGPTMasterURL + '/AskChatGPTWithImages';
export const GeminiMasterURL: string = AIBaseURL + '/GAI';
export const AskGeminiMasterURL: string = GeminiMasterURL + '/AskGemini';
//#endregion

//#region Scoreme KYC
export const ScoremeKYCMasterURL: string = PayLaterBaseURL + '/SMK';
export const ScoremePanVerification: string = ScoremeKYCMasterURL + '/PanVerification';
export const ScoremeInitiateDigilocker: string = ScoremeKYCMasterURL + '/InitiateDigilocker'
export const ScoremeDocumentConsentStatus: string = ScoremeKYCMasterURL + '/DocumentConsentStatus'
export const ScoremeAadhaarOtpGeneration: string = ScoremeKYCMasterURL + '/AadhaarOtpGeneration'
export const ScoremeAadhaarOtpVerification: string = ScoremeKYCMasterURL + '/AadhaarOtpVerification'
export const ScoremeCreditBureauRetail: string = ScoremeKYCMasterURL + '/CreditBureauData'
export const ScoremeCreditBureauValidateOtp: string = ScoremeKYCMasterURL + '/CreditBureauValidateOtp'
export const ScoremeCreditBureauResendOtp: string = ScoremeKYCMasterURL + '/CreditBureauResendOtp'
export const ScoremeCreditBureauReport: string = ScoremeKYCMasterURL + '/CreditBureauReport'
export const ScoremeCreditBureauData: string = ScoremeKYCMasterURL + '/BDAResponse'
export const GenerateBureauReportUI: string = ScoremeKYCMasterURL + '/GenerateBureauReportUI'
//#endregion

//#region RealEstate - REBackendDiscount API
export const REBackendDiscountURL: string = RealEstateBaseURL + '/REBD';
export const REBackendDiscount_Create: string = REBackendDiscountURL + '/Create';
export const REBackendDiscount_Update: string = REBackendDiscountURL + '/Update';
export const REBackendDiscount_ReadAll: string = REBackendDiscountURL + '/ReadAll';
export const REBackendDiscount_ReadAllPaginated: string = REBackendDiscountURL + '/ReadAllPaginated';
export const REBackendDiscount_ReadById: string = REBackendDiscountURL + '/ReadById';
export const REBackendDiscount_Delete: string = REBackendDiscountURL + '/Delete';
export const REBackendDiscount_ReadByBuildingId: string = REBackendDiscountURL + '/ReadByBuildingId';
export const REBackendDiscount_ReadByBusinessId: string = REBackendDiscountURL + '/ReadByBusinessId';
export const REBackendDiscount_ReadByProjectId: string = REBackendDiscountURL + '/ReadByProjectId';
export const REBackendDiscount_ReadByUnitTypeId: string = REBackendDiscountURL + '/ReadByUnitTypeId';
//#endregion

//#region PushNotificationConfig API
export const PushNotificationConfigURL: string = NotificationBaseURL + '/PNC';
export const PushNotificationConfig_Register: string = PushNotificationConfigURL + '/Register';
//#endRegion

//#region PayLater - BureauKYC API's
export const BureauKYCMasterURL: string = PayLaterBaseURL + '/BKYC';
export const BureauDigilockerGenerateAuthURL: string = BureauKYCMasterURL + '/DigilockerGenerateAuthUrl';
export const BureauDigilockerGetDetails: string = BureauKYCMasterURL + '/DigilockerGetDetails';
export const FraudDetection: string = BureauKYCMasterURL + '/FraudDetection';
//#endregion

// //#region SchoolPrintMaster API
// export const SchoolPrintMasterURL: string = SchoolBaseURL + '/PM';
// export const SchoolPrintMaster_ReadByMasterType: string = SchoolPrintMasterURL + '/ReadByMasterType';
//#endregion

//#region SchoolPrintMaster API
export const SchoolPrintMasterURL: string = SchoolBaseURL + '/PM';

export const SchoolPrintMaster_ReadByMasterType: string =
  SchoolPrintMasterURL + '/ReadByMasterType';

export const SchoolPrintMaster_GeneratePrintHtml: string =
  SchoolPrintMasterURL + '/GeneratePrintHtml';
//#endregion

//#region SocietyPrintMaster API
export const SocietyPrintMasterURL: string = SocietyBaseURL + '/PM';
export const SocietyPrintMaster_ReadByMasterType: string = SocietyPrintMasterURL + '/ReadByMasterType';
export const PushNotificationConfig_ReadById: string = PushNotificationConfigURL + '/ReadById';
export const PushNotificationConfig_SendMessage: string = PushNotificationConfigURL + '/SendMessage';
export const PushNotificationConfig_DeleteByUserId: string = PushNotificationConfigURL + '/DeleteByUserId';
export const PushNotificationConfig_SendMessageToTopic: string = PushNotificationConfigURL + '/SendMessageToTopic';
//#endregion

//#region UserProfile, Credit Engine, Paylater API
export const UserProfileMasterURL: string = PayLaterBaseURL + '/UP';
export const UserProfileCreate: string = UserProfileMasterURL + '/Create'
export const UserProfileDelete: string = UserProfileMasterURL + '/Delete'
export const UserProfileUpdate: string = UserProfileMasterURL + '/Update'
export const UserProfileReadAll: string = UserProfileMasterURL + '/ReadAll'
export const UserProfileReadById: string = UserProfileMasterURL + '/ReadById'
export const UserProfileReadByUserId: string = UserProfileMasterURL + '/ReadByUserId'
//#endRegion

//#region DocumentAddress, Credit Engine, Paylater API
export const DocumentAddressMasterURL: string = PayLaterBaseURL + '/DA';
export const DocumentAddressCreate: string = DocumentAddressMasterURL + '/Create'
export const DocumentAddressUpdate: string = DocumentAddressMasterURL + '/Update'
export const DocumentAddressDelete: string = DocumentAddressMasterURL + '/Delete'
export const DocumentAddressReadAll: string = DocumentAddressMasterURL + '/ReadAll'
export const DocumentAddressReadById: string = DocumentAddressMasterURL + '/ReadById'
export const DocumentAddressReadByUserId: string = DocumentAddressMasterURL + '/ReadByUserId'
//#endRegion

//#region CreditBureauReport, Credit Engine, Paylater API
export const CreditBureauReportMasterURL: string = PayLaterBaseURL + '/CBR';
export const CreditBureauReportCreate: string = CreditBureauReportMasterURL + '/Create'
export const CreditBureauReportUpdate: string = CreditBureauReportMasterURL + '/Update'
export const CreditBureauReportDelete: string = CreditBureauReportMasterURL + '/Delete'
export const CreditBureauReportReadAll: string = CreditBureauReportMasterURL + '/ReadAll'
export const CreditBureauReportReadById: string = CreditBureauReportMasterURL + '/ReadById'
export const CreditBureauReportReadByUserId: string = CreditBureauReportMasterURL + '/ReadByUserId'
//#endRegion

//#region CreditBureauSummary, Credit Engine, Paylater API
export const CreditBureauSummaryMasterURL: string = PayLaterBaseURL + '/CBS';
export const CreditBureauSummaryCreate: string = CreditBureauSummaryMasterURL + '/Create'
export const CreditBureauSummaryUpdate: string = CreditBureauSummaryMasterURL + '/Update'
export const CreditBureauSummaryDelete: string = CreditBureauSummaryMasterURL + '/Delete'
export const CreditBureauSummaryReadAll: string = CreditBureauSummaryMasterURL + '/ReadAll'
export const CreditBureauSummaryReadById: string = CreditBureauSummaryMasterURL + '/ReadById'
export const CreditBureauSummaryReadByUserId: string = CreditBureauSummaryMasterURL + '/ReadByUserId'
export const CreditBureauSummaryReadByBureauReportId: string = CreditBureauSummaryMasterURL + '/ReadByBureauReportId'
//#endRegion

//#region ApplicationBureauMapping, Credit Engine, Paylater API
export const ApplicationBureauMappingMasterURL: string = PayLaterBaseURL + '/ABM';
export const ApplicationBureauMappingCreate: string = ApplicationBureauMappingMasterURL + '/Create'
export const ApplicationBureauMappingUpdate: string = ApplicationBureauMappingMasterURL + '/Update'
export const ApplicationBureauMappingDelete: string = ApplicationBureauMappingMasterURL + '/Delete'
export const ApplicationBureauMappingReadAll: string = ApplicationBureauMappingMasterURL + '/ReadAll'
export const ApplicationBureauMappingReadById: string = ApplicationBureauMappingMasterURL + '/ReadById'
export const ApplicationBureauMappingReadByApplicationId: string = ApplicationBureauMappingMasterURL + '/ReadByApplicationId'
export const ApplicationBureauMappingReadByBureauSummaryId: string = ApplicationBureauMappingMasterURL + '/ReadByBureauSummaryId'
//#endRegion

//#region RealEstate - ProjectBuildingFloorRise API
export const ProjectBuildingFloorRiseURL: string = RealEstateBaseURL + '/PBFR';
export const ProjectBuildingFloorRise_Create: string = ProjectBuildingFloorRiseURL + '/Create';
export const ProjectBuildingFloorRise_Update: string = ProjectBuildingFloorRiseURL + '/Update';
export const ProjectBuildingFloorRise_Delete: string = ProjectBuildingFloorRiseURL + '/Delete';
export const ProjectBuildingFloorRise_ReadAll: string = ProjectBuildingFloorRiseURL + '/ReadAll';
export const ProjectBuildingFloorRise_ReadById: string = ProjectBuildingFloorRiseURL + '/ReadById';
export const ProjectBuildingFloorRise_ReadByProjectId: string = ProjectBuildingFloorRiseURL + '/ReadByProjectId';
export const ProjectBuildingFloorRise_ReadByBuildingId: string = ProjectBuildingFloorRiseURL + '/ReadByBuildingId';
//#endRegion

//#region RealEstate - ProjectOtherCharges API
export const ProjectOtherChargesURL: string = RealEstateBaseURL + '/POC';
export const ProjectOtherCharges_Create: string = ProjectOtherChargesURL + '/Create';
export const ProjectOtherCharges_Update: string = ProjectOtherChargesURL + '/Update';
export const ProjectOtherCharges_Delete: string = ProjectOtherChargesURL + '/Delete';
export const ProjectOtherCharges_ReadAll: string = ProjectOtherChargesURL + '/ReadAll';
export const ProjectOtherCharges_ReadById: string = ProjectOtherChargesURL + '/ReadById';
export const ProjectOtherCharges_ReadByProjectId: string = ProjectOtherChargesURL + '/ReadByProjectId';
export const ProjectOtherCharges_ReadByBuildingId: string = ProjectOtherChargesURL + '/ReadByBuildingId';
//#endRegion

//#region RealEstate - PropertyBooking API
export const PropertyBookingURL: string = RealEstateBaseURL + '/PBK';
export const PropertyBooking_Create: string = PropertyBookingURL + '/Create';
export const PropertyBooking_Update: string = PropertyBookingURL + '/Update';
export const PropertyBooking_Delete: string = PropertyBookingURL + '/Delete';
export const PropertyBooking_ReadAll: string = PropertyBookingURL + '/ReadAll';
export const PropertyBooking_ReadAllPaginated: string = PropertyBookingURL + '/ReadAllPaginated';
export const PropertyBooking_ReadById: string = PropertyBookingURL + '/ReadById';
export const PropertyBooking_ReadByPropertyId: string = PropertyBookingURL + '/ReadByPropertyId';
export const PropertyBooking_ReadByBuyerId: string = PropertyBookingURL + '/ReadByBuyerId';
export const PropertyBooking_GetConfigurationAndPricing: string = PropertyBookingURL + '/GetConfigurationAndPricing';
export const PropertyBooking_SaveBooking: string = PropertyBookingURL + '/SaveBooking';
//#endRegion

//#region RealEstate - PropertyBookingAdjustments API
export const PropertyBookingAdjustmentsURL: string = RealEstateBaseURL + '/PBA';
export const PropertyBookingAdjustments_Create: string = PropertyBookingAdjustmentsURL + '/Create';
export const PropertyBookingAdjustments_Update: string = PropertyBookingAdjustmentsURL + '/Update';
export const PropertyBookingAdjustments_Delete: string = PropertyBookingAdjustmentsURL + '/Delete';
export const PropertyBookingAdjustments_ReadAll: string = PropertyBookingAdjustmentsURL + '/ReadAll';
export const PropertyBookingAdjustments_ReadById: string = PropertyBookingAdjustmentsURL + '/ReadById';
export const PropertyBookingAdjustments_ReadByBookingId: string = PropertyBookingAdjustmentsURL + '/ReadByBookingId';
//#endRegion

//#region RealEstate - PropertyBookingBreakdown API
export const PropertyBookingBreakdownURL: string = RealEstateBaseURL + '/PBB';
export const PropertyBookingBreakdown_Create: string = PropertyBookingBreakdownURL + '/Create';
export const PropertyBookingBreakdown_Update: string = PropertyBookingBreakdownURL + '/Update';
export const PropertyBookingBreakdown_Delete: string = PropertyBookingBreakdownURL + '/Delete';
export const PropertyBookingBreakdown_ReadAll: string = PropertyBookingBreakdownURL + '/ReadAll';
export const PropertyBookingBreakdown_ReadById: string = PropertyBookingBreakdownURL + '/ReadById';
export const PropertyBookingBreakdown_ReadByBookingId: string = PropertyBookingBreakdownURL + '/ReadByBookingId';
export const PropertyBookingBreakdown_ReadByMasterId: string = PropertyBookingBreakdownURL + '/ReadByMasterId';
//#endRegion

//#region RealEstate - REBackendDiscount API
export const SPEBackendDiscountURL: string = SchoolBaseURL + '/SPBD';
export const SPEBackendDiscount_Create: string = SPEBackendDiscountURL + '/Create';
export const SPEBackendDiscount_Update: string = SPEBackendDiscountURL + '/Update';
export const SPEBackendDiscount_Delete: string = SPEBackendDiscountURL + '/Delete';
export const SPEBackendDiscount_ReadBySchoolId: string = SPEBackendDiscountURL + '/ReadBySchoolId';
export const SPEBackendDiscount_ReadAllPaginated: string = SPEBackendDiscountURL + '/ReadAllPaginated';
//#endRegion

//#region Master - UserOtpVerification API
export const UserOtpVerificationURL: string = MasterBaseURL + '/UOV';
export const UserOtpVerification_GenerateOtp: string = UserOtpVerificationURL + '/GenerateOtp';
export const UserOtpVerification_ValidateOtp: string = UserOtpVerificationURL + '/ValidateOtp';
//#endRegion

//#region Paylater - ApplicationVerification API
export const ApplicationVerificationURL: string = PayLaterBaseURL + '/AV';
export const ApplicationVerification_Create: string = ApplicationVerificationURL + '/Create';
export const ApplicationVerification_Update: string = ApplicationVerificationURL + '/Update';
export const ApplicationVerification_Delete: string = ApplicationVerificationURL + '/Delete';
export const ApplicationVerification_ReadAll: string = ApplicationVerificationURL + '/ReadAll';
export const ApplicationVerification_ReadById: string = ApplicationVerificationURL + '/ReadById';
export const ApplicationVerification_ReadByApplicationId: string = ApplicationVerificationURL + '/ReadByApplicationId';
//#endregion 

// #region Paylater - ApplicationDetail API
export const ApplicationDetailMasterURL: string = PayLaterBaseURL + '/APD';
export const ApplicationDetails_Create: string = ApplicationDetailMasterURL + '/Create';
export const ApplicationDetails_Update: string = ApplicationDetailMasterURL + '/Update';
export const ApplicationDetails_Delete: string = ApplicationDetailMasterURL + '/Delete';
export const ApplicationDetails_ReadAll: string = ApplicationDetailMasterURL + '/ReadAll';
export const ApplicationDetails_ReadById: string = ApplicationDetailMasterURL + '/ReadById';
export const ApplicationDetails_ReadByApplicationId: string = ApplicationDetailMasterURL + '/ReadByApplicationId';
export const ApplicationDetails_ReadByParameterId: string = ApplicationDetailMasterURL + '/ReadByParameterId';
export const ApplicationDetails_CreateByParameters: string = ApplicationDetailMasterURL + '/CreateByParameters';
export const ApplicationDetails_UpdateByParameterName: string = ApplicationDetailMasterURL + '/UpdateByParameterName';
// #endRegion

//#region REInvoiceMaster API 
export const REInvoiceMasterURL: string = RealEstateBaseURL + '/IM';
export const REInvoiceMaster_Create: string = REInvoiceMasterURL + '/Create';
export const REInvoiceMaster_Update: string = REInvoiceMasterURL + '/Update';
export const REInvoiceMaster_Delete: string = REInvoiceMasterURL + '/Delete';
export const REInvoiceMaster_ReadAll: string = REInvoiceMasterURL + '/ReadAll';
export const REInvoiceMaster_ReadById: string = REInvoiceMasterURL + '/ReadById';
export const REInvoiceMaster_ReadByMasterId: string = REInvoiceMasterURL + '/ReadByMasterId';
//#endRegion

//#region REInvoiceDetail API 
export const REInvoiceDetailURL: string = RealEstateBaseURL + '/IM';
export const REInvoiceDetail_Create: string = REInvoiceDetailURL + '/Create';
export const REInvoiceDetail_Update: string = REInvoiceDetailURL + '/Update';
export const REInvoiceDetail_Delete: string = REInvoiceDetailURL + '/Delete';
export const REInvoiceDetail_ReadAll: string = REInvoiceDetailURL + '/ReadAll';
export const REInvoiceDetail_ReadById: string = REInvoiceDetailURL + '/ReadById';
export const REInvoiceDetail_ReadByMasterId: string = REInvoiceDetailURL + '/ReadByMasterId';
export const REInvoiceDetail_ReadByInvoiceId: string = REInvoiceDetailURL + '/ReadByInvoiceId';
//#endRegion

//#region Paylater -> PayMentTransactions
export const PaymentTransactionsMasterURL: string = PayLaterBaseURL + '/PT'
export const PaymentTransactions_Create: string = PaymentTransactionsMasterURL + '/Create'
export const PaymentTransactions_Update: string = PaymentTransactionsMasterURL + '/Update'
export const PaymentTransactions_Delete: string = PaymentTransactionsMasterURL + '/Delete'
export const PaymentTransactions_ReadAll: string = PaymentTransactionsMasterURL + '/ReadAll'
export const PaymentTransactions_ReadByUserId: string = PaymentTransactionsMasterURL + '/ReadByUserId'
export const PaymentTransactions_ReadById: string = PaymentTransactionsMasterURL + '/ReadById'
export const PaymentTransactions_ReadByBusinessId: string = PaymentTransactionsMasterURL + '/ReadByBusinessId'
export const PaymentTransactions_ReadByModuleEntityId: string = PaymentTransactionsMasterURL + '/ReadByModuleEntityId'
export const PaymentTransactions_ReadByPRRN: string = PaymentTransactionsMasterURL + '/ReadByPRRN'
export const PaymentTransactions_PaymentUpdateStatus: string = PaymentTransactionsMasterURL + '/PaymentUpdateStatus'
//#endRegion

//#region Paylater -> FraudDetectionMaster
export const FraudDetectionMasterURL: string = PayLaterBaseURL + '/FDM';
export const FraudDetectionMaster_Create: string = FraudDetectionMasterURL + '/Create';
export const FraudDetectionMaster_Update: string = FraudDetectionMasterURL + '/Update';
export const FraudDetectionMaster_Delete: string = FraudDetectionMasterURL + '/Delete';
export const FraudDetectionMaster_ReadAll: string = FraudDetectionMasterURL + '/ReadAll';
export const FraudDetectionMaster_ReadByUserId: string = FraudDetectionMasterURL + '/ReadByUserId';
export const FraudDetectionMaster_ReadById: string = FraudDetectionMasterURL + '/ReadById';
export const FraudDetectionMaster_ReadByApplicationId: string = FraudDetectionMasterURL + '/ReadByApplicationId';
//#endRegion

//#region Paylater -> FraudDetectionSummary
export const FraudDetectionSummaryURL: string = PayLaterBaseURL + '/FDS';
export const FraudDetectionSummary_Create: string = FraudDetectionSummaryURL + '/Create';
export const FraudDetectionSummary_Update: string = FraudDetectionSummaryURL + '/Update';
export const FraudDetectionSummary_Delete: string = FraudDetectionSummaryURL + '/Delete';
export const FraudDetectionSummary_ReadAll: string = FraudDetectionSummaryURL + '/ReadAll';
export const FraudDetectionSummary_ReadById: string = FraudDetectionSummaryURL + '/ReadById';
export const FraudDetectionSummary_ReadByFraudDetectionId: string = FraudDetectionSummaryURL + '/ReadByFraudDetectionId';
//#endRegion



//#region REInvoiceDetail API 
export const StudentRecognitionURL: string = SchoolBaseURL + '/SRG';
export const StudentRecognition_Create: string = StudentRecognitionURL + '/Create';
export const StudentRecognition_Update: string = StudentRecognitionURL + '/Update';
export const StudentRecognition_Delete: string = StudentRecognitionURL + '/Delete';
export const StudentRecognition_ReadAll: string = StudentRecognitionURL + '/ReadAll';
export const StudentRecognition_ReadById: string = StudentRecognitionURL + '/ReadById';
export const StudentRecognition_ReadByStudentId: string = StudentRecognitionURL + '/ReadByStudentId';
export const StudentRecognition_ReadByTeacherId: string = StudentRecognitionURL + '/ReadByTeacherId';
export const StudentRecognition_ReadByRecognitionType: string = StudentRecognitionURL + '/ReadByRecognitionType';
//#endRegion

//#region CertificateMaster API
export const CertificateMasterURL: string = SchoolBaseURL + '/CM';
export const CertificateMaster_Create: string = CertificateMasterURL + '/Create';
export const CertificateMaster_Update: string = CertificateMasterURL + '/Update';
export const CertificateMaster_Delete: string = CertificateMasterURL + '/Delete';
export const CertificateMaster_Issue: string = CertificateMasterURL + '/Issue';
export const CertificateMaster_ReadById: string = CertificateMasterURL + '/ReadById';
export const CertificateMaster_ReadBySchoolId: string = CertificateMasterURL + '/ReadBySchoolId';
//#endregion


/* ===============================
   SAFE GOLD – API ENDPOINTS
   =============================== */

export const SafeGoldBaseURL: string = PayLaterBaseURL + '/SG';

export const SafeGold_Register = SafeGoldBaseURL + '/Registration';
export const SafeGold_Balance = SafeGoldBaseURL + '/Balance';
export const SafeGold_UserTransactions = SafeGoldBaseURL + '/UserTransactions';
// export const SafeGold_UserTransactionsByUrl = SafeGoldBaseURL + '/UserTransactionsByUrl';

export const SafeGold_UserTransactionsByUrl = SafeGoldBaseURL + '/UserTransactionsByURL';

/* -------- Buy Flow -------- */
export const SafeGold_BuyPrice = SafeGoldBaseURL + '/BuyPrice';
export const SafeGold_BuyVerify = SafeGoldBaseURL + '/BuyVerify';
export const SafeGold_BuyConfirm = SafeGoldBaseURL + '/BuyConfirm';
export const SafeGold_BuyStatus = SafeGoldBaseURL + '/BuyStatus';
export const SafeGold_Invoice = SafeGoldBaseURL + '/Invoice';

/* -------- Sell Flow -------- */
export const SafeGold_SellPrice = SafeGoldBaseURL + '/SellPrice';
export const SafeGold_SellVerify = SafeGoldBaseURL + '/SellVerify';
export const SafeGold_SellConfirm = SafeGoldBaseURL + '/SellConfirm';
export const SafeGold_SellStatus = SafeGoldBaseURL + '/SellStatus';

/* -------- Delivery Flow -------- */
export const SafeGold_PincodeValidate = SafeGoldBaseURL + '/PincodeValidate';
export const SafeGold_GoldProducts = SafeGoldBaseURL + '/GoldProducts';
export const SafeGold_RedeemGoldVerify = SafeGoldBaseURL + '/RedeemGoldVerify';
export const SafeGold_RedeemGoldConfirm = SafeGoldBaseURL + '/RedeemGoldConfirm';
export const SafeGold_RedeemStatus = SafeGoldBaseURL + '/RedeemStatus';
export const SafeGold_RedeemDispatchStatus = SafeGoldBaseURL + '/RedeemDispatchStatus';
/* ===============================
   SAFE GOLD – API ENDPOINTS - END
   =============================== */


//#region PayLater - SGUserAccount API 
export const SGUserAccountURL: string = PayLaterBaseURL + '/SGUA';
export const SGUserAccount_Create: string = SGUserAccountURL + '/Create';
export const SGUserAccount_Update: string = SGUserAccountURL + '/Update';
export const SGUserAccount_Delete: string = SGUserAccountURL + '/Delete';
export const SGUserAccount_ReadAll: string = SGUserAccountURL + '/ReadAll';
export const SGUserAccount_ReadById: string = SGUserAccountURL + '/ReadById';
export const SGUserAccount_ReadByUserId: string = SGUserAccountURL + '/ReadByUserId';
//#endRegion

//#region PayLater - SGBuyTransaction API 
export const SGBuyTransactionURL: string = PayLaterBaseURL + '/SGBT';
export const SGBuyTransaction_Create: string = SGBuyTransactionURL + '/Create';
export const SGBuyTransaction_Update: string = SGBuyTransactionURL + '/Update';
export const SGBuyTransaction_Delete: string = SGBuyTransactionURL + '/Delete';
export const SGBuyTransaction_ReadAll: string = SGBuyTransactionURL + '/ReadAll';
export const SGBuyTransaction_ReadById: string = SGBuyTransactionURL + '/ReadById';
export const SGBuyTransaction_ReadByUserId: string = SGBuyTransactionURL + '/ReadByUserId';
//#endRegion

//#region PayLater - SGLedger API 
// export const SGLedgerURL: string = PayLaterBaseURL + '/SGBT';
export const SGLedgerURL: string = PayLaterBaseURL + '/SGL';
export const SGLedger_Create: string = SGLedgerURL + '/Create';
export const SGLedger_Update: string = SGLedgerURL + '/Update';
export const SGLedger_Delete: string = SGLedgerURL + '/Delete';
export const SGLedger_ReadAll: string = SGLedgerURL + '/ReadAll';
export const SGLedger_ReadById: string = SGLedgerURL + '/ReadById';
export const SGLedger_ReadByUserId: string = SGLedgerURL + '/ReadByUserId';
// export const SGLedger_ReadBySGUserId: string = SGLedgerURL + '/ReadBySGUserId';
//#endRegion

//#region PayLater - SGSellTransaction API 
export const SGSellTransactionURL: string = PayLaterBaseURL + '/SGST';
export const SGSellTransaction_Create: string = SGSellTransactionURL + '/Create';
export const SGSellTransaction_Update: string = SGSellTransactionURL + '/Update';
export const SGSellTransaction_Delete: string = SGSellTransactionURL + '/Delete';
export const SGSellTransaction_ReadAll: string = SGSellTransactionURL + '/ReadAll';
export const SGSellTransaction_ReadById: string = SGSellTransactionURL + '/ReadById';
export const SGSellTransaction_ReadByUserId: string = SGSellTransactionURL + '/ReadByUserId';
//#endRegion

//#region PayLater - UserBankAccount API 
export const UserBankAccountURL: string = PayLaterBaseURL + '/UBA';
export const UserBankAccount_Create: string = UserBankAccountURL + '/Create';
export const UserBankAccount_Update: string = UserBankAccountURL + '/Update';
export const UserBankAccount_Delete: string = UserBankAccountURL + '/Delete';
export const UserBankAccount_ReadAll: string = UserBankAccountURL + '/ReadAll';
export const UserBankAccount_ReadById: string = UserBankAccountURL + '/ReadById';
export const UserBankAccount_ReadByUserId: string = UserBankAccountURL + '/ReadByUserId';
//#endRegion


//#region Terms 
export const TermsMasterURL : string  = PayLaterBaseURL + '/T';
export const Terms_Create : string =TermsMasterURL + '/Create';
export const Terms_Update : string =TermsMasterURL + '/Update';
export const Terms_Detele : string =TermsMasterURL + '/Delete';
export const Terms_ReadAll : string =TermsMasterURL + '/ReadAll';
export const Terms_ReadByEntityId : string  = TermsMasterURL + '/ReadByEntityId';
export const Terms_ReadById : string = TermsMasterURL + '/ReadById';
//#endRegion

//#region Terms Acceptance
export const TermsAcceptanceMasterURL : string  = PayLaterBaseURL + '/TA';
export const TermsAcceptance_Create : string =TermsMasterURL + '/Create';
export const TermsAcceptance_Update : string =TermsMasterURL + '/Update';
export const TermsAcceptance_Delete : string =TermsMasterURL + '/Delete';
export const TermsAcceptance_ReadById : string =TermsMasterURL + '/ReadById';
export const TermsAcceptance_ReadByTermId : string =TermsMasterURL + '/ReadByTermId';
//#endregion

//#region Term Acceptance Session
export const TermAcceptanceSessionMasterURL:string = PayLaterBaseURL + '/TAS';
export const TermAcceptanceSession_Create :string = TermAcceptanceSessionMasterURL + '/Create';
export const TermAcceptanceSession_Update :string = TermAcceptanceSessionMasterURL + '/Update';
export const TermAcceptanceSession_Delete :string = TermAcceptanceSessionMasterURL + '/Delete';
export const TermAcceptanceSession_ReadById :string = TermAcceptanceSessionMasterURL + '/ReadById';
export const TermAcceptanceSession_ReadByTermId :string = TermAcceptanceSessionMasterURL + '/ReadByTermId';
//#endreigon

//#region Term Content
export const TermContentMasterURL:string = PayLaterBaseURL + '/TC';
export const TermContent_Create : string  = TermContentMasterURL + '/Create';
export const TermContent_Update : string  = TermContentMasterURL + '/Update';
export const TermContent_Delete : string  = TermContentMasterURL + '/Delete';
export const TermContent_ReadById : string  = TermContentMasterURL + '/ReadById';
export const TermContent_ReadByTermId : string  = TermContentMasterURL + '/ReadByTermId'
//#endreigon


//#region Common - Discussion Master
export const  SocietyRulesMasterURL: string = SocietyBaseURL + '/SRM';
export const SocietyRulesMaster_Create: string = SocietyRulesMasterURL + '/Create';
export const SocietyRulesMaster_Update: string = SocietyRulesMasterURL + '/Update';
export const SocietyRulesMaster_ReadById: string = SocietyRulesMasterURL + '/ReadById';
export const SocietyRulesMaster_ReadBySocietyId: string = SocietyRulesMasterURL + '/ReadBySocietyId';
export const SocietyRulesMaster_Delete: string = SocietyRulesMasterURL + '/Delete';
export const SocietyRulesMaster_ReadAll = SocietyRulesMasterURL + '/ReadAll';
//#endregion

//#region
export const SocietyRulesDetailURL: string = SocietyBaseURL + '/SRD';
export const SocietyRulesDetail_Create: string = SocietyRulesDetailURL + '/Create';
export const SocietyRulesDetail_Update: string = SocietyRulesDetailURL + '/Update';
export const SocietyRulesDetail_ReadById: string = SocietyRulesDetailURL + '/ReadById';
export const SocietyRulesDetail_ReadByMasterId: string = SocietyRulesDetailURL + '/ReadByMasterId';
export const SocietyRulesDetail_Delete: string = SocietyRulesDetailURL + '/Delete';
export const SocietyRulesDetail_ReadAll = SocietyRulesDetailURL + '/ReadAll';
//#endregion



//#region
export const TenantVerificationURL: string = SocietyBaseURL + '/TV';
export const TenantVerification_Create: string = TenantVerificationURL + '/Create';
export const TenantVerification_Update: string = TenantVerificationURL + '/Update';
export const TenantVerification_ReadById: string = TenantVerificationURL + '/ReadById';
export const TenantVerification_ReadBySocietyId: string = TenantVerificationURL + '/ReadBySocietyId';
export const TenantVerification_ReadByFlatId: string = TenantVerificationURL + '/ReadByFlatId';
export const TenantVerification_Delete: string = TenantVerificationURL + '/Delete';
export const TenantVerification_ReadAll = TenantVerificationURL + '/ReadAll';
export const TenantVerification_ApproveOnboarding: string = TenantVerificationURL + '/ApproveOnboarding';
export const TenantVerification_ReadByOwnerId: string = TenantVerificationURL + '/ReadByOwnerId'
//#endregion

//#region PayLater = PaymentGateway
export const PaymentGatewayURL: string = PayLaterBaseURL + '/PG';
export const PaymentGateway_InitializePaymentGateway = PaymentGatewayURL + '/IntializePaymentGateway';

//#region Getway = PaymentGateway
export const PaymentGatewayTransactionURL: string =
  MasterBaseURL + "/PGT";

export const PaymentGatewayTransaction_Create =
  PaymentGatewayTransactionURL + "/Create";

export const PaymentGatewayTransaction_Update =
  PaymentGatewayTransactionURL + "/Update";

export const PaymentGatewayTransaction_ReadById =
  PaymentGatewayTransactionURL + "/ReadById";

export const PaymentGatewayTransaction_ReadByModuleId =
  PaymentGatewayTransactionURL + "/ReadByModuleId";

export const PaymentGatewayTransaction_ReadByGatewayOrderId =
  PaymentGatewayTransactionURL + "/ReadByGatewayOrderId";

export const PaymentGatewayTransaction_ReadByGatewayTransactionId =
  PaymentGatewayTransactionURL + "/ReadByGatewayTransactionId";

export const PaymentGateway_InitializeCashPayment =
  PaymentGatewayURL + '/InitializeCashPayment';
//#endRegion

//#region StudentFeeLedger

export const StudentFeeLedgerURL: string = SchoolBaseURL + "/SFL";
export const StudentFeeLedger_Create = StudentFeeLedgerURL + "/Create";
export const StudentFeeLedger_Update = StudentFeeLedgerURL + "/Update";
export const StudentFeeLedger_ReadAll = StudentFeeLedgerURL + "/ReadAll";
export const StudentFeeLedger_Delete = StudentFeeLedgerURL + "/Delete";
export const StudentFeeLedger_ReadById = StudentFeeLedgerURL + "/ReadById";
export const StudentFeeLedger_ReadByStudentId = StudentFeeLedgerURL + "/ReadByStudentId";
//#endRegion

//#region DigioKyc
export const DigioKycURL: string = PayLaterBaseURL + "/DGK";
export const DigioKyc_PanVerification: string = DigioKycURL + "/PanVerification";
export const DigioKyc_GSTVerification: string = DigioKycURL + "/GSTVerification";
export const DigioKyc_PANToGSTVerification: string = DigioKycURL + "/PANToGSTVerification";
export const DigioKyc_BankAccountVerification: string = DigioKycURL + "/BankAccountVerification";
export const DigioKyc_BankStatementAnalysis: string = DigioKycURL + "/BankStatementAnalysis";
export const DigioKyc_CreateESignRequest: string = DigioKycURL + '/CreateESignRequest';
export const DigioKyc_EstampProcurement: string = DigioKycURL + '/EstampProcurement';
export const DigioKyc_GetESignStatus: string = DigioKycURL + '/GetESignStatus';
export const DigioKyc_DownloadSignedDocument: string = DigioKycURL + '/DownloadSignedDocument';
export const DigioKyc_SendESignLink: string = DigioKycURL + '/SendESignLink';
//#endRegion

//#region LoanLead
export const LoanLeadURL: string = PayLaterBaseURL + "/LL";
export const LoanLead_Create: string = LoanLeadURL + "/Create";
export const LoanLead_Update: string = LoanLeadURL + "/Update";
export const LoanLead_Delete: string = LoanLeadURL + "/Delete";
export const LoanLead_ReadAll: string = LoanLeadURL + "/ReadAll";
export const LoanLead_ReadAllPaginated: string = LoanLeadURL + "/ReadAllPaginated";
export const LoanLead_ReadById: string = LoanLeadURL + "/ReadById";
export const LoanLead_ReadByUserId: string = LoanLeadURL + "ReadByUserId";
export const LoanLead_ReadByModuleId: string = LoanLeadURL + "ReadByModuleId";
//#endRegion

// #region Support Ticket API
export const SupportTicketURL: string =MasterBaseURL + "/ST";
export const SupportTicket_create: string =SupportTicketURL + "/Create";
export const SupportTicket_update: string =SupportTicketURL + "/Update";
export const SupportTicket_delete: string =SupportTicketURL + "/Delete";
export const SupportTicket_readAll: string =SupportTicketURL + "/ReadAll";
export const SupportTicket_readById: string =SupportTicketURL + "/ReadById";
export const SupportTicket_readByTicketOwner: string =SupportTicketURL + "/ReadByTicketOwner";
export const SupportTicket_readAllPaginated: string =SupportTicketURL + "/ReadAllPaginated";
export const SupportTicket_workList: string =SupportTicketURL + "/WorkList";
export const SupportTicket_forceClose: string =SupportTicketURL + "/ForceClose";
export const SupportTicket_reOpen: string =SupportTicketURL + "/ReOpen";
export const SupportTicket_takeOver: string =SupportTicketURL + "/TakeOver";
export const SupportTicket_getAdminDashboard: string =SupportTicketURL + "/GetAdminDashboard";
export const SupportTicket_uploadAttachment: string = SupportTicketURL + "/UploadAttachment";
export const SupportTicket_viewAttachment: string = SupportTicketURL + "/ViewAttachment";
// #endregion

//region TicketActivity API
export const TicketActivityURL: string =MasterBaseURL + "/TA";
export const TicketActivity_create: string =TicketActivityURL + "/Create";
export const TicketActivity_update: string =TicketActivityURL + "/Update";
export const TicketActivity_delete: string =TicketActivityURL + "/Delete";
export const TicketActivity_readAll: string =TicketActivityURL + "/ReadAll";
export const TicketActivity_readById: string =TicketActivityURL + "/ReadById";
export const TicketActivity_readByTicketId: string =TicketActivityURL + "/ReadByTicketId";
//endregion

//region TicketAssignee API
export const TicketAssigneeURL: string =MasterBaseURL + "/TAS";
export const TicketAssignee_create: string =TicketAssigneeURL + "/Create";
export const TicketAssignee_update: string =TicketAssigneeURL + "/Update";
export const TicketAssignee_delete: string =TicketAssigneeURL + "/Delete";
export const TicketAssignee_readAll: string =TicketAssigneeURL + "/ReadAll";
export const TicketAssignee_readById: string =TicketAssigneeURL + "/ReadById";
export const TicketAssignee_readByTicketId: string =TicketAssigneeURL + "/ReadByTicketId";
export const TicketAssignee_updateStatus: string =TicketAssigneeURL + "/UpdateStatus";
//endregion

//#region RevenueReport API
export const RevenueReportURL: string = HospitalBaseURL + '/RR';
export const RevenueReport_Create: string = RevenueReportURL + '/Create';
//#endregion

//#region FIXERRA API
export const FixerraBaseURL: string = PayLaterBaseURL + '/FIX';
export const Fixerra_GetSsoUrl: string = FixerraBaseURL + '/GetSsoUrl';
export const Fixerra_GenerateAuthCode: string = FixerraBaseURL + '/GenerateAuthCode';
export const Fixerra_GenerateAuthCodeByPan: string = FixerraBaseURL + '/GenerateAuthCodeByPan';
export const Fixerra_CreateUser: string = FixerraBaseURL + '/CreateUser';
export const Fixerra_CreateUserByPan: string = FixerraBaseURL + '/CreateUserByPan';
export const Fixerra_AddBankAccount: string = FixerraBaseURL + '/AddBankAccount';
export const Fixerra_AddPersonalDetails: string = FixerraBaseURL + '/AddPersonalDetails';
export const Fixerra_AddNominee: string = FixerraBaseURL + '/AddNominee';
export const Fixerra_Schemes: string = FixerraBaseURL + '/Schemes';
export const Fixerra_Explore: string = FixerraBaseURL + '/Explore';
export const Fixerra_Compare: string = FixerraBaseURL + '/Compare';
export const Fixerra_MaturityPayout: string = FixerraBaseURL + '/MaturityPayout';
export const Fixerra_Rates: string = FixerraBaseURL + '/Rates';
export const Fixerra_AgentHoldings: string = FixerraBaseURL + '/AgentHoldings';
export const Fixerra_TransactionStatus: string = FixerraBaseURL + '/TransactionStatus';
export const Fixerra_PartnerTransactionStatus: string = FixerraBaseURL + '/PartnerTransactionStatus';
export const Fixerra_TransactionDetails: string = FixerraBaseURL + '/TransactionDetails';
export const Fixerra_ListTransactions: string = FixerraBaseURL + '/ListTransactions';
export const Fixerra_Portfolio: string = FixerraBaseURL + '/Portfolio';
export const Fixerra_RenewalEnquiry: string = FixerraBaseURL + '/RenewalEnquiry';
export const Fixerra_VkycMagicLink: string = FixerraBaseURL + '/VkycMagicLink';
export const Fixerra_BankAccounts: string = FixerraBaseURL + '/BankAccounts';
export const Fixerra_Nominees: string = FixerraBaseURL + '/Nominees';
export const Fixerra_VerifyPan: string = FixerraBaseURL + '/VerifyPan';
export const Fixerra_PaymentOrder: string = FixerraBaseURL + '/PaymentOrder';
export const Fixerra_GenerateKycLink: string = FixerraBaseURL + '/GenerateKycLink';
export const Fixerra_UserKycStatus: string = FixerraBaseURL + '/UserKycStatus';

//#region PreEnrollmentInvite API

export const PreEnrollmentInviteURL: string = MasterBaseURL + '/PEI';
export const PreEnrollmentInvite_Create: string = PreEnrollmentInviteURL + '/Create';
export const PreEnrollmentInvite_Update: string = PreEnrollmentInviteURL + '/Update';
export const PreEnrollmentInvite_Delete: string = PreEnrollmentInviteURL + '/Delete';
export const PreEnrollmentInvite_ReadByModule: string = PreEnrollmentInviteURL + '/ReadByModule';
export const PreEnrollmentInvite_ReadByMobileNo: string = PreEnrollmentInviteURL + '/ReadByMobileNo';
export const PreEnrollmentInvite_CreateBulk: string = PreEnrollmentInviteURL + '/CreateBulk';

//#endregion



//# inventory region


export const InventoryBaseURL: string =
  environment.invApiURL + '/IN/IC';

  export const InventoryItemMasterBaseURL: string =
  environment.invApiURL + '/IN/IM';

  export const ItemUOMConversionBaseURL: string =
  environment.invApiURL + '/IN/IUC';

  export const VendorMasterBaseURL: string =
  environment.invApiURL + '/IN/VM';

  export const LocationMasterBaseURL =
  environment.invApiURL + '/IN/LM';

  export const PurchaseOrderMasterBaseURL =
  environment.invApiURL + '/IN/POM';

  export const PurchaseOrderDetailBaseURL =
  environment.invApiURL + '/IN/POD';

  export const UOMMasterBaseURL =
  environment.invApiURL + '/IN/UOM';

export const GoodsReceiptMasterBaseURL: string =
  environment.invApiURL + '/IN/GRM';

export const GoodsReceiptDetailBaseURL: string =
  environment.invApiURL + '/IN/GRD';

export const StockLedgerBaseURL: string =
  environment.invApiURL + '/IN/SLG';

export const StockBalanceBaseURL: string =
  environment.invApiURL + '/IN/SB';

export const IndentMasterBaseURL: string =
  environment.invApiURL + '/IN/INM';

export const IndentDetailBaseURL: string =
  environment.invApiURL + '/IN/IND';

export const StockIssueMasterBaseURL: string =
  environment.invApiURL + '/IN/SIM';

export const StockIssueDetailBaseURL: string =
  environment.invApiURL + '/IN/SID';

export const StockTransferMasterBaseURL: string =
  environment.invApiURL + '/IN/STM';

export const StockTransferDetailBaseURL: string =
  environment.invApiURL + '/IN/STD';

export const StockAdjustmentMasterBaseURL: string =
  environment.invApiURL + '/IN/SAM';

export const StockAdjustmentDetailBaseURL: string =
  environment.invApiURL + '/IN/SAD';

export const StockReturnMasterBaseURL: string =
  environment.invApiURL + '/IN/SRM';

export const StockReturnDetailBaseURL: string =
  environment.invApiURL + '/IN/SRD';

export const StockCountMasterBaseURL: string =
  environment.invApiURL + '/IN/SCM';

export const StockCountDetailBaseURL: string =
  environment.invApiURL + '/IN/SCD';

export const ReorderAlertBaseURL: string =
  environment.invApiURL + '/IN/RA';

  // Endpoints for Inventory Management
export const ItemCategory_Create: string =
  InventoryBaseURL + '/Create';

export const ItemCategory_Update: string =
  InventoryBaseURL + '/Update';

export const ItemCategory_Delete: string =
  InventoryBaseURL + '/Delete';

export const ItemCategory_ReadAll: string =
  InventoryBaseURL + '/ReadAll';

export const ItemCategory_ReadById: string =
  InventoryBaseURL + '/ReadById';

export const ItemCategory_CreateBulk: string =
  InventoryBaseURL + '/CreateBulk';

export const ItemMaster_Create: string =
  InventoryItemMasterBaseURL + '/Create';

export const ItemMaster_Update: string =
  InventoryItemMasterBaseURL + '/Update';

export const ItemMaster_Delete: string =
  InventoryItemMasterBaseURL + '/Delete';

export const ItemMaster_ReadAllPaginated: string =
  InventoryItemMasterBaseURL + '/ReadAllPaginated';

export const ItemMaster_ReadById: string =
  InventoryItemMasterBaseURL + '/ReadById';

export const ItemMaster_CreateBulk: string =
  InventoryItemMasterBaseURL + '/CreateBulk';

export const ItemUOMConversion_Create: string =
  ItemUOMConversionBaseURL + '/Create';

export const ItemUOMConversion_Delete: string =
  ItemUOMConversionBaseURL + '/Delete';

export const ItemUOMConversion_ReadAll: string =
  ItemUOMConversionBaseURL + '/ReadAll';

export const ItemUOMConversion_ReadById: string =
  ItemUOMConversionBaseURL + '/ReadById';

export const ItemUOMConversion_Update: string =
  ItemUOMConversionBaseURL + '/Update';

export const ItemUOMConversion_ReadAllPaginated: string =
  ItemUOMConversionBaseURL + '/ReadAllPaginated';  

export const VendorMaster_Create: string =
  VendorMasterBaseURL + '/Create';

export const VendorMaster_Update: string =
  VendorMasterBaseURL + '/Update';

export const VendorMaster_Delete: string =
  VendorMasterBaseURL + '/Delete';

export const VendorMaster_ReadAll: string =
  VendorMasterBaseURL + '/ReadAll';

export const VendorMaster_ReadById: string =
  VendorMasterBaseURL + '/ReadById';

export const VendorMaster_ReadAllPaginated: string =
  VendorMasterBaseURL + '/ReadAllPaginated';

export const VendorMaster_CreateBulk: string =
  VendorMasterBaseURL + '/CreateBulk';
  
export const LocationMaster_Create =
  LocationMasterBaseURL + '/Create';

export const LocationMaster_Update =
  LocationMasterBaseURL + '/Update';

export const LocationMaster_Delete =
  LocationMasterBaseURL + '/Delete';

export const LocationMaster_ReadAll =
  LocationMasterBaseURL + '/ReadAll';

export const LocationMaster_ReadById =
  LocationMasterBaseURL + '/ReadById';

export const LocationMaster_ReadAllPaginated =
  LocationMasterBaseURL + '/ReadAllPaginated';

export const LocationMaster_CreateBulk =
  LocationMasterBaseURL + '/CreateBulk';  

export const PurchaseOrderMaster_Create =
  PurchaseOrderMasterBaseURL + '/Create';

export const PurchaseOrderMaster_Update =
  PurchaseOrderMasterBaseURL + '/Update';

export const PurchaseOrderMaster_Delete =
  PurchaseOrderMasterBaseURL + '/Delete';

export const PurchaseOrderMaster_ReadAll =
  PurchaseOrderMasterBaseURL + '/ReadAll';

export const PurchaseOrderMaster_ReadById =
  PurchaseOrderMasterBaseURL + '/ReadById';

export const PurchaseOrderMaster_ReadAllPaginated =
  PurchaseOrderMasterBaseURL + '/ReadAllPaginated';
  
export const PurchaseOrderDetail_Create =
  PurchaseOrderDetailBaseURL + '/Create';

export const PurchaseOrderDetail_Update =
  PurchaseOrderDetailBaseURL + '/Update';

export const PurchaseOrderDetail_Delete =
  PurchaseOrderDetailBaseURL + '/Delete';

export const PurchaseOrderDetail_ReadAll =
  PurchaseOrderDetailBaseURL + '/ReadAll';

export const PurchaseOrderDetail_ReadById =
  PurchaseOrderDetailBaseURL + '/ReadById';  

export const UOMMaster_Create =
  UOMMasterBaseURL + '/Create';

export const UOMMaster_Update =
  UOMMasterBaseURL + '/Update';

export const UOMMaster_Delete =
  UOMMasterBaseURL + '/Delete';

export const UOMMaster_ReadAll =
  UOMMasterBaseURL + '/ReadAll';

export const UOMMaster_ReadById =
  UOMMasterBaseURL + '/ReadById';

export const UOMMaster_ReadAllPaginated =
  UOMMasterBaseURL + '/ReadAllPaginated';

export const UOMMaster_CreateBulk =
  UOMMasterBaseURL + '/CreateBulk';  

// ============================================================
// GOODS RECEIPT MASTER
// ============================================================

export const GoodsReceiptMaster_Create: string =
  GoodsReceiptMasterBaseURL + '/Create';

export const GoodsReceiptMaster_Update: string =
  GoodsReceiptMasterBaseURL + '/Update';

export const GoodsReceiptMaster_Delete: string =
  GoodsReceiptMasterBaseURL + '/Delete';

export const GoodsReceiptMaster_ReadById: string =
  GoodsReceiptMasterBaseURL + '/ReadById';

export const GoodsReceiptMaster_ReadAllPaginated: string =
  GoodsReceiptMasterBaseURL + '/ReadAllPaginated';

export const GoodsReceiptMaster_ReadByModule: string =
  GoodsReceiptMasterBaseURL + '/ReadByModule';


  
// ============================================================
// GOODS RECEIPT — TRANSACTIONAL WORKFLOW
// ============================================================

// PROPOSED CONTRACTS:
// Backend controller and Ocelot routes must be implemented
// and verified before these APIs can be used.

export const GoodsReceipt_SubmitWithDetail: string =
  GoodsReceiptMasterBaseURL + '/SubmitWithDetail';

export const GoodsReceipt_ApproveAndPost: string =
  GoodsReceiptMasterBaseURL + '/ApproveAndPost';

export const GoodsReceipt_Reject: string =
  GoodsReceiptMasterBaseURL + '/Reject';





// ============================================================
// GOODS RECEIPT DETAIL
// ============================================================

export const GoodsReceiptDetail_Create: string =
  GoodsReceiptDetailBaseURL + '/Create';

export const GoodsReceiptDetail_Update: string =
  GoodsReceiptDetailBaseURL + '/Update';

export const GoodsReceiptDetail_Delete: string =
  GoodsReceiptDetailBaseURL + '/Delete';

export const GoodsReceiptDetail_ReadById: string =
  GoodsReceiptDetailBaseURL + '/ReadById';

export const GoodsReceiptDetail_ReadAllPaginated: string =
  GoodsReceiptDetailBaseURL + '/ReadAllPaginated';

export const GoodsReceiptDetail_ReadByModule: string =
  GoodsReceiptDetailBaseURL + '/ReadByModule';


  
// ============================================================
// STOCK LEDGER

// ============================================================

export const StockLedger_Create: string =
  StockLedgerBaseURL + '/Create';

export const StockLedger_Update: string =
  StockLedgerBaseURL + '/Update';  

export const StockLedger_Delete: string =
  StockLedgerBaseURL + '/Delete';   

export const StockLedger_ReadById: string =
  StockLedgerBaseURL + '/ReadById';

export const StockLedger_ReadAllPaginated: string =
  StockLedgerBaseURL + '/ReadAllPaginated';

export const StockLedger_ReadByModule: string =
  StockLedgerBaseURL + '/ReadByModule';


// ============================================================
// STOCK BALANCE

// ============================================================

export const StockBalance_Create: string =
  StockBalanceBaseURL + '/Create';

export const StockBalance_Update: string =
  StockBalanceBaseURL + '/Update';  

export const StockBalance_Delete: string =
  StockBalanceBaseURL + '/Delete';

export const StockBalance_ReadById: string =
  StockBalanceBaseURL + '/ReadById';

export const StockBalance_ReadAllPaginated: string =
  StockBalanceBaseURL + '/ReadAllPaginated';

export const StockBalance_ReadByModule: string =
  StockBalanceBaseURL + '/ReadByModule';


// ============================================================
// INDENT MASTER
// ============================================================

export const IndentMaster_Create: string =
  IndentMasterBaseURL + '/Create';

export const IndentMaster_Update: string =
  IndentMasterBaseURL + '/Update';

export const IndentMaster_Delete: string =
  IndentMasterBaseURL + '/Delete';

export const IndentMaster_ReadById: string =
  IndentMasterBaseURL + '/ReadById';

export const IndentMaster_ReadAllPaginated: string =
  IndentMasterBaseURL + '/ReadAllPaginated';

export const IndentMaster_ReadByModule: string =
  IndentMasterBaseURL + '/ReadByModule';

// ============================================================
// INDENT DETAIL
// ============================================================



// ============================================================
// STOCK TRANSFER — TRANSACTIONAL OPERATIONS
// Backend and gateway routes must exist before use.
// ============================================================

export const StockTransfer_SubmitAndDispatch: string =
  StockTransferMasterBaseURL + '/SubmitAndDispatch';

export const StockTransfer_Receive: string =
  StockTransferMasterBaseURL + '/Receive';


export const IndentDetail_Create: string =
  IndentDetailBaseURL + '/Create';

export const IndentDetail_Update: string =
  IndentDetailBaseURL + '/Update';

export const IndentDetail_Delete: string =
  IndentDetailBaseURL + '/Delete';

export const IndentDetail_ReadById: string =
  IndentDetailBaseURL + '/ReadById';

export const IndentDetail_ReadAllPaginated: string =
  IndentDetailBaseURL + '/ReadAllPaginated';

export const IndentDetail_ReadByModule: string =
  IndentDetailBaseURL + '/ReadByModule';

export const IndentMaster_ApproveAndReserve: string =
  IndentMasterBaseURL + '/ApproveAndReserve';

// ============================================================
// STOCK ISSUE MASTER
// ============================================================

export const StockIssueMaster_Create: string =
  StockIssueMasterBaseURL + '/Create';

export const StockIssueMaster_Update: string =
  StockIssueMasterBaseURL + '/Update';

export const StockIssueMaster_Delete: string =
  StockIssueMasterBaseURL + '/Delete';

export const StockIssueMaster_ReadById: string =
  StockIssueMasterBaseURL + '/ReadById';

export const StockIssueMaster_ReadAllPaginated: string =
  StockIssueMasterBaseURL + '/ReadAllPaginated';

export const StockIssueMaster_ReadByModule: string =
  StockIssueMasterBaseURL + '/ReadByModule';




// ============================================================
// STOCK ISSUE DETAIL
// ============================================================

export const StockIssueDetail_Create: string =
  StockIssueDetailBaseURL + '/Create';

export const StockIssueDetail_Update: string =
  StockIssueDetailBaseURL + '/Update';

export const StockIssueDetail_Delete: string =
  StockIssueDetailBaseURL + '/Delete';

export const StockIssueDetail_ReadById: string =
  StockIssueDetailBaseURL + '/ReadById';

export const StockIssueDetail_ReadAllPaginated: string =
  StockIssueDetailBaseURL + '/ReadAllPaginated';

export const StockIssueDetail_ReadByModule: string =
  StockIssueDetailBaseURL + '/ReadByModule';


// ============================================================
// STOCK TRANSFER MASTER
// ============================================================

export const StockTransferMaster_Create: string =
  StockTransferMasterBaseURL + '/Create';

export const StockTransferMaster_Update: string =
  StockTransferMasterBaseURL + '/Update';

export const StockTransferMaster_Delete: string =
  StockTransferMasterBaseURL + '/Delete';

export const StockTransferMaster_ReadById: string =
  StockTransferMasterBaseURL + '/ReadById';

export const StockTransferMaster_ReadAllPaginated: string =
  StockTransferMasterBaseURL + '/ReadAllPaginated';

export const StockTransferMaster_ReadByModule: string =
  StockTransferMasterBaseURL + '/ReadByModule';




// ============================================================
// STOCK TRANSFER DETAIL
// ============================================================

export const StockTransferDetail_Create: string =
  StockTransferDetailBaseURL + '/Create';

export const StockTransferDetail_Update: string =
  StockTransferDetailBaseURL + '/Update';

export const StockTransferDetail_Delete: string =
  StockTransferDetailBaseURL + '/Delete';

export const StockTransferDetail_ReadById: string =
  StockTransferDetailBaseURL + '/ReadById';

export const StockTransferDetail_ReadAllPaginated: string =
  StockTransferDetailBaseURL + '/ReadAllPaginated';

export const StockTransferDetail_ReadByModule: string =
  StockTransferDetailBaseURL + '/ReadByModule';

// Proposed endpoint — backend/Ocelot must implement this route.
export const StockTransfer_Post =
  StockTransferDetailBaseURL + '/Post';


// ============================================================
// STOCK ADJUSTMENT MASTER
// ============================================================

export const StockAdjustmentMaster_Create: string =
  StockAdjustmentMasterBaseURL + '/Create';

export const StockAdjustmentMaster_Update: string =
  StockAdjustmentMasterBaseURL + '/Update';

export const StockAdjustmentMaster_Delete: string =
  StockAdjustmentMasterBaseURL + '/Delete';

export const StockAdjustmentMaster_ReadById: string =
  StockAdjustmentMasterBaseURL + '/ReadById';

export const StockAdjustmentMaster_ReadAllPaginated: string =
  StockAdjustmentMasterBaseURL + '/ReadAllPaginated';

export const StockAdjustmentMaster_ReadByModule: string =
  StockAdjustmentMasterBaseURL + '/ReadByModule';





// ============================================================
// STOCK ADJUSTMENT DETAIL
// ============================================================

export const StockAdjustmentDetail_Create: string =
  StockAdjustmentDetailBaseURL + '/Create';

export const StockAdjustmentDetail_Update: string =
  StockAdjustmentDetailBaseURL + '/Update';

export const StockAdjustmentDetail_Delete: string =
  StockAdjustmentDetailBaseURL + '/Delete';

export const StockAdjustmentDetail_ReadById: string =
  StockAdjustmentDetailBaseURL + '/ReadById';

export const StockAdjustmentDetail_ReadAllPaginated: string =
  StockAdjustmentDetailBaseURL + '/ReadAllPaginated';

export const StockAdjustmentDetail_ReadByModule: string =
  StockAdjustmentDetailBaseURL + '/ReadByModule';


// ============================================================
// STOCK RETURN MASTER
// (Used to reverse a posted GR — vendor return)
// ============================================================

export const StockReturnMaster_Create: string =
  StockReturnMasterBaseURL + '/Create';

export const StockReturnMaster_Update: string =
  StockReturnMasterBaseURL + '/Update';

export const StockReturnMaster_Delete: string =
  StockReturnMasterBaseURL + '/Delete';

export const StockReturnMaster_ReadById: string =
  StockReturnMasterBaseURL + '/ReadById';

export const StockReturnMaster_ReadAllPaginated: string =
  StockReturnMasterBaseURL + '/ReadAllPaginated';

export const StockReturnMaster_ReadByModule: string =
  StockReturnMasterBaseURL + '/ReadByModule';





// ============================================================
// STOCK RETURN DETAIL
// ============================================================

export const StockReturnDetail_Create: string =
  StockReturnDetailBaseURL + '/Create';

export const StockReturnDetail_Update: string =
  StockReturnDetailBaseURL + '/Update';

export const StockReturnDetail_Delete: string =
  StockReturnDetailBaseURL + '/Delete';

export const StockReturnDetail_ReadById: string =
  StockReturnDetailBaseURL + '/ReadById';

export const StockReturnDetail_ReadAllPaginated: string =
  StockReturnDetailBaseURL + '/ReadAllPaginated';

export const StockReturnDetail_ReadByModule: string =
  StockReturnDetailBaseURL + '/ReadByModule';


// ============================================================
// STOCK COUNT MASTER
// ============================================================

export const StockCountMaster_Create: string =
  StockCountMasterBaseURL + '/Create';

export const StockCountMaster_Update: string =
  StockCountMasterBaseURL + '/Update';

export const StockCountMaster_Delete: string =
  StockCountMasterBaseURL + '/Delete';

export const StockCountMaster_ReadById: string =
  StockCountMasterBaseURL + '/ReadById';

export const StockCountMaster_ReadAllPaginated: string =
  StockCountMasterBaseURL + '/ReadAllPaginated';

export const StockCountMaster_ReadByModule: string =
  StockCountMasterBaseURL + '/ReadByModule';





// ============================================================
// STOCK COUNT DETAIL
// ============================================================

export const StockCountDetail_Create: string =
  StockCountDetailBaseURL + '/Create';

export const StockCountDetail_Update: string =
  StockCountDetailBaseURL + '/Update';

export const StockCountDetail_Delete: string =
  StockCountDetailBaseURL + '/Delete';

export const StockCountDetail_ReadById: string =
  StockCountDetailBaseURL + '/ReadById';

export const StockCountDetail_ReadAllPaginated: string =
  StockCountDetailBaseURL + '/ReadAllPaginated';

export const StockCountDetail_ReadByModule: string =
  StockCountDetailBaseURL + '/ReadByModule';


// ============================================================
// REORDER ALERT
// ============================================================

export const ReorderAlert_Create: string =
  ReorderAlertBaseURL + '/Create';

export const ReorderAlert_Update: string =
  ReorderAlertBaseURL + '/Update';

export const ReorderAlert_Delete: string =
  ReorderAlertBaseURL + '/Delete';

export const ReorderAlert_ReadById: string =
  ReorderAlertBaseURL + '/ReadById';

export const ReorderAlert_ReadAllPaginated: string =
  ReorderAlertBaseURL + '/ReadAllPaginated';

export const ReorderAlert_ReadByModule: string =
  ReorderAlertBaseURL + '/ReadByModule';
//#endregion

//#region MenuMaster API

export const MenuMasterURL: string = MasterBaseURL + '/MM';
export const MenuMaster_create: string = MenuMasterURL + '/Create';
export const MenuMaster_update: string = MenuMasterURL + '/Update';
export const MenuMaster_readById: string = MenuMasterURL + '/ReadById';
export const MenuMaster_delete: string = MenuMasterURL + '/Delete';
export const MenuMaster_readAll: string = MenuMasterURL + '/ReadAll';
export const MenuMaster_readAllPaginated = MenuMasterURL + '/ReadAllPaginated';
export const MenuMaster_readBySoftwareId: string = MenuMasterURL + '/ReadBySoftwareId';
export const MenuMaster_readByUserId: string = MenuMasterURL + '/ReadByUserId';

//#endregion

//#region ============================== CRM ================================

// ============================================================
//  CRM — Root URL
// ============================================================
export const CrmBaseURL: string = environment.crmApiURL + '/CRM';



// ============================================================
//  CRM — Base URLs (one per gateway prefix)
//  Every prefix is verified against the Ocelot gateway configs.
// ============================================================

// --- Territory ---
export const CrmTerritoryBaseURL: string = CrmBaseURL + '/TER';

// --- Account Config ---
export const CrmAccountConfigBaseURL: string = CrmBaseURL + '/AC';

// --- Entity ---
export const CrmEntityBaseURL:          string = CrmBaseURL + '/ENT';
export const CrmPersonBaseURL:          string = CrmBaseURL + '/PER';
export const CrmOrganizationBaseURL:    string = CrmBaseURL + '/ORG';
export const CrmContactPointBaseURL:    string = CrmBaseURL + '/CP';
export const CrmEntityRelationshipBaseURL: string = CrmBaseURL + '/ER';
export const CrmEntityTagBaseURL:       string = CrmBaseURL + '/ET';
export const CrmEntityUserMapBaseURL:   string = CrmBaseURL + '/EUM';
export const CrmDuplicateCandidateBaseURL: string = CrmBaseURL + '/DC';

// --- Lead domain ---
export const CrmLeadMasterBaseURL:   string = CrmBaseURL + '/LM';
export const CrmLeadDetailBaseURL:   string = CrmBaseURL + '/LD';
export const CrmLeadActivityBaseURL: string = CrmBaseURL + '/LA';
export const CrmLeadAssigneeBaseURL: string = CrmBaseURL + '/LAS';
export const CrmLeadCheckListBaseURL:string = CrmBaseURL + '/LCL';

// --- Contact (basic) ---
export const CrmContactBaseURL: string = CrmBaseURL + '/CT';

// --- Opportunity ---
export const CrmOpportunityBaseURL:            string = CrmBaseURL + '/OPP';
export const CrmLoanHandoffBaseURL:            string = CrmBaseURL + '/LH';
export const CrmOpportunityParticipantBaseURL: string = CrmBaseURL + '/OPPT';
export const CrmOpportunityStageHistoryBaseURL:string = CrmBaseURL + '/OSH';
export const CrmOpportunityAssignHistBaseURL:  string = CrmBaseURL + '/OAH';
export const CrmOpportunityFieldValueBaseURL:  string = CrmBaseURL + '/OFV';

// --- Pipeline / Stages / Transitions ---
export const CrmPipelineBaseURL:        string = CrmBaseURL + '/PIP';
export const CrmPipelineStageBaseURL:   string = CrmBaseURL + '/PS';
export const CrmStageTransitionBaseURL: string = CrmBaseURL + '/ST';

// --- Products / SubProducts / Verticals ---
export const CrmProductBaseURL:    string = CrmBaseURL + '/PRD';
export const CrmSubProductBaseURL: string = CrmBaseURL + '/SP';
export const CrmVerticalBaseURL:   string = CrmBaseURL + '/VRT';


 // --- Teams ---
export const CrmTeamBaseURL:       string = CrmBaseURL + '/TEM';
export const CrmTeamMemberBaseURL: string = CrmBaseURL + '/TM';


// --- Field Definitions / Tags ---
export const CrmFieldDefinitionBaseURL: string = CrmBaseURL + '/FD';
export const CrmTagBaseURL:             string = CrmBaseURL + '/TAG';

// --- Meetings ---
export const CrmMeetingBaseURL: string = CrmBaseURL + '/MTG';
export const CrmMeetingDetailBaseURL: string = CrmBaseURL + '/MD';
export const CrmMeetingMasterBaseURL: string = CrmBaseURL + '/MM';


// --- Tasks / Activities / Follow-ups ---
export const CrmTaskBaseURL: string = CrmBaseURL + '/TSK';
export const CrmActivityBaseURL: string = CrmBaseURL + '/ATV';
export const CrmFollowUpBaseURL: string = CrmBaseURL + '/FU';
export const CrmFollowUpScheduleBaseURL: string = CrmBaseURL + '/FUS';

// --- Field Visit ---
export const CrmFieldVisitBaseURL: string = CrmBaseURL + '/FV';

// --- Communication Hub ---
export const CrmConversationBaseURL:           string = CrmBaseURL + '/CNV';
export const CrmConversationParticipantBaseURL:string = CrmBaseURL + '/CNP';
export const CrmMessageBaseURL:                string = CrmBaseURL + '/MSG';
export const CrmCallLogBaseURL:                string = CrmBaseURL + '/CL';
export const CrmChannelAccountBaseURL:         string = CrmBaseURL + '/CA';
export const CrmContactPreferenceBaseURL:      string = CrmBaseURL + '/CPR';

// --- Lead Sources & Sites ---
export const CrmFacebookBaseURL:   string = CrmBaseURL + '/FB';
export const CrmImportJobBaseURL:  string = CrmBaseURL + '/IJ';
export const CrmSiteMasterBaseURL: string = CrmBaseURL + '/SITE';

// --- Marketing ---
export const MktCampaignBaseURL:   string = CrmBaseURL + '/CMP';
export const MktSpendBaseURL:      string = CrmBaseURL + '/SPD';
export const MktTouchpointBaseURL: string = CrmBaseURL + '/CT';
export const MktAudienceBaseURL:   string = CrmBaseURL + '/AUD';
export const MktEmailBaseURL:      string = CrmBaseURL + '/EML';
export const MktUnsubBaseURL:      string = CrmBaseURL + '/UNS';
export const RevAttrBaseURL:       string = CrmBaseURL + '/RA';

// --- Customer Success ---
export const CsLifecycleBaseURL: string = CrmBaseURL + '/AL';
export const CsHealthBaseURL:    string = CrmBaseURL + '/HS';
export const CsPlanBaseURL:      string = CrmBaseURL + '/OP';
export const CsTaskBaseURL:      string = CrmBaseURL + '/OT';
export const CsRenewalBaseURL:   string = CrmBaseURL + '/REN';

// --- Contracts & Subscriptions ---
export const BizProposalBaseURL:     string = CrmBaseURL + '/PRP';
export const BizContractBaseURL:     string = CrmBaseURL + '/CTR';
export const BizSubscriptionBaseURL: string = CrmBaseURL + '/SUB';

// --- Automation / Workflow Studio ---
export const CrmAutoBaseURL: string = CrmBaseURL + '/WF';
export const CrmConditionBaseURL: string = CrmAutoBaseURL + '/Condition';
export const CrmActionBaseURL: string = CrmAutoBaseURL + '/Action';
export const CrmScheduledActionBaseURL: string = CrmAutoBaseURL + '/ScheduledAction';
export const CrmSLAURL: string = CrmBaseURL + '/SLA';
export const CrmSLAI: string = CrmBaseURL + '/SLAI';
export const WorkflowVersion_Create =
  CrmAutoBaseURL + '/Version/Create';

export const WorkflowVersion_Update =
  CrmAutoBaseURL + '/Version/Update';

export const WorkflowVersion_Delete =
  CrmAutoBaseURL + '/Version/Delete';

export const WorkflowVersion_ReadById =
  CrmAutoBaseURL + '/Version/ReadById';

export const WorkflowVersion_ReadByWorkflowId =
  CrmAutoBaseURL + '/Version/ReadByWorkflowId';
// --- Trigger ---
export const CrmTriggerBaseURL: string = CrmBaseURL + '/TRG';

// --- Quotation ---
export const CrmQuotationBaseURL: string = CrmBaseURL + '/QM';

export const CrmQuotationDetailBaseURL: string = CrmBaseURL + '/QD';

export const CrmQuotationOtherChargesBaseURL: string = CrmBaseURL + '/QOC';

// --- Referral (from Referral module) ---
export const CrmReferralBaseURL: string = CrmBaseURL + '/REF';



// ============================================================
//  ACCOUNT CONFIG  — /CRM/AC
// ============================================================
export const AccountConfig_HealthCheck:       string = CrmAccountConfigBaseURL + '/healthCheck';
export const AccountConfig_Create:            string = CrmAccountConfigBaseURL + '/Create';
export const AccountConfig_Update:            string = CrmAccountConfigBaseURL + '/Update';
export const AccountConfig_Delete:            string = CrmAccountConfigBaseURL + '/Delete';
export const AccountConfig_ReadById:          string = CrmAccountConfigBaseURL + '/ReadById';
export const AccountConfig_ReadAll:           string = CrmAccountConfigBaseURL + '/ReadAll';
export const AccountConfig_ReadByModule:      string = CrmAccountConfigBaseURL + '/ReadByModule';
export const AccountConfig_ReadAllPaginated:  string = CrmAccountConfigBaseURL + '/ReadAllPaginated';
export const AccountConfig_SetDefault:        string = CrmAccountConfigBaseURL + '/SetDefault';
export const AccountConfig_SetSecret:         string = CrmAccountConfigBaseURL + '/SetSecret';


// ============================================================
//  TERRITORY  — /CRM/TER
// ============================================================
export const Territory_Create:           string = CrmTerritoryBaseURL + '/Create';
export const Territory_Update:           string = CrmTerritoryBaseURL + '/Update';
export const Territory_Delete:           string = CrmTerritoryBaseURL + '/Delete';
export const Territory_ReadById:         string = CrmTerritoryBaseURL + '/ReadById';
export const Territory_ReadAll:          string = CrmTerritoryBaseURL + '/ReadAll';
export const Territory_ReadAllPaginated: string = CrmTerritoryBaseURL + '/ReadAllPaginated';

export const DuplicateCandidate_ReadByEntityId: string =
  CrmDuplicateCandidateBaseURL + '/ReadByEntityId';

export const Entity_Merge: string =
  CrmEntityBaseURL + '/Merge';

// ============================================================
//  ENTITY  — /CRM/ENT
// ============================================================
export const EntityURL              = MasterBaseURL + '/Entity';
export const Entity_Create:           string = CrmEntityBaseURL + '/Create';
export const Entity_Update:           string = CrmEntityBaseURL + '/Update';
export const Entity_Delete:           string = CrmEntityBaseURL + '/Delete';
export const Entity_ReadById:         string = CrmEntityBaseURL + '/ReadById';
export const Entity_ReadAll:          string = CrmEntityBaseURL + '/ReadAll';
export const Entity_ReadAllPaginated: string = CrmEntityBaseURL + '/ReadAllPaginated';
export const Entity_Search: string = CrmEntityBaseURL + '/Search';
export const Entity_ReadByOwnerUserId:string = CrmEntityBaseURL + '/ReadByOwnerUserId';


// ============================================================
//  PERSON  — /CRM/PER
// ============================================================
export const Person_Create:           string = CrmPersonBaseURL + '/Create';
export const Person_Update:           string = CrmPersonBaseURL + '/Update';
export const Person_Delete:           string = CrmPersonBaseURL + '/Delete';
export const Person_ReadById:         string = CrmPersonBaseURL + '/ReadById';
export const Person_ReadAll:          string = CrmPersonBaseURL + '/ReadAll';
export const Person_ReadAllPaginated: string = CrmPersonBaseURL + '/ReadAllPaginated';



export const Person_ReadByEntityId: string =
  CrmPersonBaseURL + '/ReadByEntityId';


  
// ============================================================
//  ORGANIZATION  — /CRM/ORG
// ============================================================
export const Organization_Create:           string = CrmOrganizationBaseURL + '/Create';
export const Organization_Update:           string = CrmOrganizationBaseURL + '/Update';
export const Organization_Delete:           string = CrmOrganizationBaseURL + '/Delete';
export const Organization_ReadById:         string = CrmOrganizationBaseURL + '/ReadById';
export const Organization_ReadAll:          string = CrmOrganizationBaseURL + '/ReadAll';
export const Organization_ReadAllPaginated: string = CrmOrganizationBaseURL + '/ReadAllPaginated';
export const Organization_ReadByEntityId: string =
  CrmOrganizationBaseURL + '/ReadByEntityId';

// ============================================================
//  CONTACT POINT  — /CRM/CP
// ============================================================
export const ContactPoint_Create:           string = CrmContactPointBaseURL + '/Create';
export const ContactPoint_Update:           string = CrmContactPointBaseURL + '/Update';
export const ContactPoint_Delete:           string = CrmContactPointBaseURL + '/Delete';
export const ContactPoint_ReadById:         string = CrmContactPointBaseURL + '/ReadById';
export const ContactPoint_ReadAll:          string = CrmContactPointBaseURL + '/ReadAll';
export const ContactPoint_ReadAllPaginated: string = CrmContactPointBaseURL + '/ReadAllPaginated';
export const ContactPoint_ReadByEntityId:   string = CrmContactPointBaseURL + '/ReadByEntityId';

// ============================================================
//  ENTITY RELATIONSHIP  — /CRM/ER
// ============================================================
export const EntityRelationship_Create:           string = CrmEntityRelationshipBaseURL + '/Create';
export const EntityRelationship_Update:           string = CrmEntityRelationshipBaseURL + '/Update';
export const EntityRelationship_Delete:           string = CrmEntityRelationshipBaseURL + '/Delete';
export const EntityRelationship_ReadById:         string = CrmEntityRelationshipBaseURL + '/ReadById';
export const EntityRelationship_ReadAll:          string = CrmEntityRelationshipBaseURL + '/ReadAll';
export const EntityRelationship_ReadAllPaginated: string = CrmEntityRelationshipBaseURL + '/ReadAllPaginated';


// ============================================================
//  ENTITY TAG  — /CRM/ET
// ============================================================
export const EntityTag_Create:           string = CrmEntityTagBaseURL + '/Create';
export const EntityTag_Update:           string = CrmEntityTagBaseURL + '/Update';
export const EntityTag_Delete:           string = CrmEntityTagBaseURL + '/Delete';
export const EntityTag_ReadById:         string = CrmEntityTagBaseURL + '/ReadById';
export const EntityTag_ReadAll:          string = CrmEntityTagBaseURL + '/ReadAll';
export const EntityTag_ReadAllPaginated: string = CrmEntityTagBaseURL + '/ReadAllPaginated';


// ============================================================
//  ENTITY USER MAP  — /CRM/EUM
// ============================================================
export const EntityUserMap_Create:           string = CrmEntityUserMapBaseURL + '/Create';
export const EntityUserMap_Update:           string = CrmEntityUserMapBaseURL + '/Update';
export const EntityUserMap_Delete:           string = CrmEntityUserMapBaseURL + '/Delete';
export const EntityUserMap_ReadById:         string = CrmEntityUserMapBaseURL + '/ReadById';
export const EntityUserMap_ReadAll:          string = CrmEntityUserMapBaseURL + '/ReadAll';
export const EntityUserMap_ReadAllPaginated: string = CrmEntityUserMapBaseURL + '/ReadAllPaginated';


// ============================================================
//  DUPLICATE CANDIDATE  — /CRM/DC
// ============================================================
export const DuplicateCandidate_Create:           string = CrmDuplicateCandidateBaseURL + '/Create';
export const DuplicateCandidate_Update:           string = CrmDuplicateCandidateBaseURL + '/Update';
export const DuplicateCandidate_Delete:           string = CrmDuplicateCandidateBaseURL + '/Delete';
export const DuplicateCandidate_ReadById:         string = CrmDuplicateCandidateBaseURL + '/ReadById';
export const DuplicateCandidate_ReadAll:          string = CrmDuplicateCandidateBaseURL + '/ReadAll';
export const DuplicateCandidate_ReadAllPaginated: string = CrmDuplicateCandidateBaseURL + '/ReadAllPaginated';


// ============================================================
//  CONTACT (basic)  — /CRM/CT
// ============================================================
export const Contact_Create:           string = CrmContactBaseURL + '/Create';
export const Contact_Update:           string = CrmContactBaseURL + '/Update';
export const Contact_Delete:           string = CrmContactBaseURL + '/Delete';
export const Contact_ReadById:         string = CrmContactBaseURL + '/ReadById';
export const Contact_ReadAll:          string = CrmContactBaseURL + '/ReadAll';
export const Contact_ReadAllPaginated: string = CrmContactBaseURL + '/ReadAllPaginated';


// ============================================================
//  LEAD MASTER  — /CRM/LM
// ============================================================
export const LeadMaster_Create:           string = CrmLeadMasterBaseURL + '/Create';
export const LeadMaster_Update:           string = CrmLeadMasterBaseURL + '/Update';
export const LeadMaster_Delete:           string = CrmLeadMasterBaseURL + '/Delete';
export const LeadMaster_ReadById:         string = CrmLeadMasterBaseURL + '/ReadById';
export const LeadMaster_ReadAll:          string = CrmLeadMasterBaseURL + '/ReadAll';
export const LeadMaster_ReadAllPaginated: string = CrmLeadMasterBaseURL + '/ReadAllPaginated';
export const LeadMaster_CreateWithAssignment = environment.crmApiURL + '/CRM/LM/CreateWithAssignment';

// ============================================================
//  LEAD DETAIL  — /CRM/LD
// ============================================================
export const LeadDetail_Create:           string = CrmLeadDetailBaseURL + '/Create';
export const LeadDetail_Update:           string = CrmLeadDetailBaseURL + '/Update';
export const LeadDetail_Delete:           string = CrmLeadDetailBaseURL + '/Delete';
export const LeadDetail_ReadById:         string = CrmLeadDetailBaseURL + '/ReadById';
export const LeadDetail_ReadAll:          string = CrmLeadDetailBaseURL + '/ReadAll';
export const LeadDetail_ReadAllPaginated: string = CrmLeadDetailBaseURL + '/ReadAllPaginated';


// ============================================================
//  LEAD ACTIVITY  — /CRM/LA
// ============================================================
export const LeadActivity_Create:           string = CrmLeadActivityBaseURL + '/Create';
export const LeadActivity_Update:           string = CrmLeadActivityBaseURL + '/Update';
export const LeadActivity_Delete:           string = CrmLeadActivityBaseURL + '/Delete';
export const LeadActivity_ReadById:         string = CrmLeadActivityBaseURL + '/ReadById';
export const LeadActivity_ReadAll:          string = CrmLeadActivityBaseURL + '/ReadAll';
export const LeadActivity_ReadAllPaginated: string = CrmLeadActivityBaseURL + '/ReadAllPaginated';


// ============================================================
//  LEAD ASSIGNEE  — /CRM/LAS
// ============================================================
export const LeadAssignee_Create:           string = CrmLeadAssigneeBaseURL + '/Create';
export const LeadAssignee_Update:           string = CrmLeadAssigneeBaseURL + '/Update';
export const LeadAssignee_Delete:           string = CrmLeadAssigneeBaseURL + '/Delete';
export const LeadAssignee_ReadById:         string = CrmLeadAssigneeBaseURL + '/ReadById';
export const LeadAssignee_ReadAll:          string = CrmLeadAssigneeBaseURL + '/ReadAll';
export const LeadAssignee_ReadAllPaginated: string = CrmLeadAssigneeBaseURL + '/ReadAllPaginated';


// ============================================================
//  LEAD CHECKLIST  — /CRM/LCL
// ============================================================
export const LeadCheckList_Create:           string = CrmLeadCheckListBaseURL + '/Create';
export const LeadCheckList_Update:           string = CrmLeadCheckListBaseURL + '/Update';
export const LeadCheckList_Delete:           string = CrmLeadCheckListBaseURL + '/Delete';
export const LeadCheckList_ReadById:         string = CrmLeadCheckListBaseURL + '/ReadById';
export const LeadCheckList_ReadAll:          string = CrmLeadCheckListBaseURL + '/ReadAll';
export const LeadCheckList_ReadAllPaginated: string = CrmLeadCheckListBaseURL + '/ReadAllPaginated';


// ============================================================
//  OPPORTUNITY  — /CRM/OPP
// ============================================================
export const Opportunity_Create:           string = CrmOpportunityBaseURL + '/Create';
export const Opportunity_Intake:          string = CrmOpportunityBaseURL + '/Intake';
export const Opportunity_Update:           string = CrmOpportunityBaseURL + '/Update';
export const Opportunity_Delete:           string = CrmOpportunityBaseURL + '/Delete';
export const Opportunity_ReadById:         string = CrmOpportunityBaseURL + '/ReadById';
export const Opportunity_ReadAll:          string = CrmOpportunityBaseURL + '/ReadAll';
export const Opportunity_ReadAllPaginated: string = CrmOpportunityBaseURL + '/ReadAllPaginated';
export const Opportunity_MoveStage:        string = CrmOpportunityBaseURL + '/MoveStage';
export const Opportunity_Assign: string = CrmOpportunityBaseURL + '/Assign';
export const Opportunity_Close:            string = CrmOpportunityBaseURL + '/Close';
export const Opportunity_ReadByEntityId = CrmOpportunityBaseURL + '/ReadByEntityId';
export const Opportunity_CreateWithEntity =
  `${environment.crmApiURL}/CRM/OPP/CreateWithEntity`;

// ============================================================
//  LOAN HANDOFF — /CRM/LH (read-only from Angular; callback secret is server-side)
// ============================================================
export const LoanHandoff_ReadByOpportunityId: string = CrmLoanHandoffBaseURL + '/ReadByOpportunityId';

// ============================================================
//  OPPORTUNITY PARTICIPANT  — /CRM/OPPT
// ============================================================
export const OpportunityParticipant_Create:           string = CrmOpportunityParticipantBaseURL + '/Create';
export const OpportunityParticipant_Update:           string = CrmOpportunityParticipantBaseURL + '/Update';
export const OpportunityParticipant_Delete:           string = CrmOpportunityParticipantBaseURL + '/Delete';
export const OpportunityParticipant_ReadById:         string = CrmOpportunityParticipantBaseURL + '/ReadById';
export const OpportunityParticipant_ReadAll:          string = CrmOpportunityParticipantBaseURL + '/ReadAll';
export const OpportunityParticipant_ReadAllPaginated: string = CrmOpportunityParticipantBaseURL + '/ReadAllPaginated';
export const OpportunityParticipant_ReadByOpportunityId = CrmOpportunityParticipantBaseURL + '/ReadByOpportunityId';

// ============================================================
//  OPPORTUNITY STAGE HISTORY  — /CRM/OSH
// ============================================================
export const OpportunityStageHistory_Create:           string = CrmOpportunityStageHistoryBaseURL + '/Create';
export const OpportunityStageHistory_ReadById:         string = CrmOpportunityStageHistoryBaseURL + '/ReadById';
export const OpportunityStageHistory_ReadAll:          string = CrmOpportunityStageHistoryBaseURL + '/ReadAll';
export const OpportunityStageHistory_ReadAllPaginated: string = CrmOpportunityStageHistoryBaseURL + '/ReadAllPaginated';
export const OpportunityStageHistory_ReadByOpportunityId = CrmOpportunityStageHistoryBaseURL + '/ReadByOpportunityId';

// ============================================================
//  OPPORTUNITY ASSIGNMENT HISTORY  — /CRM/OAH
// ============================================================
export const OpportunityAssignmentHistory_Create:           string = CrmOpportunityAssignHistBaseURL + '/Create';
export const OpportunityAssignmentHistory_ReadAll:          string = CrmOpportunityAssignHistBaseURL + '/ReadAll';
export const OpportunityAssignmentHistory_ReadAllPaginated: string = CrmOpportunityAssignHistBaseURL + '/ReadAllPaginated';
export const OpportunityAssignmentHistory_ReadByOpportunityId = CrmOpportunityAssignHistBaseURL + '/ReadByOpportunityId';

// ============================================================
//  OPPORTUNITY FIELD VALUE  — /CRM/OFV
// ============================================================
export const OpportunityFieldValue_Create:           string = CrmOpportunityFieldValueBaseURL + '/Create';
export const OpportunityFieldValue_Update:           string = CrmOpportunityFieldValueBaseURL + '/Update';
export const OpportunityFieldValue_ReadAll:          string = CrmOpportunityFieldValueBaseURL + '/ReadAll';
export const OpportunityFieldValue_ReadAllPaginated: string = CrmOpportunityFieldValueBaseURL + '/ReadAllPaginated';
export const OpportunityFieldValue_ReadByOpportunityId = CrmOpportunityFieldValueBaseURL + '/ReadByOpportunityId';

// ============================================================
//  PIPELINE  — /CRM/PIP
// ============================================================
export const Pipeline_Create:           string = CrmPipelineBaseURL + '/Create';
export const Pipeline_Update:           string = CrmPipelineBaseURL + '/Update';
export const Pipeline_Delete:           string = CrmPipelineBaseURL + '/Delete';
export const Pipeline_ReadById:         string = CrmPipelineBaseURL + '/ReadById';
export const Pipeline_ReadAll:          string = CrmPipelineBaseURL + '/ReadAll';
export const Pipeline_ReadAllPaginated: string = CrmPipelineBaseURL + '/ReadAllPaginated';


// ============================================================
//  PIPELINE STAGE  — /CRM/PS
// ============================================================
export const PipelineStage_Create:           string = CrmPipelineStageBaseURL + '/Create';
export const PipelineStage_Update:           string = CrmPipelineStageBaseURL + '/Update';
export const PipelineStage_Delete:           string = CrmPipelineStageBaseURL + '/Delete';
export const PipelineStage_ReadById:         string = CrmPipelineStageBaseURL + '/ReadById';
export const PipelineStage_ReadAll:          string = CrmPipelineStageBaseURL + '/ReadAll';
export const PipelineStage_ReadAllPaginated: string = CrmPipelineStageBaseURL + '/ReadAllPaginated';


// ============================================================
//  STAGE TRANSITION  — /CRM/ST
// ============================================================
export const StageTransition_Create:           string = CrmStageTransitionBaseURL + '/Create';
export const StageTransition_Update:           string = CrmStageTransitionBaseURL + '/Update';
export const StageTransition_Delete:           string = CrmStageTransitionBaseURL + '/Delete';
export const StageTransition_ReadById:         string = CrmStageTransitionBaseURL + '/ReadById';
export const StageTransition_ReadAll:          string = CrmStageTransitionBaseURL + '/ReadAll';
export const StageTransition_ReadAllPaginated: string = CrmStageTransitionBaseURL + '/ReadAllPaginated';



 // ============================================================
 //  CRM PRODUCT MASTER — /CRM/PRD
 // ============================================================

export const CRMProduct_Create:           string = CrmProductBaseURL + '/Create';
export const CRMProduct_Update:           string = CrmProductBaseURL + '/Update';
export const CRMProduct_ReadById:         string = CrmProductBaseURL + '/ReadById';
export const CRMProduct_Delete:           string = CrmProductBaseURL + '/Delete';
export const CRMProduct_ReadAll:          string = CrmProductBaseURL + '/ReadAll';
export const CRMProduct_ReadByVerticalId: string = CrmProductBaseURL + '/ReadByVerticalId';




// ============================================================
//  SUB-PRODUCT  — /CRM/SP
// ============================================================
export const SubProduct_Create:           string = CrmSubProductBaseURL + '/Create';
export const SubProduct_Update:           string = CrmSubProductBaseURL + '/Update';
export const SubProduct_Delete:           string = CrmSubProductBaseURL + '/Delete';
export const SubProduct_ReadById:         string = CrmSubProductBaseURL + '/ReadById';
export const SubProduct_ReadAll:          string = CrmSubProductBaseURL + '/ReadAll';
export const SubProduct_ReadAllPaginated: string = CrmSubProductBaseURL + '/ReadAllPaginated';


// ============================================================
//  VERTICAL  — /CRM/VRT
// ============================================================
export const Vertical_Create:           string = CrmVerticalBaseURL + '/Create';
export const Vertical_Update:           string = CrmVerticalBaseURL + '/Update';
export const Vertical_Delete:           string = CrmVerticalBaseURL + '/Delete';
export const Vertical_ReadById:         string = CrmVerticalBaseURL + '/ReadById';
export const Vertical_ReadAll:          string = CrmVerticalBaseURL + '/ReadAll';
export const Vertical_ReadAllPaginated: string = CrmVerticalBaseURL + '/ReadAllPaginated';


// ============================================================
//  TEAM  — /CRM/TM
// ============================================================
export const Team_Create:           string = CrmTeamBaseURL + '/Create';
export const Team_Update:           string = CrmTeamBaseURL + '/Update';
export const Team_Delete:           string = CrmTeamBaseURL + '/Delete';
export const Team_ReadById:         string = CrmTeamBaseURL + '/ReadById';
export const Team_ReadAll:          string = CrmTeamBaseURL + '/ReadAll';
export const Team_ReadAllPaginated: string = CrmTeamBaseURL + '/ReadAllPaginated';
export const Team_AssignUser:       string = CrmTeamBaseURL + '/AssignUser';

// ============================================================
//  TEAM MEMBER  — /CRM/TEM
// ============================================================
export const TeamMember_Create:           string = CrmTeamMemberBaseURL + '/Create';
export const TeamMember_Update:           string = CrmTeamMemberBaseURL + '/Update';
export const TeamMember_Delete:           string = CrmTeamMemberBaseURL + '/Delete';
export const TeamMember_ReadById:         string = CrmTeamMemberBaseURL + '/ReadById';
export const TeamMember_ReadAll:          string = CrmTeamMemberBaseURL + '/ReadAll';
export const TeamMember_ReadAllPaginated: string = CrmTeamMemberBaseURL + '/ReadAllPaginated';


// ============================================================
//  FIELD DEFINITION  — /CRM/FD
// ============================================================
export const FieldDefinition_Create:           string = CrmFieldDefinitionBaseURL + '/Create';
export const FieldDefinition_Update:           string = CrmFieldDefinitionBaseURL + '/Update';
export const FieldDefinition_Delete:           string = CrmFieldDefinitionBaseURL + '/Delete';
export const FieldDefinition_ReadById:         string = CrmFieldDefinitionBaseURL + '/ReadById';
export const FieldDefinition_ReadAll:          string = CrmFieldDefinitionBaseURL + '/ReadAll';
export const FieldDefinition_ReadAllPaginated: string = CrmFieldDefinitionBaseURL + '/ReadAllPaginated';
export const FieldDefinition_ReadByProductId: string = CrmFieldDefinitionBaseURL + '/ReadByProductId';

// ============================================================
//  TAG  — /CRM/TAG
// ============================================================
export const Tag_Create:           string = CrmTagBaseURL + '/Create';
export const Tag_Update:           string = CrmTagBaseURL + '/Update';
export const Tag_Delete:           string = CrmTagBaseURL + '/Delete';
export const Tag_ReadById:         string = CrmTagBaseURL + '/ReadById';
export const Tag_ReadAll:          string = CrmTagBaseURL + '/ReadAll';
export const Tag_ReadAllPaginated: string = CrmTagBaseURL + '/ReadAllPaginated';


// ============================================================
//  MEETING  — /CRM/MTG
// ============================================================
export const Meeting_Create:            string = CrmMeetingBaseURL + '/Create';
export const Meeting_Update:            string = CrmMeetingBaseURL + '/Update';
export const Meeting_Delete:            string = CrmMeetingBaseURL + '/Delete';
export const Meeting_ReadById:          string = CrmMeetingBaseURL + '/ReadById';
export const Meeting_ReadAll:           string = CrmMeetingBaseURL + '/ReadAll';
export const Meeting_ReadByModule:      string = CrmMeetingBaseURL + '/ReadByModule';
export const Meeting_ReadAllPaginated: string = CrmMeetingBaseURL + '/ReadAllPaginated';
export const Meeting_FollowUpLog_Create: string = CrmMeetingBaseURL + '/CreateFollowUpLog';

export const MeetingDetail_Create:            string = CrmMeetingDetailBaseURL + '/Create';
export const MeetingDetail_Update:            string = CrmMeetingDetailBaseURL + '/Update';
export const MeetingDetail_Delete:            string = CrmMeetingDetailBaseURL + '/Delete';
export const MeetingDetail_ReadById:          string = CrmMeetingDetailBaseURL + '/ReadById';
export const MeetingDetail_ReadAll:           string = CrmMeetingDetailBaseURL + '/ReadAll';
//  export const MeetingDetail_ReadAllPaginated:  string = MeetingDetail_ReadAll;
export const MeetingDetail_ReadAllPaginated:  string = CrmMeetingDetailBaseURL + '/ReadAllPaginated';

export const MeetingMaster_Create:   string = CrmMeetingMasterBaseURL + '/Create';
export const MeetingMaster_Update:   string = CrmMeetingMasterBaseURL + '/Update';
export const MeetingMaster_Delete:   string = CrmMeetingMasterBaseURL + '/Delete';
export const MeetingMaster_ReadById: string = CrmMeetingMasterBaseURL + '/ReadById';
export const MeetingMaster_ReadAll:  string = CrmMeetingMasterBaseURL + '/ReadAll';
export const MeetingMaster_ReadAllPaginated: string = CrmMeetingMasterBaseURL + '/ReadAllPaginated';
// ============================================================
//  TASK  — /CRM/TSK
// ============================================================
 

export const Activity_Create:            string = CrmActivityBaseURL + '/Create';
export const Activity_Update:            string = CrmActivityBaseURL + '/Update';
export const Activity_Delete:            string = CrmActivityBaseURL + '/Delete';
export const Activity_ReadById:          string = CrmActivityBaseURL + '/ReadById';
export const Activity_ReadAll:           string = CrmActivityBaseURL + '/ReadAll';
export const Activity_ReadByModule:      string = CrmActivityBaseURL + '/ReadByModule';
export const Activity_ReadAllPaginated:  string = CrmActivityBaseURL + '/ReadAllPaginated';            

export const FollowUp_Create:               string = CrmFollowUpBaseURL + '/Create';
export const FollowUp_Update:               string = CrmFollowUpBaseURL + '/Update';
export const FollowUp_Delete:               string = CrmFollowUpBaseURL + '/Delete';
export const FollowUp_ReadById:             string = CrmFollowUpBaseURL + '/ReadById';
export const FollowUp_ReadAll:              string = CrmFollowUpBaseURL + '/ReadAll';
export const FollowUp_ReadByOpportunityId:  string = CrmFollowUpBaseURL + '/ReadByOpportunityId';
export const FUS_ReadMyWork:    string = CrmFollowUpScheduleBaseURL + '/ReadMyWork';
export const FUS_CompleteCall:  string = CrmFollowUpScheduleBaseURL + '/CompleteCall';
export const FollowUp_ReadAllPaginated:     string = CrmFollowUpBaseURL + '/ReadAllPaginated';  //                 // ✅ point to real route


// ============================================================
// FLOW-27 — CRM Executive Dashboard KPI
// ============================================================

export const CrmDashboardBaseURL: string = CrmBaseURL + '/LM';

export const CRM_DashboardKPI_ReadSummary: string =
  CrmDashboardBaseURL + '/KPI/KpiSummary';


// ============================================================
//  FIELD VISIT  — /CRM/FV
// ============================================================
export const FieldVisit_Create:           string = CrmFieldVisitBaseURL + '/Create';
export const FieldVisit_Update:           string = CrmFieldVisitBaseURL + '/Update';
export const FieldVisit_Delete:           string = CrmFieldVisitBaseURL + '/Delete';
export const FieldVisit_ReadById:         string = CrmFieldVisitBaseURL + '/ReadById';
export const FieldVisit_ReadAll:          string = CrmFieldVisitBaseURL + '/ReadAll';
export const FieldVisit_ReadAllPaginated: string = CrmFieldVisitBaseURL + '/ReadAllPaginated';



// ============================================================
//  CONVERSATION  — /CRM/CNV
// ============================================================
export const Conversation_Create:            string = CrmConversationBaseURL + '/Create';
export const Conversation_Update:            string = CrmConversationBaseURL + '/Update';
export const Conversation_Delete:            string = CrmConversationBaseURL + '/Delete';
export const Conversation_ReadById:          string = CrmConversationBaseURL + '/ReadById';
export const Conversation_ReadAll:           string = CrmConversationBaseURL + '/ReadAll';
export const Conversation_ReadByModule:      string = CrmConversationBaseURL + '/ReadByModule';
export const Conversation_ReadAllPaginated:  string = CrmConversationBaseURL + '/ReadAllPaginated';

// ============================================================
//  WHATSAPP INBOX — CONVERSATION ACTIONS
//  Proposed endpoints: backend/Ocelot verification required
// ============================================================

export const Conversation_Assign: string = CrmConversationBaseURL + '/Assign';
export const Conversation_LinkOpportunity: string = CrmConversationBaseURL + '/LinkOpportunity';
export const Conversation_ReadByOpportunityId: string = CrmConversationBaseURL + '/ReadByOpportunityId';
export const Conversation_AddInternalNote: string = CrmConversationBaseURL + '/AddInternalNote';
export const Conversation_UpdateStatus: string = CrmConversationBaseURL + '/UpdateStatus';

// ============================================================
//  CONVERSATION PARTICIPANT  — /CRM/CNP
// ============================================================
export const ConversationParticipant_Create:           string = CrmConversationParticipantBaseURL + '/Create';
export const ConversationParticipant_Update:           string = CrmConversationParticipantBaseURL + '/Update';
export const ConversationParticipant_Delete:           string = CrmConversationParticipantBaseURL + '/Delete';
export const ConversationParticipant_ReadById:         string = CrmConversationParticipantBaseURL + '/ReadById';
export const ConversationParticipant_ReadAll:          string = CrmConversationParticipantBaseURL + '/ReadAll';
export const ConversationParticipant_ReadByConversationId: string = CrmConversationParticipantBaseURL + '/ReadByConversationId';
export const ConversationParticipant_ReadAllPaginated: string = CrmConversationParticipantBaseURL + '/ReadAllPaginated';

// ============================================================
//  MESSAGE  — /CRM/MSG
// ============================================================
export const Message_Create:                string = CrmMessageBaseURL + '/Create';
export const Message_Update:                string = CrmMessageBaseURL + '/Update';
export const Message_Delete:                string = CrmMessageBaseURL + '/Delete';
export const Message_ReadById:              string = CrmMessageBaseURL + '/ReadById';
export const Message_ReadAll:               string = CrmMessageBaseURL + '/ReadAll';
export const Message_ReadByConversationId:  string = CrmMessageBaseURL + '/ReadByConversationId';
export const Message_ReadAllPaginated:      string = CrmMessageBaseURL + '/ReadAllPaginated';

// ============================================================
//  WHATSAPP INBOX — MESSAGE SENDING
//  Proposed endpoints: backend/Ocelot verification required
// ============================================================

export const Message_SendText: string =
  CrmMessageBaseURL + '/SendText';

export const Message_SendMedia: string =
  CrmMessageBaseURL + '/SendMedia';

// ============================================================
//  WHATSAPP REALTIME — SignalR Hub & New REST endpoints
//  Backend: /Notification/WhatsAppMessage  |  Gateway: /NT/WAM
// ============================================================

export const WhatsAppRealtimeBaseURL: string = NotificationBaseURL + '/WAM';
export const WhatsAppHubURL: string = WhatsAppRealtimeBaseURL + '/hubs/whatsapp';

// Conversations & Messages (cursor-paged)
export const WhatsAppRealtime_GetConversations: string = WhatsAppRealtimeBaseURL + '/api/whatsapp/conversations';
export const WhatsAppRealtime_GetMessages: string = WhatsAppRealtimeBaseURL + '/api/whatsapp/conversations'; // append /{chatId}/messages
export const WhatsAppRealtime_MarkRead: string = WhatsAppRealtimeBaseURL + '/api/whatsapp/conversations'; // append /{chatId}/read
export const WhatsAppRealtime_SendMessage: string = WhatsAppRealtimeBaseURL + '/api/whatsapp/messages/send';
export const WhatsAppRealtime_GetMedia: string = WhatsAppRealtimeBaseURL + '/api/whatsapp/messages'; // append /{id}/media

// Sessions
export const WhatsAppRealtime_GetSessions: string = WhatsAppRealtimeBaseURL + '/api/whatsapp/sessions';
export const WhatsAppRealtime_GetSessionStatus: string = WhatsAppRealtimeBaseURL + '/api/whatsapp/sessions'; // append /{session}/status
export const WhatsAppRealtime_StartSession: string = WhatsAppRealtimeBaseURL + '/api/whatsapp/sessions'; // append /{session}/start
export const WhatsAppRealtime_StopSession: string = WhatsAppRealtimeBaseURL + '/api/whatsapp/sessions';  // append /{session}/stop
export const WhatsAppRealtime_RestartSession: string = WhatsAppRealtimeBaseURL + '/api/whatsapp/sessions'; // append /{session}/restart

// AI Agent
export const WhatsAppAgent_Trigger: string = WhatsAppRealtimeBaseURL + '/api/whatsapp/agent/trigger';
export const WhatsAppAgent_FollowUp: string = WhatsAppRealtimeBaseURL + '/api/whatsapp/agent/followup';
export const WhatsAppAgent_ScheduleSend: string = WhatsAppRealtimeBaseURL + '/api/whatsapp/agent/send';
export const WhatsAppAgent_GetTasks: string = WhatsAppRealtimeBaseURL + '/api/whatsapp/agent/tasks';
export const WhatsAppAgent_CancelTask: string = WhatsAppRealtimeBaseURL + '/api/whatsapp/agent/tasks'; // append /{id}
export const WhatsAppAgent_GetSettings: string = WhatsAppRealtimeBaseURL + '/api/whatsapp/agent/settings';
export const WhatsAppAgent_UpdateSettings: string = WhatsAppRealtimeBaseURL + '/api/whatsapp/agent/settings';
export const WhatsAppAgent_GetSettings_WAA: string = NotificationBaseURL + '/WAA/Setting';
export const WhatsAppAgent_UpdateSettings_WAA: string = NotificationBaseURL + '/WAA/Setting';

  
// ============================================================
//  CALL LOG  — /CRM/CL
// ============================================================
export const CallLog_Create:                string = CrmCallLogBaseURL + '/Create';
export const CallLog_Update:                string = CrmCallLogBaseURL + '/Update';
export const CallLog_Delete:                string = CrmCallLogBaseURL + '/Delete';
export const CallLog_ReadById:              string = CrmCallLogBaseURL + '/ReadById';
export const CallLog_ReadAll:               string = CrmCallLogBaseURL + '/ReadAll';
export const CallLog_ReadByConversationId:  string = CrmCallLogBaseURL + '/ReadByConversationId';
export const CallLog_ReadAllPaginated:      string = CrmCallLogBaseURL + '/ReadAllPaginated';

//The Communications module has transitioned to the AccountConfig-based integration. The existing ChannelAccount constants and legacy gateway routes are being retained temporarily for backward compatibility and to avoid disruption to existing integrations.
//The remaining ChannelAccount cleanup and complete migration verification are scheduled for an upcoming implementation release.
//Current Implementation: AccountConfig integration implemented as reported in R21.
//Pending: Legacy ChannelAccount reference cleanup, gateway route retirement, mobile AccountConfig mapping verification, and end-to-end regression testing.
//Risk Treatment: Documented technical debt with planned remediation before final production migration.
//Audit Disposition: DEFERRED — ACCEPTED TECHNICAL DEBT. Not eligible for verified technical closure until the pending remediation is completed.
// ============================================================
//  CHANNEL ACCOUNT  — /CRM/CA
// ============================================================
export const ChannelAccount_Create:            string = CrmChannelAccountBaseURL + '/Create';
export const ChannelAccount_Update:            string = CrmChannelAccountBaseURL + '/Update';
export const ChannelAccount_Delete:            string = CrmChannelAccountBaseURL + '/Delete';
export const ChannelAccount_ReadById:          string = CrmChannelAccountBaseURL + '/ReadById';
export const ChannelAccount_ReadAll:           string = CrmChannelAccountBaseURL + '/ReadAll';
export const ChannelAccount_ReadAllPaginated:  string = CrmChannelAccountBaseURL + '/ReadAllPaginated';

// ============================================================
//  CONTACT PREFERENCE  — /CRM/CPR
// ============================================================
export const ContactPreference_Create:            string = CrmContactPreferenceBaseURL + '/Create';
export const ContactPreference_Update:            string = CrmContactPreferenceBaseURL + '/Update';
export const ContactPreference_Delete:            string = CrmContactPreferenceBaseURL + '/Delete';
export const ContactPreference_ReadById:          string = CrmContactPreferenceBaseURL + '/ReadById';
export const ContactPreference_ReadAll:           string = CrmContactPreferenceBaseURL + '/ReadAll';
export const ContactPreference_ReadByEntityId:    string = CrmContactPreferenceBaseURL + '/ReadByEntityId';
export const ContactPreference_ReadAllPaginated:  string = CrmContactPreferenceBaseURL + '/ReadAllPaginated';


// ============================================================
//  FACEBOOK  — /CRM/FB
// ============================================================
export const FacebookConfig_ReadAll:   string = CrmFacebookBaseURL + '/Config/ReadAll';
export const FacebookConfig_Create:    string = CrmFacebookBaseURL + '/Config/Create';
export const FacebookPages_ReadAll:    string = CrmFacebookBaseURL + '/Pages/ReadAll';
export const FacebookPages_Update:     string = CrmFacebookBaseURL + '/Pages/Update';
export const FacebookLeadForms_ReadAll:string = CrmFacebookBaseURL + '/Forms/ReadAll';
export const FacebookLeadForms_Update: string = CrmFacebookBaseURL + '/Forms/Update';


// ============================================================
//  IMPORT JOB  — /CRM/IJ
// ============================================================
export const ImportJob_Create:           string = CrmImportJobBaseURL + '/Create';
export const ImportJob_ReadById:         string = CrmImportJobBaseURL + '/ReadById';
export const ImportJob_ReadAll:          string = CrmImportJobBaseURL + '/ReadAll';
export const ImportJob_ReadAllPaginated: string = CrmImportJobBaseURL + '/ReadAllPaginated';
// FLOW-29 — existing multipart upload + read-only status/error download routes.
export const ImportJob_Upload:           string = CrmImportJobBaseURL + '/Upload';
export const ImportJob_Status:           string = CrmImportJobBaseURL + '/Status';
export const ImportJob_DownloadErrors:   string = CrmImportJobBaseURL + '/DownloadErrors';


// ============================================================
//  SITE MASTER  — /CRM/SITE
// ============================================================
export const SiteMaster_Create:           string = CrmSiteMasterBaseURL + '/Create';
export const SiteMaster_Update:           string = CrmSiteMasterBaseURL + '/Update';
export const SiteMaster_Delete:           string = CrmSiteMasterBaseURL + '/Delete';
export const SiteMaster_ReadById:         string = CrmSiteMasterBaseURL + '/ReadById';
export const SiteMaster_ReadAll:          string = CrmSiteMasterBaseURL + '/ReadAll';
export const SiteMaster_ReadAllPaginated: string = CrmSiteMasterBaseURL + '/ReadAllPaginated';


// ============================================================
//  MARKETING — CAMPAIGN  — /CRM/CMP
// ============================================================
export const Campaign_Create:            string = MktCampaignBaseURL + '/Create';
export const Campaign_Update:            string = MktCampaignBaseURL + '/Update';
export const Campaign_Delete:            string = MktCampaignBaseURL + '/Delete';
export const Campaign_ReadById:          string = MktCampaignBaseURL + '/ReadById';
export const Campaign_ReadAll:           string = MktCampaignBaseURL + '/ReadAll';
export const Campaign_ReadAllPaginated:  string = MktCampaignBaseURL + '/ReadAllPaginated';


// ============================================================
//  MARKETING — SPEND  — /CRM/SPD
// ============================================================
export const CampaignSpend_Create:            string = MktSpendBaseURL + '/Create';
export const CampaignSpend_Update:            string = MktSpendBaseURL + '/Update';
export const CampaignSpend_Delete:            string = MktSpendBaseURL + '/Delete';
export const CampaignSpend_ReadAll:           string = MktSpendBaseURL + '/ReadAll';
export const CampaignSpend_ReadAllPaginated:  string = MktSpendBaseURL + '/ReadAllPaginated';


// ============================================================
//  MARKETING — TOUCHPOINT  — /CRM/TCH
// ============================================================
export const CampaignTouchpoint_Create:            string = MktTouchpointBaseURL + '/Create';
export const CampaignTouchpoint_ReadAll:           string = MktTouchpointBaseURL + '/ReadAll';
export const CampaignTouchpoint_ReadAllPaginated:  string = MktTouchpointBaseURL + '/ReadAllPaginated';


// ============================================================
//  MARKETING — AUDIENCE  — /CRM/AUD
// ============================================================
export const Audience_Create:            string = MktAudienceBaseURL + '/Create';
export const Audience_Update:            string = MktAudienceBaseURL + '/Update';
export const Audience_Delete:            string = MktAudienceBaseURL + '/Delete';
export const Audience_ReadAll:           string = MktAudienceBaseURL + '/ReadAll';
export const Audience_ReadAllPaginated:  string = MktAudienceBaseURL + '/ReadAllPaginated';


// ============================================================
//  MARKETING — EMAIL  — /CRM/EML
// ============================================================
export const EmailMarketing_Create:            string = MktEmailBaseURL + '/Create';
export const EmailMarketing_ReadAll:           string = MktEmailBaseURL + '/ReadAll';
export const EmailMarketing_ReadAllPaginated:  string = MktEmailBaseURL + '/ReadAllPaginated';


// ============================================================
//  MARKETING — UNSUBSCRIBED  — /CRM/UNS
// ============================================================
export const UnsubscribedAlerts_Create:            string = MktUnsubBaseURL + '/Create';
export const UnsubscribedAlerts_ReadAll:           string = MktUnsubBaseURL + '/ReadAll';
export const UnsubscribedAlerts_ReadAllPaginated:  string = MktUnsubBaseURL + '/ReadAllPaginated';


// ============================================================
//  REVENUE ATTRIBUTION  — /CRM/RA
// ============================================================
export const RevenueAttribution_ReadAll:           string = RevAttrBaseURL + '/ReadAll';
export const RevenueAttribution_ReadAllPaginated:  string = RevAttrBaseURL + '/ReadAllPaginated';


// ============================================================
//  CUSTOMER SUCCESS — LIFECYCLE  — /CRM/AL
// ============================================================
export const AccountLifecycle_Create:            string = CsLifecycleBaseURL + '/Create';
export const AccountLifecycle_ReadAll:           string = CsLifecycleBaseURL + '/ReadAll';
export const AccountLifecycle_ReadAllPaginated:  string = CsLifecycleBaseURL + '/ReadAllPaginated';
export const AccountLifecycle_Update :            string = CsLifecycleBaseURL + '/Update';
export const AccountLifecycle_Delete:           string = CsLifecycleBaseURL + '/Delete';
// ============================================================
//  CUSTOMER SUCCESS — HEALTH SCORE  — /CRM/HS
// ============================================================
export const HealthScore_Create:            string = CsHealthBaseURL + '/Create';
export const HealthScore_Update:            string = CsHealthBaseURL + '/Update';
export const HealthScore_ReadAll:           string = CsHealthBaseURL + '/ReadAll';
export const HealthScore_ReadAllPaginated:  string = CsHealthBaseURL + '/ReadAllPaginated';
export const HealthScore_Delete:            string = CsHealthBaseURL + '/Delete';
export const HealthScore_ReadByEntityId: string =
  CsHealthBaseURL + '/ReadByEntityId';
// ============================================================
//  CUSTOMER SUCCESS — ONBOARDING PLANS  — /CRM/OP
// ============================================================
export const OnboardingPlan_ReadAll:           string = CsPlanBaseURL + '/ReadAll';
export const OnboardingPlan_ReadAllPaginated:  string = CsPlanBaseURL + '/ReadAllPaginated';
export const OnboardingPlan_Create  :          string = CsPlanBaseURL + '/Create';
export const OnboardingPlan_Update  :         string = CsPlanBaseURL + '/Update';
export const OnboardingPlan_Delete    :       string = CsPlanBaseURL + '/Delete';

// ============================================================
//  CUSTOMER SUCCESS — ONBOARDING TASKS  — /CRM/OT
// ============================================================
export const OnboardingTask_Create:            string = CsTaskBaseURL + '/Create';
export const OnboardingTask_Update:            string = CsTaskBaseURL + '/Update';
export const OnboardingTask_ReadAll:           string = CsTaskBaseURL + '/ReadAll';
export const OnboardingTask_ReadAllPaginated:  string = CsTaskBaseURL + '/ReadAllPaginated';
export const OnboardingTask_Delete   :        string = CsTaskBaseURL + '/Delete';
export const OnboardingTask_ReadByOnboardingPlanId   :        string = CsTaskBaseURL + '/ReadByOnboardingPlanId';
// ============================================================
//  CUSTOMER SUCCESS — RENEWALS  — /CRM/REN
// ============================================================
export const Renewal_Update:            string = CsRenewalBaseURL + '/Update';
export const Renewal_ReadAll:           string = CsRenewalBaseURL + '/ReadAll';
export const Renewal_ReadAllPaginated:  string = CsRenewalBaseURL + '/ReadAllPaginated';
export const Renewal_Delete        :  string = CsRenewalBaseURL+ '/Delete';
export const Renewal_Create          :  string = CsRenewalBaseURL+  '/Create';
export const Renewal_ReadByEntityId: string =
  CsRenewalBaseURL + '/ReadByEntityId';
// ============================================================
//  CONTRACTS — PROPOSAL  — /CRM/PRP
// ============================================================
export const Proposal_Create:            string = BizProposalBaseURL + '/Create';
export const Proposal_Update:            string = BizProposalBaseURL + '/Update';
export const Proposal_ReadAll:           string = BizProposalBaseURL + '/ReadAll';
export const Proposal_ReadAllPaginated:  string = BizProposalBaseURL + '/ReadAllPaginated';


// ============================================================
//  CONTRACTS — CONTRACT  — /CRM/CON
// ============================================================
export const Contract_Create:            string = BizContractBaseURL + '/Create';
export const Contract_Update:            string = BizContractBaseURL + '/Update';
export const Contract_Delete:            string = BizContractBaseURL + '/Delete';
export const Contract_ReadAll:           string = BizContractBaseURL + '/ReadAll';
export const Contract_ReadAllPaginated:  string = BizContractBaseURL + '/ReadAllPaginated';
export const Contract_ReadById: string =
  BizContractBaseURL + '/ReadById';

export const Contract_ReadByEntityId: string =
  BizContractBaseURL + '/ReadByEntityId';

// ============================================================
//  CONTRACTS — SUBSCRIPTION  — /CRM/SUB
// ============================================================
export const Subscription_Create:            string = BizSubscriptionBaseURL + '/Create';
export const Subscription_Update:            string = BizSubscriptionBaseURL + '/Update';
export const Subscription_ReadAll:           string = BizSubscriptionBaseURL + '/ReadAll';
export const Subscription_ReadAllPaginated:  string = BizSubscriptionBaseURL + '/ReadAllPaginated';


// ============================================================
//  AUTOMATION — WORKFLOW  — /CRM/WF/Workflow
// ============================================================
export const Workflow_Create:            string = CrmAutoBaseURL + '/Create';
export const Workflow_Update:            string = CrmAutoBaseURL + '/Update';
export const Workflow_Delete:            string = CrmAutoBaseURL + '/Delete';
export const Workflow_ReadAll:           string = CrmAutoBaseURL + '/ReadAll';
export const Workflow_ReadAllPaginated:  string = CrmAutoBaseURL + '/ReadAllPaginated';
export const Workflow_Publish = CrmAutoBaseURL + '/Publish';

// ============================================================
//  AUTOMATION — WORKFLOW VERSION  — /CRM/WF/Version
// ============================================================
export const WorkflowVersion_ReadAll:           string = CrmAutoBaseURL + '/Version/ReadAll';
export const WorkflowVersion_ReadAllPaginated:  string = CrmAutoBaseURL + '/Version/ReadAllPaginated';


// ============================================================
//  AUTOMATION — TRIGGER  — /CRM/TRG
// ============================================================
export const Trigger_Create:            string = CrmTriggerBaseURL + '/Create';
export const Trigger_Update:            string = CrmTriggerBaseURL + '/Update';
export const Trigger_Delete:            string = CrmTriggerBaseURL + '/Delete';
export const Trigger_ReadAll:           string = CrmTriggerBaseURL + '/ReadAll';
export const Trigger_ReadAllPaginated:  string = CrmTriggerBaseURL + '/ReadAllPaginated';


// ============================================================
//  AUTOMATION — CONDITION  — /CRM/WF/Condition
// // ============================================================
// export const Condition_Create:            string = CrmAutoBaseURL + '/Create';
// export const Condition_Update:            string = CrmAutoBaseURL + '/Update';
// export const Condition_Delete:            string = CrmAutoBaseURL + '/Delete';
// export const Condition_ReadAll:           string = CrmAutoBaseURL + '/ReadAll';
// export const Condition_ReadAllPaginated:  string = CrmAutoBaseURL + '/ReadAllPaginated';

export const Condition_Create:            string = CrmConditionBaseURL + '/Create';
export const Condition_Update:            string = CrmConditionBaseURL + '/Update';
export const Condition_Delete:            string = CrmConditionBaseURL + '/Delete';
export const Condition_ReadAll:           string = CrmConditionBaseURL + '/ReadAll';
export const Condition_ReadAllPaginated:  string = CrmConditionBaseURL + '/ReadAllPaginated';


// ============================================================
//  AUTOMATION — ACTION  — /CRM/WF/Action
// ============================================================
// export const Action_Create:            string = CrmAutoBaseURL + '/Create';
// export const Action_Update:            string = CrmAutoBaseURL + '/Update';
// export const Action_Delete:            string = CrmAutoBaseURL + '/Delete';
// export const Action_ReadAll:           string = CrmAutoBaseURL + '/ReadAll';
// export const Action_ReadAllPaginated:  string = CrmAutoBaseURL + '/ReadAllPaginated';
export const Action_Create:            string = CrmActionBaseURL + '/Create';
export const Action_Update:            string = CrmActionBaseURL + '/Update';
export const Action_Delete:            string = CrmActionBaseURL + '/Delete';
export const Action_ReadAll:           string = CrmActionBaseURL + '/ReadAll';
export const Action_ReadAllPaginated:  string = CrmActionBaseURL + '/ReadAllPaginated';


// ============================================================
//  AUTOMATION — SLA RULES  — /CRM/WF/SLA
// ============================================================
export const SLA_Create:            string = CrmSLAURL + '/Create';
export const SLA_Update:            string = CrmSLAURL + '/Update';
export const SLA_Delete:            string = CrmSLAURL + '/Delete';
export const SLA_ReadAll:           string = CrmSLAURL + '/ReadAll';
export const SLA_ReadAllPaginated:  string = CrmSLAURL + '/ReadAllPaginated';


// ============================================================
//  AUTOMATION — SLA INSTANCES  — /CRM/WF/SLAInstance
// ============================================================
export const SLAInstance_Update:            string = CrmSLAI + '/Update';
export const SLAInstance_ReadAll:           string = CrmSLAI + '/ReadAll';
export const SLAInstance_ReadAllPaginated:  string = CrmSLAI + '/ReadAllPaginated';


// ============================================================
//  AUTOMATION — EXECUTIONS  — /CRM/WF/Execution
// ============================================================
export const Execution_ReadAll:           string = CrmAutoBaseURL + '/ReadAll';
export const Execution_ReadAllPaginated:  string = CrmAutoBaseURL + '/ReadAllPaginated';


// ============================================================
//  AUTOMATION — SCHEDULED ACTIONS  — /CRM/WF/ScheduledAction
// ============================================================
// export const ScheduledAction_Update:            string = CrmAutoBaseURL + '/Update';
// export const ScheduledAction_ReadAll:           string = CrmAutoBaseURL + '/ReadAll';
// export const ScheduledAction_ReadAllPaginated:  string = CrmAutoBaseURL + '/ReadAllPaginated';
export const ScheduledAction_Update:            string = CrmScheduledActionBaseURL + '/Update';
export const ScheduledAction_ReadAll:           string = CrmScheduledActionBaseURL + '/ReadAll';
export const ScheduledAction_ReadAllPaginated:  string = CrmScheduledActionBaseURL + '/ReadAllPaginated';


// ============================================================
//  QUOTATION MASTER  —  /CRM/QM
// ============================================================
export const Quotation_Create:            string = CrmQuotationBaseURL + '/Create';
export const Quotation_Update:            string = CrmQuotationBaseURL + '/Update';
export const Quotation_Delete:            string = CrmQuotationBaseURL + '/Delete';
export const Quotation_ReadById:          string = CrmQuotationBaseURL + '/ReadById';
export const Quotation_ReadAll:           string = CrmQuotationBaseURL + '/ReadAll';
export const Quotation_ReadAllPaginated:  string = CrmQuotationBaseURL + '/ReadAllPaginated';

//  QUOTATION DETAIL  —  /CRM/QD
export const QuotationDetail_Create:           string = CrmQuotationDetailBaseURL + '/Create';
export const QuotationDetail_Update:           string = CrmQuotationDetailBaseURL + '/Update';
export const QuotationDetail_Delete:           string = CrmQuotationDetailBaseURL + '/Delete';
export const QuotationDetail_ReadById:         string = CrmQuotationDetailBaseURL + '/ReadById';
export const QuotationDetail_ReadAll:          string = CrmQuotationDetailBaseURL + '/ReadAll';
export const QuotationDetail_ReadAllPaginated: string = CrmQuotationDetailBaseURL + '/ReadAllPaginated';


//  QUOTATION OTHER CHARGES  —  /CRM/QOC

export const QuotationOtherCharges_Create:           string = CrmQuotationOtherChargesBaseURL + '/Create';
export const QuotationOtherCharges_Update:           string = CrmQuotationOtherChargesBaseURL + '/Update';
export const QuotationOtherCharges_Delete:           string = CrmQuotationOtherChargesBaseURL + '/Delete';
export const QuotationOtherCharges_ReadById:         string = CrmQuotationOtherChargesBaseURL + '/ReadById';
export const QuotationOtherCharges_ReadAll:          string = CrmQuotationOtherChargesBaseURL + '/ReadAll';
export const QuotationOtherCharges_ReadAllPaginated: string = CrmQuotationOtherChargesBaseURL + '/ReadAllPaginated';
// ============================================================
//  REFERRAL  — /CRM/REF
// ============================================================
export const Referral_ReadAll:                    string = CrmReferralBaseURL + '/ReadAll';
export const Referral_ReadAllPaginated:           string = CrmReferralBaseURL + '/ReadAllPaginated';
export const ReferralConversion_ReadAllPaginated: string = CrmReferralBaseURL + '/Conversion/ReadAllPaginated';
export const ReferralDispute_ReadAllPaginated:    string = CrmReferralBaseURL + '/Dispute/ReadAllPaginated';
export const ReferralTouchpoint_ReadAllPaginated: string = CrmReferralBaseURL + '/Touchpoint/ReadAllPaginated';

// ============================================================
//  FOLLOW-UP — AI CUSTOMER REPLY REVIEW
//
//  IMPORTANT:
//  These are HUMAN-APPROVAL APIs.
//  Angular must NEVER call the inbound webhook directly.
// ============================================================

export const FollowUp_AIReview_ReadAllPaginated: string = CrmFollowUpBaseURL + '/AIReview/ReadAllPaginated';
export const FollowUp_AIReview_ReadById: string = CrmFollowUpBaseURL + '/AIReview/ReadById';
export const FollowUp_AIReview_ApproveTask: string = CrmFollowUpBaseURL + '/AIReview/ApproveTask';
export const FollowUp_AIReview_ApproveReplyAndSend: string = CrmFollowUpBaseURL + '/AIReview/ApproveReplyAndSend';
export const FollowUp_AIReview_Reject: string = CrmFollowUpBaseURL + '/AIReview/Reject';


//#endregion

//#region HospitalConsentMaster API

export const HospitalConsentMasterURL: string = HospitalBaseURL + "/HCM";
export const HospitalConsentMaster_Create: string = HospitalConsentMasterURL + "/Create";
export const HospitalConsentMaster_Update: string = HospitalConsentMasterURL + "/Update";
export const HospitalConsentMaster_Delete: string = HospitalConsentMasterURL + "/Delete";
export const HospitalConsentMaster_ReadById: string = HospitalConsentMasterURL + "/ReadById";
export const HospitalConsentMaster_ReadByHospitalId: string = HospitalConsentMasterURL + "/ReadByHospitalId";

//#region HospitalConsentDetail API

export const HospitalConsentDetailURL: string = HospitalBaseURL + "/HCD";
export const HospitalConsentDetail_Create: string = HospitalConsentDetailURL + "/Create";
export const HospitalConsentDetail_Update: string = HospitalConsentDetailURL + "/Update";
export const HospitalConsentDetail_Delete: string = HospitalConsentDetailURL + "/Delete";
export const HospitalConsentDetail_ReadById: string = HospitalConsentDetailURL + "/ReadById";
export const HospitalConsentDetail_ReadByConsentId: string = HospitalConsentDetailURL + "/ReadByConsentId";

//#endregion
export const TreatmentDischargeURL: string =
  HospitalBaseURL + "/TD";

export const TreatmentDischarge_Create: string =
  TreatmentDischargeURL + "/Create";

export const TreatmentDischarge_Update: string =
  TreatmentDischargeURL + "/Update";

export const TreatmentDischarge_ReadByPlanId: string =
  TreatmentDischargeURL + "/ReadByPlanId";

//#endregion





